{
  "version": 1,
  "integrations": [
    {
      "category": "Marketing",
      "subcategory": "Analytics & attribution",
      "id": "windsor-ai",
      "name": "Windsor.ai",
      "description": "Connect Meta Ads, Google Ads, TikTok Ads, LinkedIn Ads + 320 more",
      "url": "https://mcp.windsor.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Windsor.ai",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P0",
      "logo": "windsor-ai.svg",
      "sourceUrl": "https://claude.ai/directory/360c0c31-4bb6-42ca-8e50-5da0a100a68e",
      "publisherUrl": "https://windsor.ai/"
    },
    {
      "category": "Marketing",
      "subcategory": "Analytics & attribution",
      "id": "supermetrics",
      "name": "Supermetrics Marketing Analytics",
      "description": "Google Ads, Facebook Ads, Google Analytics, TikTok, LinkedIn, Instagram, YouTube & 200+ sources",
      "url": "https://mcp.supermetrics.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Supermetrics",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P0",
      "logo": "supermetrics.svg",
      "sourceUrl": "https://claude.ai/directory/cc599e7b-8c59-4e89-9bf0-36d47bb9ec80",
      "publisherUrl": "https://supermetrics.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Analytics & attribution",
      "id": "amplitude",
      "name": "Amplitude",
      "description": "Search, access, and get insights on your Amplitude data",
      "url": "https://mcp.amplitude.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Amplitude",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "amplitude.svg",
      "sourceUrl": "https://claude.ai/directory/8e40fa13-4654-4387-bbad-12b8ecc81351",
      "publisherUrl": "https://amplitude.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Analytics & attribution",
      "id": "metricool-social-media-management",
      "name": "Metricool Social Media Management",
      "description": "Schedule posts, analyze, and manage social media with AI",
      "url": "https://ai.metricool.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Metricool",
      "tags": [
        "commerce-shopping",
        "communication",
        "data-analytics",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P1",
      "logo": "metricool-social-media-management.svg",
      "sourceUrl": "https://claude.ai/directory/70ba6d62-7e98-4ef4-9073-d161d900a95f",
      "publisherUrl": "https://metricool.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Analytics & attribution",
      "id": "motion",
      "name": "Motion Creative Analytics",
      "description": "Analyze your Meta ad creative & competitor ad libraries",
      "url": "https://projects.motionapp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Motion Creative Analytics",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "motion.svg",
      "sourceUrl": "https://claude.ai/directory/47b0738c-d713-47a5-8141-ca455a6e1bf2",
      "publisherUrl": "https://motionapp.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Automation",
      "id": "zapier",
      "name": "Zapier",
      "description": "Automate workflows across thousands of apps via conversation",
      "url": "https://mcp.zapier.com/api/v1/connect",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zapier",
      "tags": [
        "communication",
        "data-analytics",
        "developer-tools",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P0",
      "logo": "zapier.svg",
      "sourceUrl": "https://claude.ai/directory/1f6f271e-3d29-4241-b35e-8abe6def4891",
      "publisherUrl": "https://zapier.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Automation",
      "id": "make",
      "name": "Make",
      "description": "Run Make scenarios and manage your Make account",
      "url": "https://mcp.make.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Make",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "make.svg",
      "sourceUrl": "https://claude.ai/directory/038318ff-ed0d-45f8-a453-b01de0071561",
      "publisherUrl": "https://www.make.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Automation",
      "id": "ifttt",
      "name": "IFTTT",
      "description": "Connect, control, and automate 1,000+ apps with IFTTT",
      "url": "https://ifttt.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "IFTTT, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "ifttt.svg",
      "sourceUrl": "https://claude.ai/directory/a0ea0811-dabc-4b51-903a-d762fec4afcb",
      "publisherUrl": "https://ifttt.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "shopify",
      "name": "Shopify",
      "description": "Build, manage, and analyze your Shopify store",
      "url": "https://setup.shopify.com/mcp",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Store access requires a separate sign-in and authorization flow that has not been verified in Maito.",
      "publisher": "Shopify",
      "tags": ["commerce-shopping", "productivity", "sales-and-marketing"],
      "priority": "P0",
      "logo": "shopify.svg",
      "sourceUrl": "https://claude.ai/directory/80917cb7-3071-4fca-b053-a4262d356c60",
      "publisherUrl": "https://www.shopify.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "helium-10",
      "name": "Helium 10",
      "description": "Access your Helium 10 data directly in Claude",
      "url": "https://mcp.helium10.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Helium 10",
      "tags": ["commerce-shopping", "data-analytics", "sales-and-marketing"],
      "priority": "P2",
      "logo": "helium-10.svg",
      "sourceUrl": "https://claude.ai/directory/e336ede2-5687-4590-a60b-12c3ab56fc63",
      "publisherUrl": "https://www.helium10.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "shippo",
      "name": "Shippo",
      "description": "Multi-carrier shipping, from a single package to high volume: compare live rates across USPS, UPS, FedEx, DHL, and 40+ carriers, then buy labels, validate addresses, and track packages.",
      "url": "https://mcp.shippo.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Shippo",
      "tags": ["commerce-shopping", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "shippo.svg",
      "sourceUrl": "https://claude.ai/directory/983c8e05-8485-481c-b9b6-c25b291331ce",
      "publisherUrl": "https://shippo.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "shipbob",
      "name": "ShipBob",
      "description": "Your orders, inventory, and shipments from any prompt",
      "url": "https://api.shipbob.com/developer-api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ShipBob",
      "tags": ["commerce-shopping"],
      "priority": "P2",
      "logo": "shipbob.svg",
      "sourceUrl": "https://claude.ai/directory/b5a11013-f123-42e1-b553-1caa40c95477",
      "publisherUrl": "https://www.shipbob.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "jobber",
      "name": "Jobber",
      "description": "Get answers and take action with context from your Jobber account",
      "url": "https://mcp.getjobber.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Jobber",
      "tags": ["communication", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "jobber.svg",
      "sourceUrl": "https://claude.ai/directory/d53b3c4b-c4c7-4886-8698-786cfaff70f2",
      "publisherUrl": "https://www.getjobber.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "terminal49",
      "name": "Terminal49",
      "description": "Track ocean shipments and containers",
      "url": "https://mcp.terminal49.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Terminal49, Inc.",
      "tags": ["commerce-shopping", "data-analytics", "other"],
      "priority": "P2",
      "logo": "terminal49.svg",
      "sourceUrl": "https://claude.ai/directory/e976edae-40c4-4c29-a1f8-6d5b40bc7cee",
      "publisherUrl": "https://terminal49.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "amazon-selling-partner",
      "name": "Amazon Selling Partner",
      "description": "Amazon Selling Partner MCP",
      "url": "https://sellingpartner-ai.amazon.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Amazon",
      "tags": ["commerce-shopping", "data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "amazon-selling-partner.svg",
      "sourceUrl": "https://claude.ai/directory/921c3435-ce00-4c0b-8809-4647b3cb108f",
      "publisherUrl": "https://sellercentral.amazon.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "canva",
      "name": "Canva",
      "description": "Search, create, autofill, and export Canva designs",
      "url": "https://mcp.canva.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Canva",
      "tags": ["creative", "education"],
      "priority": "P0",
      "logo": "canva.svg",
      "sourceUrl": "https://claude.ai/directory/eb9240f2-e1c1-43c1-828f-0fda40c22e4c",
      "publisherUrl": "https://canva.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "gamma",
      "name": "Gamma",
      "description": "Create presentations, docs, socials, and sites with AI",
      "url": "https://mcp.gamma.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gamma",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P0",
      "logo": "gamma.svg",
      "sourceUrl": "https://claude.ai/directory/ba1eef5a-c510-416e-b5fa-c34d523d81a1",
      "publisherUrl": "https://gamma.app/about"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "vidiq",
      "name": "vidIQ",
      "description": "Research and create for YouTube, Instagram & TikTok",
      "url": "https://mcp.vidiq.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "vidIQ",
      "tags": ["creative", "data-analytics", "media-entertainment"],
      "priority": "P1",
      "logo": "vidiq.svg",
      "sourceUrl": "https://claude.ai/directory/dc5bb20f-6ebd-4dbe-a47e-c2d20fa25acc",
      "publisherUrl": "https://vidiq.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "webflow",
      "name": "Webflow",
      "description": "Design pages, manage CMS content, add motion, analyze traffic, and launch the whole site, all from a prompt and all inside the permissions your workspace already has.",
      "url": "https://mcp.webflow.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Webflow",
      "tags": ["creative", "developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "webflow.svg",
      "sourceUrl": "https://claude.ai/directory/092d0ef3-9fc6-4101-8f7e-c2b80e58a065",
      "publisherUrl": "https://webflow.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "hyperframes",
      "name": "HyperFrames by HeyGen",
      "description": "Build animated slides and motion graphics with HTML",
      "url": "https://mcp.heygen.com/mcp/hyperframes",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "HeyGen Technologies",
      "tags": ["creative", "productivity"],
      "priority": "P1",
      "logo": "hyperframes.svg",
      "sourceUrl": "https://claude.ai/directory/275b944b-60a0-4f0d-9e55-0c0e5927a5c7",
      "publisherUrl": "https://www.heygen.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "wix",
      "name": "Wix",
      "description": "Manage and build sites and apps on Wix",
      "url": "https://mcp.wix.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wix",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "wix.svg",
      "sourceUrl": "https://claude.ai/directory/780a3621-8271-4822-bd0b-b9cab309375d",
      "publisherUrl": "https://www.wix.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "descript",
      "name": "Descript",
      "description": "Import, edit, or create video with prompts",
      "url": "https://api.descript.com/v2/mcp/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Descript",
      "tags": ["creative", "productivity"],
      "priority": "P1",
      "logo": "descript.svg",
      "sourceUrl": "https://claude.ai/directory/adcb61d5-8738-4724-a8e9-9cca7d525c3c",
      "publisherUrl": "https://descript.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "elevenlabs",
      "name": "ElevenLabs",
      "description": "Manage your ElevenAgents voice agents in your chat",
      "url": "https://api.elevenlabs.io/v1/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "ElevenLabs",
      "tags": [
        "creative",
        "developer-tools",
        "media-entertainment",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P1",
      "logo": "elevenlabs.svg",
      "sourceUrl": "https://claude.ai/directory/4a542638-16d2-4bd1-9937-efa473d3f2f0",
      "publisherUrl": "https://elevenlabs.io/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "opusclip",
      "name": "OpusClip",
      "description": "Turn long videos into edited social clips, captions, and scheduled posts.",
      "url": "https://mcp.opus.pro/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "OpusClip",
      "tags": ["creative", "media-entertainment", "sales-and-marketing"],
      "priority": "P1",
      "logo": "opusclip.svg",
      "sourceUrl": "https://www.opus.pro/mcp",
      "publisherUrl": "https://www.opus.pro/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "tella",
      "name": "Tella",
      "description": "Edit, export, organize, and publish videos with agent-driven workflows.",
      "url": "https://api.tella.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tella",
      "tags": ["creative", "media-entertainment", "sales-and-marketing"],
      "priority": "P2",
      "logo": "tella.svg",
      "sourceUrl": "https://www.tella.com/mcp",
      "publisherUrl": "https://www.tella.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "intuit-mailchimp",
      "name": "Intuit Mailchimp",
      "description": "Create marketing campaigns",
      "url": "https://ai-inc.mailchimp.com/claude/mcp/v2",
      "oneClick": false,
      "limitation": "OAuth metadata fails strict issuer validation and cannot complete Maito's one-click flow.",
      "publisher": "Intuit Mailchimp",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "intuit-mailchimp.svg",
      "sourceUrl": "https://claude.ai/directory/3a7fa2ac-d655-4479-bce3-8e10fcc26f96",
      "publisherUrl": "https://mailchimp.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "surveymonkey",
      "name": "SurveyMonkey",
      "description": "Design surveys, collect responses, and analyze results",
      "url": "https://mcp.surveymonkey.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "SurveyMonkey",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "surveymonkey.svg",
      "sourceUrl": "https://claude.ai/directory/58ff478e-b9b7-47c9-8253-78fb9364513a",
      "publisherUrl": "https://www.surveymonkey.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "beehiiv",
      "name": "beehiiv",
      "description": "Manage newsletter content, audience segments, automations, surveys, and performance data.",
      "url": "https://mcp.beehiiv.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "beehiiv",
      "tags": ["sales-and-marketing", "communication", "data-analytics"],
      "priority": "P1",
      "logo": "beehiiv.svg",
      "sourceUrl": "https://www.beehiiv.com/features/mcp/getting-started",
      "publisherUrl": "https://www.beehiiv.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "loops",
      "name": "Loops",
      "description": "Manage contacts, mailing lists, events, workflows, campaigns, and transactional email.",
      "url": "https://mcp.loops.so",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Loops",
      "tags": ["sales-and-marketing", "communication", "productivity"],
      "priority": "P0",
      "logo": "loops.svg",
      "sourceUrl": "https://loops.so/agents/mcp",
      "publisherUrl": "https://loops.so/"
    },
    {
      "category": "Marketing",
      "subcategory": "SEO & market intelligence",
      "id": "semrush",
      "name": "Semrush",
      "description": "SEO, keyword research, competitor analysis, traffic and market analytics, backlink analysis, domain analysis, and PPC",
      "url": "https://mcp.semrush.com/claude/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Semrush Holdings, Inc.",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P0",
      "logo": "semrush.svg",
      "sourceUrl": "https://claude.ai/directory/8194f7ea-e733-4e80-bd77-e504fd4ed5e5",
      "publisherUrl": "https://www.semrush.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "SEO & market intelligence",
      "id": "ahrefs",
      "name": "Ahrefs",
      "description": "SEO & AI search analytics",
      "url": "https://api.ahrefs.com/mcp/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ahrefs Pte. Ltd.",
      "tags": ["communication", "data-analytics", "sales-and-marketing"],
      "priority": "P1",
      "logo": "ahrefs.svg",
      "sourceUrl": "https://claude.ai/directory/098cb32a-ba21-4770-97dd-78bb54655419",
      "publisherUrl": "https://ahrefs.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "SEO & market intelligence",
      "id": "dataforseo",
      "name": "DataForSEO",
      "description": "Access live SERP, keyword, backlink, on-page, business, and domain analytics data.",
      "url": "https://mcp.dataforseo.com/v3/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "DataForSEO",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P0",
      "logo": "dataforseo.svg",
      "sourceUrl": "https://dataforseo.com/seo-mcp-server",
      "publisherUrl": "https://dataforseo.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "SEO & market intelligence",
      "id": "similarweb",
      "name": "Similarweb",
      "description": "Real time web, mobile app, and market data.",
      "url": "https://mcp.similarweb.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Similarweb",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "similarweb.svg",
      "sourceUrl": "https://claude.ai/directory/80862d08-1022-4d86-816d-ee9b500d6b90",
      "publisherUrl": "https://similarweb.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "SEO & market intelligence",
      "id": "g2",
      "name": "G2",
      "description": "Bring real buyer signals into AI workflows",
      "url": "https://mcp.g2.com/mcp",
      "oneClick": false,
      "limitation": "OAuth metadata fails strict issuer validation and cannot complete Maito's one-click flow.",
      "publisher": "G2",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "g2.svg",
      "sourceUrl": "https://claude.ai/directory/df731661-86d2-48e9-ac51-bdeceb265948",
      "publisherUrl": "https://g2.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social advertising",
      "id": "adwhispr",
      "name": "AdWhispr",
      "description": "Research competitor ads, clone creative, and launch campaigns on Meta, Google, and TikTok.",
      "url": "https://adwhispr.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AdWhispr",
      "tags": ["sales-and-marketing", "creative", "data-analytics"],
      "priority": "P1",
      "logo": "adwhispr.svg",
      "sourceUrl": "https://adwhispr.com/how-to/connect-adwhispr-to-cursor",
      "publisherUrl": "https://adwhispr.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social listening & intelligence",
      "id": "brand24",
      "name": "Brand24",
      "description": "Analyze live brand mentions, sentiment, discussions, sources, and influencers.",
      "url": "https://mcp.brand24.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Brand24",
      "tags": ["sales-and-marketing", "data-analytics"],
      "priority": "P1",
      "logo": "brand24.svg",
      "sourceUrl": "https://help.brand24.com/en/articles/13011375-brand24-mcp",
      "publisherUrl": "https://brand24.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social listening & intelligence",
      "id": "meltwater",
      "name": "Meltwater",
      "description": "Access saved searches, media and social mentions, analytics, and intelligence.",
      "url": "https://api.meltwater.com/v2/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Meltwater",
      "tags": ["sales-and-marketing", "data-analytics"],
      "priority": "P1",
      "logo": "meltwater.svg",
      "sourceUrl": "https://developer.meltwater.com/guides/meltwater-mcp/overview/",
      "publisherUrl": "https://www.meltwater.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social listening & intelligence",
      "id": "hootsuite-lumen",
      "name": "Hootsuite Lumen",
      "description": "Track mentions and sentiment, find influencers, and summarize competitive intelligence.",
      "url": "https://mcp.hootsuite.com/lumen",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hootsuite",
      "tags": ["sales-and-marketing", "data-analytics", "communication"],
      "priority": "P1",
      "logo": "hootsuite-lumen.svg",
      "sourceUrl": "https://www.hootsuite.com/integrations/mcp",
      "publisherUrl": "https://www.hootsuite.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "zernio",
      "name": "Zernio",
      "description": "Create and schedule posts, upload media, manage inboxes and ads, and read social analytics.",
      "url": "https://mcp.zernio.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zernio",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P0",
      "logo": "zernio.svg",
      "sourceUrl": "https://docs.zernio.com/mcp",
      "publisherUrl": "https://zernio.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "postiz",
      "name": "Postiz",
      "description": "Schedule and publish posts, manage channels and media, and read analytics across 30+ social platforms.",
      "url": "https://mcp.postiz.com/mcp-oauth-dynamic",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Postiz",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P0",
      "logo": "postiz.svg",
      "sourceUrl": "https://postiz.com/mcp",
      "publisherUrl": "https://postiz.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "typefully",
      "name": "Typefully",
      "description": "Create, edit, schedule, and analyze social posts across X, LinkedIn, Threads, Bluesky, and Mastodon.",
      "url": "https://mcp.typefully.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Typefully",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P0",
      "logo": "typefully.svg",
      "sourceUrl": "https://support.typefully.com/en/articles/13128440-typefully-mcp-server",
      "publisherUrl": "https://typefully.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "hootsuite-perch",
      "name": "Hootsuite Perch",
      "description": "Create, plan, schedule, publish, and review social content.",
      "url": "https://mcp.hootsuite.com/perch",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hootsuite",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P0",
      "logo": "hootsuite-perch.svg",
      "sourceUrl": "https://www.hootsuite.com/integrations/mcp",
      "publisherUrl": "https://www.hootsuite.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "hootsuite-nest",
      "name": "Hootsuite Nest",
      "description": "Triage social inboxes, assign conversations, reply, and resolve customer-care items.",
      "url": "https://mcp.hootsuite.com/nest",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hootsuite",
      "tags": ["sales-and-marketing", "communication", "customer-support"],
      "priority": "P1",
      "logo": "hootsuite-nest.svg",
      "sourceUrl": "https://www.hootsuite.com/integrations/mcp",
      "publisherUrl": "https://www.hootsuite.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "hootsuite-parliament",
      "name": "Hootsuite Parliament",
      "description": "Find shareable content and schedule employee-advocacy posts.",
      "url": "https://mcp.hootsuite.com/parliament",
      "oneClick": false,
      "limitation": "The endpoint requests a bearer credential without compatible OAuth metadata; it needs a dedicated authentication preset.",
      "publisher": "Hootsuite",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P2",
      "logo": "hootsuite-parliament.svg",
      "sourceUrl": "https://www.hootsuite.com/integrations/mcp",
      "publisherUrl": "https://www.hootsuite.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "postproxy",
      "name": "Postproxy",
      "description": "Publish and schedule posts, manage queues, and handle comments and direct messages across social networks.",
      "url": "https://mcp.postproxy.dev/mcp",
      "auth": "header",
      "oneClick": false,
      "limitation": "Requires an API key; the remote authentication setup has not been verified in Maito.",
      "publisher": "Postproxy",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P1",
      "logo": "postproxy.svg",
      "sourceUrl": "https://postproxy.dev/automation/mcp/",
      "publisherUrl": "https://postproxy.dev/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "ayrshare",
      "name": "Ayrshare",
      "description": "Publish, schedule, validate, analyze, and manage engagement across 14+ social networks.",
      "url": "https://api.ayrshare.com/mcp",
      "auth": "header",
      "oneClick": true,
      "publisher": "Ayrshare",
      "tags": ["sales-and-marketing", "communication", "data-analytics"],
      "priority": "P1",
      "logo": "ayrshare.svg",
      "sourceUrl": "https://www.ayrshare.com/ai-agent/",
      "publisherUrl": "https://www.ayrshare.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "socialrobot",
      "name": "SocialRobot",
      "description": "Schedule and manage posts across Instagram, LinkedIn, X, TikTok, Pinterest, Threads, Facebook, Bluesky, and Mastodon.",
      "url": "https://socialrobot.io/api/mcp",
      "auth": "header",
      "oneClick": false,
      "limitation": "Requires OAuth or a bearer API key; the account connection has not been verified in Maito.",
      "publisher": "SocialRobot",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P2",
      "logo": "socialrobot.svg",
      "sourceUrl": "https://socialrobot.io/developers",
      "publisherUrl": "https://socialrobot.io/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social media management",
      "id": "schedule-and-chill",
      "name": "Schedule & Chill",
      "description": "Schedule posts, browse media, and read the publishing queue.",
      "url": "https://schedulenchill.com/mcp-oauth",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Schedule & Chill",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P2",
      "logo": "schedule-and-chill.svg",
      "sourceUrl": "https://schedulenchill.com/help/developers/mcp",
      "publisherUrl": "https://schedulenchill.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Web operations",
      "id": "godaddy",
      "name": "GoDaddy",
      "description": "Search domains and check availability",
      "url": "https://api.godaddy.com/v1/domains/mcp",
      "oneClick": false,
      "limitation": "The MCP endpoint did not complete the compatibility probe and needs provider-live verification.",
      "publisher": "GoDaddy",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "godaddy.svg",
      "sourceUrl": "https://claude.ai/directory/a1d0551d-c567-4975-91fc-7ced9e819421",
      "publisherUrl": "https://www.godaddy.com/"
    },
    {
      "category": "Product",
      "subcategory": "Automation & APIs",
      "id": "celigo",
      "name": "Celigo",
      "description": "Build and manage automations across hundreds of apps",
      "url": "https://api.integrator.io/celigo-mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Celigo",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "celigo.svg",
      "sourceUrl": "https://claude.ai/directory/3386d7b4-82b0-4c72-b634-2b080d191fa7",
      "publisherUrl": "https://www.celigo.com/"
    },
    {
      "category": "Product",
      "subcategory": "Automation & APIs",
      "id": "mulesoft",
      "name": "MuleSoft",
      "description": "Govern, manage, and observe your entire Agent ecosystem",
      "url": "https://omni.mulesoft.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "MuleSoft",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "mulesoft.svg",
      "sourceUrl": "https://claude.ai/directory/a847d0cb-319e-4c0a-a70d-5278ee7e5f13",
      "publisherUrl": "https://www.mulesoft.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "slack",
      "name": "Slack",
      "description": "Search channels, send messages, manage canvases, users, files, and lists.",
      "url": "https://mcp.slack.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Slack",
      "tags": [],
      "priority": "P0",
      "logo": "slack.svg",
      "sourceUrl": "https://docs.slack.dev/ai/slack-mcp-server",
      "publisherUrl": "https://slack.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "microsoft-365",
      "name": "Microsoft 365",
      "description": "Access your company's SharePoint, OneDrive, Outlook, and Teams directly in Claude",
      "url": "https://microsoft365.mcp.claude.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["communication", "productivity"],
      "priority": "P0",
      "logo": "microsoft-365.svg",
      "sourceUrl": "https://claude.ai/directory/ce0c9cda-5ea5-44c5-9cf2-40810dfa6582",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "zoom-for-claude",
      "name": "Zoom for Claude",
      "description": "Search, recap, and act on your Zoom meetings",
      "url": "https://mcp.zoom.us/mcp/zoom/streamable",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Zoom",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "zoom-for-claude.svg",
      "sourceUrl": "https://claude.ai/directory/1ed68a66-c371-4d26-82dc-28e6c260ece8",
      "publisherUrl": "https://zoom.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "granola",
      "name": "Granola",
      "description": "The AI notepad for meetings",
      "url": "https://mcp.granola.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Granola",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "granola.svg",
      "sourceUrl": "https://claude.ai/directory/4d608ca4-1664-4ddd-be1c-c88c0ea2ec7e",
      "publisherUrl": "https://www.granola.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "fireflies",
      "name": "Fireflies",
      "description": "Analyze and generate insights from meeting transcripts",
      "url": "https://api.fireflies.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fireflies AI Corp",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "fireflies.svg",
      "sourceUrl": "https://claude.ai/directory/839a0ae2-0c0f-4c27-9f85-726ed6515536",
      "publisherUrl": "https://fireflies.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "fathom",
      "name": "Fathom – Your Meeting Intelligence Layer",
      "description": "Your meeting notes, transcripts, and context – now part of every Claude conversation",
      "url": "https://api.fathom.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fathom",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "fathom.svg",
      "sourceUrl": "https://claude.ai/directory/954b8c86-38d8-431b-bdaf-85b14336989c",
      "publisherUrl": "https://fathom.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "plaud",
      "name": "Plaud",
      "description": "Search and extract insights from your Plaud recordings.",
      "url": "https://mcp.plaud.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Plaud",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "plaud.svg",
      "sourceUrl": "https://claude.ai/directory/33b42d5b-de4e-43c6-ae45-135b15ec1791",
      "publisherUrl": "https://www.plaud.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "read-ai",
      "name": "Read AI",
      "description": "Bring your meetings into Claude",
      "url": "https://api.read.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Read AI",
      "tags": ["communication", "productivity"],
      "priority": "P1",
      "logo": "read-ai.svg",
      "sourceUrl": "https://claude.ai/directory/f232e067-e927-4095-927a-e0db5bc00ca6",
      "publisherUrl": "https://read.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "otter-ai",
      "name": "Otter.ai",
      "description": "Unlock your meeting intelligence",
      "url": "https://mcp.otter.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Otter.ai",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "otter-ai.svg",
      "sourceUrl": "https://claude.ai/directory/bb74915f-d284-4590-a208-ae06447b37af",
      "publisherUrl": "https://otter.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "intercom",
      "name": "Intercom",
      "description": "Access to Intercom data for better customer insights",
      "url": "https://mcp.intercom.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Intercom",
      "tags": ["communication"],
      "priority": "P0",
      "logo": "intercom.svg",
      "sourceUrl": "https://claude.ai/directory/b2def8dc-ae47-4d46-877a-19b6a6ebb771",
      "publisherUrl": "https://intercom.com/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "zoho-desk",
      "name": "Zoho Desk",
      "description": "Zoho Desk MCP for Customer Support Automation",
      "url": "https://claude-zohodesk.zohomcp.com/mcp/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "zoho-desk.svg",
      "sourceUrl": "https://claude.ai/directory/680aa72d-df6e-456f-b3c1-177f04b211c4",
      "publisherUrl": "https://www.zoho.com/mcp/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "pylon",
      "name": "Pylon",
      "description": "Search and manage Pylon support issues",
      "url": "https://mcp.usepylon.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pylon",
      "tags": ["communication"],
      "priority": "P2",
      "logo": "pylon.svg",
      "sourceUrl": "https://claude.ai/directory/240b8712-17ed-4233-858a-9a872dec63b2",
      "publisherUrl": "https://www.usepylon.com/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "gainsight-staircase-ai",
      "name": "Gainsight (Staircase AI)",
      "description": "Power AI Workflows with Customer Context",
      "url": "https://mcp.staircase.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gainsight",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "gainsight-staircase-ai.svg",
      "sourceUrl": "https://claude.ai/directory/7b4941fa-a8fa-4a00-a726-cf692ac269ca",
      "publisherUrl": "https://www.gainsight.com/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "unthread",
      "name": "Unthread",
      "description": "Manage and automate your support tickets",
      "url": "https://app.unthread.io/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Unthread",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "unthread.svg",
      "sourceUrl": "https://claude.ai/directory/9fcc5cc5-15fe-4144-bafb-239db7e9038d",
      "publisherUrl": "https://unthread.io/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "lorikeet",
      "name": "Lorikeet",
      "description": "A universal concierge for complex businesses",
      "url": "https://mcp.lorikeetcx.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lorikeet",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "lorikeet.svg",
      "sourceUrl": "https://claude.ai/directory/0ffe8735-4ad5-4e7b-99e3-c8fc25f51b52",
      "publisherUrl": "https://www.lorikeetcx.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "supabase",
      "name": "Supabase",
      "description": "Manage databases, authentication, and storage",
      "url": "https://mcp.supabase.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Supabase",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P0",
      "logo": "supabase.svg",
      "sourceUrl": "https://claude.ai/directory/11ca66fc-1e98-49d5-ab9b-7cb4672a8f10",
      "publisherUrl": "https://supabase.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "bigquery",
      "name": "Google Cloud BigQuery",
      "description": "BigQuery: Advanced analytical insights for agents",
      "url": "https://bigquery.googleapis.com/mcp",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Requires Google Cloud credentials and IAM permissions that the catalog setup does not collect.",
      "publisher": "Google",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "bigquery.svg",
      "sourceUrl": "https://claude.ai/directory/7c316b77-98a0-4dbb-8b54-a96ae26a884f",
      "publisherUrl": "https://google.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "tavily",
      "name": "Tavily",
      "description": "Connect your AI agents to the web",
      "url": "https://mcp.tavily.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tavily",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "tavily.svg",
      "sourceUrl": "https://claude.ai/directory/d8a25d2a-e5ea-4860-b990-277244df5417",
      "publisherUrl": "https://www.tavily.com/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "figma",
      "name": "Figma",
      "description": "Generate diagrams and better code from Figma context",
      "url": "https://mcp.figma.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Figma",
      "tags": ["creative"],
      "priority": "P0",
      "logo": "figma.svg",
      "sourceUrl": "https://claude.ai/directory/c758d038-d8eb-4421-b426-9dd68dc7f84a",
      "publisherUrl": "https://www.figma.com/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "miro",
      "name": "Miro",
      "description": "Access and create new content on Miro boards",
      "url": "https://mcp.miro.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Miro",
      "tags": [
        "communication",
        "creative",
        "developer-tools",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P0",
      "logo": "miro.svg",
      "sourceUrl": "https://claude.ai/directory/72480fb8-32ed-4075-b1c4-79e09c858b29",
      "publisherUrl": "https://miro.com/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "lucid",
      "name": "Lucid",
      "description": "Ideate, diagram, and align teams",
      "url": "https://mcp.lucid.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lucid Software",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "lucid.svg",
      "sourceUrl": "https://claude.ai/directory/0cce5c8c-7590-41d0-abbe-aa5c64961ac0",
      "publisherUrl": "https://lucid.co/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "excalidraw-app-demo",
      "name": "Excalidraw",
      "description": "MCP for creating interactive hand-drawn diagrams in Excalidraw",
      "url": "https://mcp.excalidraw.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Excalidraw",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "excalidraw-app-demo.svg",
      "sourceUrl": "https://claude.ai/directory/934bf25a-e0d1-43ff-a488-b2c5567ec956",
      "publisherUrl": "https://github.com/excalidraw"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "mermaid-chart",
      "name": "Mermaid Chart",
      "description": "Validates Mermaid syntax, renders diagrams as high-quality SVG, and displays them instantly in an interactive UI where users can preview, zoom, and iterate in real time.",
      "url": "https://chatgpt.mermaid.ai/anthropic/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Mermaid Chart Inc",
      "tags": ["creative", "productivity"],
      "priority": "P1",
      "logo": "mermaid-chart.svg",
      "sourceUrl": "https://claude.ai/directory/de1df83d-e8f5-4498-a1e7-246cb9df999f",
      "publisherUrl": "https://www.mermaidchart.com/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "mobbin",
      "name": "Mobbin",
      "description": "Find UI & UX design references",
      "url": "https://api.mobbin.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mobbin",
      "tags": ["creative", "developer-tools", "education", "other", "productivity"],
      "priority": "P1",
      "logo": "mobbin.svg",
      "sourceUrl": "https://claude.ai/directory/705ad993-53e3-4be6-b32c-cc9cff5225f6",
      "publisherUrl": "https://mobbin.com/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "tldraw",
      "name": "tldraw",
      "description": "Let Claude sketch, draw, and diagram with you",
      "url": "https://tldraw-mcp-app.tldraw.workers.dev/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "tldraw",
      "tags": ["creative", "productivity"],
      "priority": "P2",
      "logo": "tldraw.svg",
      "sourceUrl": "https://claude.ai/directory/02795770-2c02-42fe-888f-26769ca324a0",
      "publisherUrl": "https://www.tldraw.dev/"
    },
    {
      "category": "Product",
      "subcategory": "Design & prototyping",
      "id": "whimsical",
      "name": "Whimsical",
      "description": "Create flowcharts, mindmaps, wireframes and diagrams",
      "url": "https://mcp.whimsical.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Whimsical",
      "tags": ["creative", "productivity"],
      "priority": "P2",
      "logo": "whimsical.svg",
      "sourceUrl": "https://claude.ai/directory/9b75f9c6-c443-4b88-96ff-f33234d4f135",
      "publisherUrl": "https://whimsical.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "github",
      "name": "GitHub",
      "description": "Work with repositories, pull requests, issues, and GitHub Actions.",
      "url": "https://api.githubcopilot.com/mcp/",
      "auth": "header",
      "oneClick": true,
      "publisher": "GitHub",
      "tags": [],
      "priority": "P0",
      "logo": "github.svg",
      "sourceUrl": "https://docs.github.com/en/copilot/how-tos/provide-context/use-mcp-in-your-ide/extend-copilot-chat-with-mcp",
      "publisherUrl": "https://github.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "gitlab",
      "name": "GitLab",
      "description": "Work with GitLab projects, issues, merge requests, repositories, and CI/CD.",
      "url": "https://gitlab.com/api/v4/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GitLab",
      "tags": [],
      "priority": "P0",
      "logo": "gitlab.svg",
      "sourceUrl": "https://docs.gitlab.com/user/model_context_protocol/mcp_server/",
      "publisherUrl": "https://gitlab.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "lovable",
      "name": "Lovable",
      "description": "Build, iterate, inspect, and deploy Lovable apps",
      "url": "https://mcp.lovable.dev/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lovable",
      "tags": ["developer-tools", "productivity"],
      "priority": "P0",
      "logo": "lovable.svg",
      "sourceUrl": "https://claude.ai/directory/1d9dadfe-0a7d-4a47-af18-101ae0ae0efd",
      "publisherUrl": "https://www.lovable.dev/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "postman",
      "name": "Postman",
      "description": "Give API context to your coding agents",
      "url": "https://mcp.postman.com/minimal",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Postman, Inc.",
      "tags": ["developer-tools"],
      "priority": "P0",
      "logo": "postman.svg",
      "sourceUrl": "https://claude.ai/directory/b9049585-f39b-45e8-8626-6ca78d9d7d22",
      "publisherUrl": "https://www.postman.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "context7",
      "name": "Context7",
      "description": "Up-to-date docs for LLMs and AI code editors",
      "url": "https://mcp.context7.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Context7",
      "tags": ["developer-tools"],
      "priority": "P0",
      "logo": "context7.svg",
      "sourceUrl": "https://claude.ai/directory/37153cd7-b17c-470e-8b46-007e2859e0f3",
      "publisherUrl": "https://context7.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "hugging-face",
      "name": "Hugging Face",
      "description": "Access the Hugging Face Hub and thousands of Gradio Apps",
      "url": "https://huggingface.co/mcp?login&gradio=none",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hugging Face",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "hugging-face.svg",
      "sourceUrl": "https://claude.ai/directory/37ed56d5-9d61-4fd4-ad00-b9134c694296",
      "publisherUrl": "https://huggingface.co/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "replit",
      "name": "Replit",
      "description": "Turn ideas into apps and websites instantly",
      "url": "https://replit-mcp.com/anthropic/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Replit",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "replit.svg",
      "sourceUrl": "https://claude.ai/directory/b952bcd7-554a-460e-9c8a-a81074f9d430",
      "publisherUrl": "https://replit.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "base44",
      "name": "Base44",
      "description": "Build and manage Base44 apps",
      "url": "https://app.base44.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Base44",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "base44.svg",
      "sourceUrl": "https://claude.ai/directory/16ebc92d-b1db-473a-82ef-015426940c4c",
      "publisherUrl": "https://base44.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "resend",
      "name": "Resend",
      "description": "Email for developers. The best way to reach humans instead of spam folders. Deliver transactional and marketing emails at scale.",
      "url": "https://mcp.resend.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Resend",
      "tags": [
        "communication",
        "data-analytics",
        "developer-tools",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "resend.svg",
      "sourceUrl": "https://claude.ai/directory/b770b020-8081-435f-8e05-4bee9c2a8772",
      "publisherUrl": "https://resend.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "clerk",
      "name": "Clerk",
      "description": "Create and configure Clerk applications, manage users, set up production instances, and get SDK snippets.",
      "url": "https://mcp.clerk.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Clerk",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "clerk.svg",
      "sourceUrl": "https://clerk.com/docs/guides/ai/mcp/clerk-mcp-server",
      "publisherUrl": "https://clerk.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "twilio",
      "name": "Twilio",
      "description": "Build powerful communications and customer engagement",
      "url": "https://mcp.twilio.com/docs",
      "auth": "none",
      "oneClick": true,
      "publisher": "Twilio",
      "tags": ["communication"],
      "priority": "P2",
      "logo": "twilio.svg",
      "sourceUrl": "https://claude.ai/directory/0f28b719-ce6a-4597-83a6-ff5b2d5b17c5",
      "publisherUrl": "https://twilio.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "vercel",
      "name": "Vercel",
      "description": "Analyze, debug, and manage projects and deployments.",
      "url": "https://mcp.vercel.com/",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Account operations require OAuth; the catalog was classified from public tools and the sign-in flow needs verification.",
      "publisher": "Vercel",
      "tags": [],
      "priority": "P0",
      "logo": "vercel.svg",
      "sourceUrl": "https://vercel.com/docs/agent-resources/vercel-mcp",
      "publisherUrl": "https://vercel.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "sentry",
      "name": "Sentry",
      "description": "Search, query, and debug application errors and performance issues.",
      "url": "https://mcp.sentry.dev/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sentry",
      "tags": [],
      "priority": "P0",
      "logo": "sentry.svg",
      "sourceUrl": "https://docs.sentry.io/product/sentry-mcp/",
      "publisherUrl": "https://sentry.io/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "datadog",
      "name": "Datadog",
      "description": "Debug and resolve issues using Datadog telemetry",
      "url": "https://mcp.datadoghq.com/v1/mcp?toolsets=all,visualizations",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Datadog",
      "tags": ["developer-tools"],
      "priority": "P0",
      "logo": "datadog.svg",
      "sourceUrl": "https://claude.ai/directory/68268024-1a91-4316-a9e1-14ecb814cb18",
      "publisherUrl": "https://www.datadoghq.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "new-relic",
      "name": "New Relic",
      "description": "Investigate application errors, query telemetry, and analyze deployment impact.",
      "url": "https://mcp.newrelic.com/mcp/",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "The hosted server supports automatic OAuth registration, but account sign-in and tool access have not been verified in Maito. Use a custom MCP connection for now; EU and Japan accounts need their regional endpoint.",
      "publisher": "New Relic",
      "tags": ["developer-tools", "data-analytics"],
      "priority": "P1",
      "logo": "new-relic.svg",
      "sourceUrl": "https://docs.newrelic.com/docs/agentic-ai/mcp/setup/",
      "publisherUrl": "https://newrelic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "grafana",
      "name": "Grafana Cloud",
      "description": "Investigate issues using Grafana Cloud dashboards, logs, metrics, and traces.",
      "url": "https://mcp.grafana.com/mcp",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Requires Grafana Cloud with Grafana Assistant access. Automatic OAuth registration is supported, but account sign-in and tool access have not been verified in Maito. Self-hosted Grafana needs its separate open-source MCP server.",
      "publisher": "Grafana Labs",
      "tags": ["developer-tools", "data-analytics"],
      "priority": "P1",
      "logo": "grafana.svg",
      "sourceUrl": "https://grafana.com/docs/grafana-cloud/ai-tools/mcp-servers/cloud-mcp/",
      "publisherUrl": "https://grafana.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "honeycomb",
      "name": "Honeycomb",
      "description": "Query telemetry, inspect traces, and investigate latency and error spikes.",
      "url": "https://mcp.honeycomb.io/mcp",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Requires Honeycomb Intelligence access. Automatic OAuth registration is supported, but account sign-in and tool access have not been verified in Maito. EU accounts need the EU endpoint.",
      "publisher": "Honeycomb",
      "tags": ["developer-tools", "data-analytics"],
      "priority": "P1",
      "logo": "honeycomb.svg",
      "sourceUrl": "https://docs.honeycomb.io/integrations/mcp/",
      "publisherUrl": "https://www.honeycomb.io/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "betterstack",
      "name": "Better Stack",
      "description": "Investigate incidents and query logs and telemetry from Better Stack.",
      "url": "https://mcp.betterstack.com",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "The publisher documents OAuth and bearer-token access, but the live endpoint returned an access-denied response during verification. Account sign-in and tool access have not been verified in Maito.",
      "publisher": "Better Stack",
      "tags": ["developer-tools", "data-analytics"],
      "priority": "P1",
      "logo": "betterstack.svg",
      "sourceUrl": "https://betterstack.com/docs/getting-started/integrations/mcp/",
      "publisherUrl": "https://betterstack.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "cloudflare",
      "name": "Cloudflare Developer Platform",
      "description": "Build applications with compute, storage, and AI",
      "url": "https://bindings.mcp.cloudflare.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Cloudflare",
      "tags": ["developer-tools"],
      "priority": "P0",
      "logo": "cloudflare.svg",
      "sourceUrl": "https://claude.ai/directory/2d60210c-dd92-4be0-b09c-3662f10445c9",
      "publisherUrl": "https://cloudflare.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "netlify",
      "name": "Netlify",
      "description": "Create, deploy, manage, and secure websites on Netlify.",
      "url": "https://netlify-mcp.netlify.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Netlify",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "netlify.svg",
      "sourceUrl": "https://claude.ai/directory/816d73d2-2c34-4ad5-a1a3-c119c719e3af",
      "publisherUrl": "https://www.netlify.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "incident-io",
      "name": "incident.io",
      "description": "See and manage everything in incident.io",
      "url": "https://mcp.incident.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "incident.io",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "incident-io.svg",
      "sourceUrl": "https://claude.ai/directory/1f80285c-87b3-496f-91b3-07ea8fc86488",
      "publisherUrl": "https://incident.io/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "pagerduty",
      "name": "PagerDuty",
      "description": "Manage incidents, services and on-call schedules",
      "url": "https://mcp.pagerduty.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "PagerDuty",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "pagerduty.svg",
      "sourceUrl": "https://claude.ai/directory/fc41b5e5-97bc-4c80-af18-e3a9442b655b",
      "publisherUrl": "https://www.pagerduty.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "aws-marketplace",
      "name": "AWS Marketplace",
      "description": "Discover, evaluate, and buy solutions for the cloud",
      "url": "https://marketplace-mcp.us-east-1.api.aws/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "AWS Marketplace",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "aws-marketplace.svg",
      "sourceUrl": "https://claude.ai/directory/2ed43e1e-f547-48a3-85cc-b9baa412d06b",
      "publisherUrl": "https://aws.amazon.com/marketplace"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "google-compute-engine",
      "name": "Google Compute Engine",
      "description": "MCP server for Google Compute Engine",
      "url": "https://compute.googleapis.com/mcp",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Requires Google Cloud credentials and IAM permissions that the catalog setup does not collect.",
      "publisher": "Google",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "google-compute-engine.svg",
      "sourceUrl": "https://claude.ai/directory/3afecfe4-46be-4f31-9050-9b8a67909028",
      "publisherUrl": "https://cloud.google.com/products/compute"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "supermemory",
      "name": "Supermemory",
      "description": "Search documents, notes, and memories saved in Supermemory spaces.",
      "url": "https://mcp.supermemory.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Supermemory",
      "tags": [],
      "priority": "P0",
      "logo": "supermemory.svg",
      "sourceUrl": "https://docs.supermemory.ai/supermemory-mcp/setup",
      "publisherUrl": "https://supermemory.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "notion",
      "name": "Notion",
      "description": "Connect your Notion workspace to search, update, and power workflows across tools",
      "url": "https://mcp.notion.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Notion",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "notion.svg",
      "sourceUrl": "https://claude.ai/directory/69f3a300-cc60-48c4-b237-dfac56530dbf",
      "publisherUrl": "https://notion.com/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "atlassian",
      "name": "Atlassian MCP",
      "description": "Search, read and update Jira, Confluence, Bitbucket, Loom and other Atlassian apps with your existing Atlassian permissions.",
      "url": "https://mcp.atlassian.com/v2/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Atlassian",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "atlassian.svg",
      "sourceUrl": "https://claude.ai/directory/11ba10d9-477b-4988-bd1c-90a7fa680dc1",
      "publisherUrl": "https://atlassian.com/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "box",
      "name": "Box",
      "description": "Search, edit and get insights on your Box content",
      "url": "https://mcp.box.com/",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Box",
      "tags": ["data-analytics", "legal"],
      "priority": "P0",
      "logo": "box.svg",
      "sourceUrl": "https://claude.ai/directory/a5380429-c773-4180-b642-301418240c8c",
      "publisherUrl": "https://www.box.com/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "airtable",
      "name": "Airtable",
      "description": "Bring your structured data to Claude",
      "url": "https://mcp.airtable.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Airtable",
      "tags": ["data-analytics"],
      "priority": "P0",
      "logo": "airtable.svg",
      "sourceUrl": "https://claude.ai/directory/cb504fab-e494-490f-bff8-bb3ab23a2209",
      "publisherUrl": "https://airtable.com/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "dropbox",
      "name": "Dropbox",
      "description": "Search, organize, and take action on your Dropbox content",
      "url": "https://mcp.dropbox.com/claude_app_mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Dropbox",
      "tags": ["creative", "legal", "media-entertainment", "productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "dropbox.svg",
      "sourceUrl": "https://claude.ai/directory/1e4280cc-037c-47f0-9873-56bea1871bdb",
      "publisherUrl": "https://www.dropbox.com/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "goodnotes",
      "name": "Goodnotes",
      "description": "Turn AI insights into documents",
      "url": "https://claude-mcp-api.ml.goodnotes.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Goodnotes",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "goodnotes.svg",
      "sourceUrl": "https://claude.ai/directory/e261228f-7eed-410a-b7b7-f4474dc592ba",
      "publisherUrl": "https://goodnotes.com/"
    },
    {
      "category": "Product",
      "subcategory": "Product analytics",
      "id": "posthog",
      "name": "PostHog",
      "description": "Query, analyze, and manage your PostHog insights",
      "url": "https://mcp.posthog.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PostHog",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "posthog.svg",
      "sourceUrl": "https://claude.ai/directory/50688846-553c-4a12-bc21-df94d2173734",
      "publisherUrl": "https://posthog.com/"
    },
    {
      "category": "Product",
      "subcategory": "Product analytics",
      "id": "mixpanel",
      "name": "Mixpanel",
      "description": "Analyze, query, and manage your Mixpanel data",
      "url": "https://mcp.mixpanel.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mixpanel",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "mixpanel.svg",
      "sourceUrl": "https://claude.ai/directory/29d60a67-6f16-489b-8a1e-efdcece8d1f6",
      "publisherUrl": "https://mixpanel.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "asana",
      "name": "Asana",
      "description": "Connect to Asana to coordinate tasks, projects, and goals",
      "url": "https://mcp.asana.com/v2/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Asana",
      "tags": ["communication", "productivity"],
      "priority": "P0",
      "logo": "asana.svg",
      "sourceUrl": "https://claude.ai/directory/41aefcf3-a829-45eb-8cee-d90b93912f57",
      "publisherUrl": "https://asana.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "linear",
      "name": "Linear",
      "description": "Manage issues, projects & team workflows in Linear",
      "url": "https://mcp.linear.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Linear (Linear Orbit, Inc.)",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "linear.svg",
      "sourceUrl": "https://claude.ai/directory/fa50c30c-9f62-4f94-b851-217868185db6",
      "publisherUrl": "https://linear.app/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "clickup",
      "name": "ClickUp",
      "description": "Project management & collaboration for teams & agents",
      "url": "https://mcp.clickup.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ClickUp",
      "tags": ["communication", "productivity"],
      "priority": "P0",
      "logo": "clickup.svg",
      "sourceUrl": "https://claude.ai/directory/aa5a2bca-4004-49ea-bc2b-978162587a3a",
      "publisherUrl": "https://clickup.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "todoist",
      "name": "Todoist",
      "description": "Search, complete, and manage your tasks in Todoist",
      "url": "https://ai.todoist.net/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Doist",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "todoist.svg",
      "sourceUrl": "https://claude.ai/directory/d1bac76b-5673-4d98-b275-41451f3dd847",
      "publisherUrl": "https://todoist.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "trello",
      "name": "Trello",
      "description": "Get things done in Trello",
      "url": "https://mcp.trello.com/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Trello",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "trello.svg",
      "sourceUrl": "https://claude.ai/directory/7bc869f4-0f64-4dd6-9c19-bee47499508c",
      "publisherUrl": "https://trello.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "wrike",
      "name": "Wrike",
      "description": "Manage, update and move work forward from Claude",
      "url": "https://mcp.wrike.com/v2",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Wrike",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "wrike.svg",
      "sourceUrl": "https://claude.ai/directory/baa35676-3f79-4728-aec9-b37870c73deb",
      "publisherUrl": "https://www.wrike.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "ticktick",
      "name": "TickTick",
      "description": "Search, create and manage your tasks/habit it TickTick.",
      "url": "https://mcp.ticktick.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Appest Inc",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "ticktick.svg",
      "sourceUrl": "https://claude.ai/directory/8998ee3e-3ade-49db-b4b1-bd888240c8d0",
      "publisherUrl": "https://ticktick.com/"
    },
    {
      "category": "Sales",
      "subcategory": "CRM",
      "id": "salesforce",
      "name": "Salesforce",
      "description": "Query CRM records, run flows, and invoke Salesforce platform actions.",
      "url": "https://api.salesforce.com/platform/mcp/v1/platform/headless-360",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Salesforce",
      "tags": [],
      "priority": "P0",
      "logo": "salesforce.svg",
      "sourceUrl": "https://developer.salesforce.com/docs/platform/einstein-genai/guide/hosted-mcp-overview.html",
      "publisherUrl": "https://salesforce.com/"
    },
    {
      "category": "Sales",
      "subcategory": "CRM",
      "id": "hubspot",
      "name": "HubSpot",
      "description": "CRM context for every answer, insight, and action",
      "url": "https://mcp.hubspot.com/anthropic",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "HubSpot",
      "tags": ["sales-and-marketing"],
      "priority": "P0",
      "logo": "hubspot.svg",
      "sourceUrl": "https://claude.ai/directory/875dee50-9b3f-452b-af8c-fbc839966273",
      "publisherUrl": "https://www.hubspot.com/"
    },
    {
      "category": "Sales",
      "subcategory": "CRM",
      "id": "attio",
      "name": "Attio",
      "description": "Search, manage, and update your Attio CRM from Claude",
      "url": "https://mcp.attio.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Attio",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "attio.svg",
      "sourceUrl": "https://claude.ai/directory/ae5afdb9-e3c6-4b64-a13a-420e7a8d8124",
      "publisherUrl": "https://attio.com/"
    },
    {
      "category": "Sales",
      "subcategory": "CRM",
      "id": "pipedrive-mcp",
      "name": "Pipedrive",
      "description": "Find deals, update records, manage activities and work with your live CRM data using natural language.",
      "url": "https://mcp.pipedrive.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pipedrive",
      "tags": ["communication", "data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "pipedrive-mcp.svg",
      "sourceUrl": "https://claude.ai/directory/30f3f2c8-e6e4-4bf9-845f-46f5afeea73a",
      "publisherUrl": "https://pipedrive.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "gmail",
      "name": "Gmail",
      "description": "Draft replies, summarize threads, & search your inbox",
      "url": "https://gmailmcp.googleapis.com/mcp/v1",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Requires a registered Google OAuth client and consent; anonymous tool discovery does not authorize mailbox access.",
      "publisher": "Google",
      "tags": ["communication"],
      "priority": "P0",
      "logo": "gmail.svg",
      "sourceUrl": "https://claude.ai/directory/2701e52f-b826-4aaf-8b25-11f2a97c98b0",
      "publisherUrl": "https://cloud.google.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "google-calendar",
      "name": "Google Calendar",
      "description": "Manage your schedule and coordinate meetings effortlessly",
      "url": "https://calendarmcp.googleapis.com/mcp/v1",
      "auth": "oauth",
      "oneClick": false,
      "limitation": "Requires a registered Google OAuth client and consent; anonymous tool discovery does not authorize calendar access.",
      "publisher": "Google",
      "tags": ["productivity"],
      "priority": "P0",
      "logo": "google-calendar.svg",
      "sourceUrl": "https://claude.ai/directory/2a838eaa-f7b4-4bc2-bd47-c326f3c813c5",
      "publisherUrl": "https://cloud.google.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "cal-com",
      "name": "Cal.com",
      "description": "Manage availability, event types, and bookings.",
      "url": "https://mcp.cal.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Cal.com",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P0",
      "logo": "cal-com.svg",
      "sourceUrl": "https://cal.com/blog/how-to-connect-calcom-to-claude-using-mcp",
      "publisherUrl": "https://cal.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "superhuman-mail",
      "name": "Superhuman Mail",
      "description": "The most productive email app ever, for Gmail & Outlook",
      "url": "https://mcp.mail.superhuman.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Superhuman Mail",
      "tags": ["communication", "productivity"],
      "priority": "P1",
      "logo": "superhuman-mail.svg",
      "sourceUrl": "https://claude.ai/directory/c0449015-4acb-47b6-b9ac-e6e98e884328",
      "publisherUrl": "https://superhuman.com/products/mail"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "calendly",
      "name": "Calendly",
      "description": "Manage event types, availability, and bookings.",
      "url": "https://mcp.calendly.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Calendly",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "calendly.svg",
      "sourceUrl": "https://claude.ai/directory/d778b2f9-25f4-42a2-87ab-dbaa896deb1b",
      "publisherUrl": "https://calendly.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "stripe",
      "name": "Stripe",
      "description": "Manage payments, customers, subscriptions, invoices, and financial workflows.",
      "url": "https://mcp.stripe.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Stripe",
      "tags": [],
      "priority": "P0",
      "logo": "stripe.svg",
      "sourceUrl": "https://docs.stripe.com/mcp",
      "publisherUrl": "https://stripe.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "docusign",
      "name": "Docusign",
      "description": "Intelligent, secure contract management by Docusign",
      "url": "https://mcp.docusign.com/mcp",
      "oneClick": false,
      "limitation": "OAuth metadata fails strict issuer validation and cannot complete Maito's one-click flow.",
      "publisher": "Docusign",
      "tags": ["legal", "productivity"],
      "priority": "P0",
      "logo": "docusign.svg",
      "sourceUrl": "https://claude.ai/directory/a876b642-2b05-4808-a565-deeb271802fd",
      "publisherUrl": "https://www.docusign.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "quickbooks",
      "name": "Intuit QuickBooks",
      "description": "Business Finances made simple",
      "url": "https://ai-inc.quickbooks.intuit.com/v1/mcp",
      "oneClick": false,
      "limitation": "The endpoint requests a bearer credential without compatible OAuth metadata; it needs a dedicated authentication preset.",
      "publisher": "Intuit QuickBooks",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P1",
      "logo": "quickbooks.svg",
      "sourceUrl": "https://claude.ai/directory/a933e343-3389-4a82-beeb-7d5f5c2c4f25",
      "publisherUrl": "https://quickbooks.intuit.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "xero",
      "name": "Xero",
      "description": "Access your Xero financials from any conversation",
      "url": "https://mcp.xero.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Xero Limited",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "xero.svg",
      "sourceUrl": "https://claude.ai/directory/4c1fcb68-c482-46c5-a677-659eaf2f2c85",
      "publisherUrl": "https://www.xero.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "ramp",
      "name": "Ramp",
      "description": "Search, access, and analyze your Ramp financial data",
      "url": "https://ramp-mcp-remote.ramp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ramp",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "ramp.svg",
      "sourceUrl": "https://claude.ai/directory/61bac03c-3f98-4b3c-affb-1b99533fa82c",
      "publisherUrl": "https://ramp.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "ironclad",
      "name": "Ironclad Contracts",
      "description": "Plain language search for faster contract answers and manage your contractual obligations",
      "url": "https://mcp.na1.ironcladapp.com/mcp",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "Ironclad, Inc",
      "tags": ["legal", "productivity"],
      "priority": "P1",
      "logo": "ironclad.svg",
      "sourceUrl": "https://claude.ai/directory/c5504c7c-d299-4637-a012-29ef1a2354a9",
      "publisherUrl": "https://ironcladapp.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Contracts & payments",
      "id": "paypal",
      "name": "PayPal",
      "description": "Access PayPal payments platform",
      "url": "https://mcp.paypal.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PayPal",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "paypal.svg",
      "sourceUrl": "https://claude.ai/directory/001103b7-bcde-4b9c-b5d4-f209c2fed1f3",
      "publisherUrl": "https://paypal.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "gojiberry",
      "name": "GojiBerry",
      "description": "Find and update contacts, lists, campaigns, intent signals, and outreach analytics.",
      "url": "https://mcp.gojiberry.ai",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GojiBerry AI",
      "tags": [],
      "priority": "P0",
      "logo": "gojiberry.svg",
      "sourceUrl": "https://help.gojiberry.ai/en/articles/14540015-using-the-gojiberry-mcp-server",
      "publisherUrl": "https://gojiberry.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "apollo",
      "name": "Apollo.io",
      "description": "Find, enrich, and reach ideal prospects, on Claude",
      "url": "https://mcp.apollo.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Apollo.io",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P0",
      "logo": "apollo.svg",
      "sourceUrl": "https://claude.ai/directory/8fd555a4-ea5f-49cf-9335-582dd6760597",
      "publisherUrl": "https://www.apollo.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "zoominfo",
      "name": "ZoomInfo",
      "description": "Find prospects. Research accounts. Enrich buyers with verified B2B data. Act on intent signals.",
      "url": "https://mcp.zoominfo.com/mcp",
      "oneClick": false,
      "limitation": "OAuth metadata fails strict issuer validation and cannot complete Maito's one-click flow.",
      "publisher": "ZoomInfo Technologies Inc.",
      "tags": [
        "communication",
        "data-analytics",
        "developer-tools",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P0",
      "logo": "zoominfo.svg",
      "sourceUrl": "https://claude.ai/directory/f2cdf1b8-2f75-48a4-8d8c-8d9cce1b8643",
      "publisherUrl": "https://www.zoominfo.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "clay",
      "name": "Clay",
      "description": "Find prospects. Research accounts. Personalize outreach",
      "url": "https://api.clay.com/v3/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Clay",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P1",
      "logo": "clay.svg",
      "sourceUrl": "https://claude.ai/directory/a8159026-14b4-403a-933b-bd897a5b36ca",
      "publisherUrl": "https://clay.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "pitchbook",
      "name": "PitchBook Premium",
      "description": "PitchBook data, embedded in the way you work.",
      "url": "https://premium.mcp.pitchbook.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PitchBook",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "pitchbook.svg",
      "sourceUrl": "https://claude.ai/directory/79c545e3-8878-4557-bcbb-3add11c86890",
      "publisherUrl": "https://www.pitchbook.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "lusha",
      "name": "Lusha",
      "description": "Find and enrich B2B contacts and companies",
      "url": "https://mcp.lusha.com/mcp/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lusha",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "lusha.svg",
      "sourceUrl": "https://claude.ai/directory/cb3b7f71-456f-4f8e-8a31-e77194d396ab",
      "publisherUrl": "https://lusha.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "bigdata",
      "name": "Bigdata.com",
      "description": "AI grounding layer for finance: stocks, market data, portfolio, investment research & financial data — SEC filings, earnings calls, sentiment, premium news, plus your own private documents, all cited",
      "url": "https://mcp.bigdata.com/",
      "oneClick": false,
      "limitation": "Requires a pre-registered OAuth client; Maito's one-click flow supports dynamic registration.",
      "publisher": "RavenPack",
      "tags": ["data-analytics", "financial-services", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "bigdata.svg",
      "sourceUrl": "https://claude.ai/directory/e463df16-b3d7-4bb9-953d-b652a073c764",
      "publisherUrl": "https://www.ravenpack.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales engagement",
      "id": "outreach",
      "name": "Outreach",
      "description": "Unleash your team's best performance with Outreach AI",
      "url": "https://api.outreach.io/mcp/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Outreach",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "outreach.svg",
      "sourceUrl": "https://claude.ai/directory/7b2bdb34-e318-4d50-893f-330a8e41d78c",
      "publisherUrl": "https://outreach.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "monday-com",
      "name": "monday.com",
      "description": "monday.com project management & CRM for projects, tasks, portfolios, boards, workflows, milestones, dependencies, forms, dashboards, cross-project portfolio status, and critical paths.",
      "url": "https://mcp.monday.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "monday.com",
      "tags": ["creative", "developer-tools", "other", "productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "monday-com.png",
      "sourceUrl": "https://claude.ai/directory/49e0f9ba-7d45-4fb6-b098-55eec956fbc6",
      "publisherUrl": "https://monday.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "adobe",
      "name": "Adobe",
      "description": "Design, combine, and edit with Adobe pro tools",
      "url": "https://adobe-creativity.adobe.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adobe Inc.",
      "tags": ["creative", "productivity"],
      "priority": "P1",
      "logo": "adobe.png",
      "sourceUrl": "https://claude.ai/directory/22854937-9510-4b57-9230-62c820102d8f",
      "publisherUrl": "https://www.adobe.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "wispr-flow",
      "name": "Wispr Flow",
      "description": "Your meetings, notes, and tasks from Wispr Flow — now native context for Claude.",
      "url": "https://api.wisprflow.ai/connect/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wispr Flow",
      "tags": ["communication", "productivity"],
      "priority": "P1",
      "logo": "wispr-flow.png",
      "sourceUrl": "https://claude.ai/directory/958b6948-97e4-4315-9ee5-82254f617557",
      "publisherUrl": "https://wisprflow.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "microsoft-learn",
      "name": "Microsoft Learn",
      "description": "Search trusted Microsoft docs to power your development",
      "url": "https://learn.microsoft.com/api/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Microsoft",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "microsoft-learn.png",
      "sourceUrl": "https://claude.ai/directory/89a7ddf5-2a6b-410c-be11-aa0e1a1b35a6",
      "publisherUrl": "https://learn.microsoft.com/en-us/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "pubmed",
      "name": "PubMed",
      "description": "Search biomedical literature from PubMed",
      "url": "https://pubmed.mcp.claude.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["consumer-health", "health-life-sciences"],
      "priority": "P1",
      "logo": "pubmed.svg",
      "sourceUrl": "https://claude.ai/directory/81cc5080-a204-4aa1-a694-fa868a3c8721",
      "publisherUrl": "https://www.anthropic.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "consensus",
      "name": "Consensus",
      "description": "Explore scientific research",
      "url": "https://mcp.consensus.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Consensus",
      "tags": ["data-analytics", "health-life-sciences"],
      "priority": "P1",
      "logo": "consensus.svg",
      "sourceUrl": "https://claude.ai/directory/65247229-f0c7-49df-9044-fcbb8b3894c6",
      "publisherUrl": "https://consensus.app/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "wordpress-com",
      "name": "WordPress.com",
      "description": "Secure AI access to manage your WordPress.com sites",
      "url": "https://public-api.wordpress.com/wpcom/v2/mcp/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Automattic (WordPress.com)",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "wordpress-com.png",
      "sourceUrl": "https://claude.ai/directory/e6fc4c18-ea48-4752-9912-7a13bf9999ed",
      "publisherUrl": "https://wordpress.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "adobe-marketing-agent",
      "name": "Adobe Marketing Agent",
      "description": "Marketing campaign and audience insights from Adobe",
      "url": "https://aep-ai-ama.adobe.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adobe Inc",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "adobe-marketing-agent.png",
      "sourceUrl": "https://claude.ai/directory/39d085c5-0b24-4a3f-aca1-5ec9d1726714",
      "publisherUrl": "https://business.adobe.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "sandp-deterministic-retrieval",
      "name": "S&P - Deterministic Retrieval",
      "description": "Deterministic access to S&P Global data",
      "url": "https://kfinance.kensho.com/integrations/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "S&P Global",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "sandp-deterministic-retrieval.png",
      "sourceUrl": "https://claude.ai/directory/d965405c-3467-4046-b5b3-e8fb8ed235eb",
      "publisherUrl": "https://www.spglobal.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "exa",
      "name": "Exa",
      "description": "Web Search + Code Docs Search",
      "url": "https://mcp.exa.ai/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Exa",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "exa.png",
      "sourceUrl": "https://claude.ai/directory/91408932-1110-4350-97c7-2d6b3a6d9694",
      "publisherUrl": "https://exa.ai/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "clinical-trials",
      "name": "Clinical Trials",
      "description": "Access ClinicalTrials.gov data",
      "url": "https://hcls.mcp.claude.com/clinical_trials/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "clinical-trials.png",
      "sourceUrl": "https://claude.ai/directory/c1754944-3ad1-49ab-bec5-9aeae3a6a9a3",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "biorxiv",
      "name": "bioRxiv",
      "description": "Access bioRxiv and medRxiv preprint data",
      "url": "https://hcls.mcp.claude.com/biorxiv/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "biorxiv.png",
      "sourceUrl": "https://claude.ai/directory/7f750eb6-c3cb-47d7-9269-d35c43fe9925",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "vibe-prospecting",
      "name": "Vibe Prospecting",
      "description": "Find and enrich company and contact data in Claude for prospecting, lead generation, recruiting, and CRM enrichment across 150M+ companies and 800M+ contacts",
      "url": "https://vibeprospecting.explorium.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vibeprospecting.ai",
      "tags": [
        "data-analytics",
        "financial-services",
        "other",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P1",
      "logo": "vibe-prospecting.png",
      "sourceUrl": "https://claude.ai/directory/1bdcb159-b6f0-4f13-bc08-fdb40b007828",
      "publisherUrl": "https://www.vibeprospecting.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "anthropic-economic-index",
      "name": "Anthropic Economic Index",
      "description": "Explore public data on how the world uses Claude",
      "url": "https://econ-index.mcp.claude.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "anthropic-economic-index.svg",
      "sourceUrl": "https://claude.ai/directory/5e90e841-ba8a-433e-9303-cd41820de915",
      "publisherUrl": "https://www.anthropic.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "wiley-scholar-gateway",
      "name": "Wiley Scholar Gateway",
      "description": "Enhance responses with scholarly research and citations",
      "url": "https://connector.scholargateway.ai/v2/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "John Wiley & Sons Inc.",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "wiley-scholar-gateway.png",
      "sourceUrl": "https://claude.ai/directory/ff091334-0f12-4d0e-a973-c00467dd3818",
      "publisherUrl": "https://www.wiley.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "factset-ai-ready-data",
      "name": "FactSet AI-Ready Data",
      "description": "Access institutional-quality financial data and analytics",
      "url": "https://mcp.factset.com/content/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "FactSet Research Systems",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "factset-ai-ready-data.png",
      "sourceUrl": "https://claude.ai/directory/f2da5b67-41bc-4ce9-8eb8-f18ab09bde5a",
      "publisherUrl": "https://www.factset.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "klaviyo",
      "name": "Klaviyo",
      "description": "Report, strategize & create with real-time Klaviyo data",
      "url": "https://mcp.klaviyo.com/mcp?include-mcp-app=true",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Klaviyo",
      "tags": ["communication", "data-analytics", "sales-and-marketing"],
      "priority": "P1",
      "logo": "klaviyo.png",
      "sourceUrl": "https://claude.ai/directory/b1a89151-dc5f-4d75-baa7-9da291b81a0c",
      "publisherUrl": "https://klaviyo.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "jotform",
      "name": "Jotform",
      "description": "Create forms, surveys, quizzes & analyze submissions",
      "url": "https://mcp.jotform.com/mcp-app",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jotform",
      "tags": ["data-analytics", "education", "nonprofit", "productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "jotform.png",
      "sourceUrl": "https://claude.ai/directory/aed7e2be-868e-4046-9e12-5c917b4e6b97",
      "publisherUrl": "https://www.jotform.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "chembl",
      "name": "ChEMBL",
      "description": "Access the ChEMBL Database",
      "url": "https://hcls.mcp.claude.com/chembl/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "chembl.png",
      "sourceUrl": "https://claude.ai/directory/711ccc94-754b-4659-903d-d61b29dd781e",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "adobe-experience-manager",
      "name": "Adobe Experience Manager",
      "description": "Manage your Adobe Experience Manager content",
      "url": "https://mcp.adobeaemcloud.com/adobe/mcp/aem",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adobe",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "adobe-experience-manager.png",
      "sourceUrl": "https://claude.ai/directory/e9f93fb8-37d6-4727-a129-956e5263ac3e",
      "publisherUrl": "https://business.adobe.com/products/experience-manager"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "trimble-sketchup",
      "name": "Trimble SketchUp",
      "description": "Create and iterate 3D models for use in SketchUp",
      "url": "https://api.sketchup.com/mcp/v1/sketchup/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Trimble SketchUp",
      "tags": ["creative"],
      "priority": "P1",
      "logo": "trimble-sketchup.svg",
      "sourceUrl": "https://claude.ai/directory/b982ecd1-ee51-45f0-99d9-9330a0dd8b0c",
      "publisherUrl": "https://sketchup.trimble.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "elicit",
      "name": "Elicit",
      "description": "Search and analyze scientific papers",
      "url": "https://elicit.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Elicit, inc.",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "elicit.png",
      "sourceUrl": "https://claude.ai/directory/1287875c-308f-4a61-9ebf-4a0201ef214f",
      "publisherUrl": "https://elicit.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "biorender",
      "name": "BioRender",
      "description": "Search the BioRender library, find your files, and generate new scientific figures directly from Claude.",
      "url": "https://mcp.services.biorender.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "BioRender",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "biorender.png",
      "sourceUrl": "https://claude.ai/directory/81cc5080-a204-4aa1-a694-fa868a3c8720",
      "publisherUrl": "https://biorender.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "adobe-workfront",
      "name": "Adobe Workfront",
      "description": "Manage planning, projects, tasks, and approvals",
      "url": "https://mcp.workfront.adobe.com/mcp/v1/workfront",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adobe",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "adobe-workfront.png",
      "sourceUrl": "https://claude.ai/directory/81d7db7c-e329-41ee-bc8e-48beceac2d68",
      "publisherUrl": "https://business.adobe.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "alpha-vantage",
      "name": "Alpha Vantage",
      "description": "Stock market data: stocks, options, fundamentals, earnings, SEC filings, indices, news, exchange rates, commodities, and other trading signals to power your quantitative finance workflow",
      "url": "https://mcp.alphavantage.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Alpha Vantage Inc",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P1",
      "logo": "alpha-vantage.png",
      "sourceUrl": "https://claude.ai/directory/0f1d77a7-9e03-438a-824d-d66c6dd0f0d5",
      "publisherUrl": "https://alphavantage.co/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "scite",
      "name": "Scite",
      "description": "Evidence-based answers grounded in research",
      "url": "https://api.scite.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Scite",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "scite.png",
      "sourceUrl": "https://claude.ai/directory/f65118b4-06cb-468a-b2c7-f203ae7b54ea",
      "publisherUrl": "https://scite.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "morningstar",
      "name": "Morningstar",
      "description": "Up-to-date investment and market insights",
      "url": "https://mcp.morningstar.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Morningstar",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "morningstar.png",
      "sourceUrl": "https://claude.ai/directory/2e98be30-8dba-486e-94a9-9a01d34678e2",
      "publisherUrl": "https://www.morningstar.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "zoho-crm",
      "name": "Zoho CRM",
      "description": "MCP Server for Zoho CRM Workflows",
      "url": "https://claude-zohocrm.zohomcp.com/mcp/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "zoho-crm.png",
      "sourceUrl": "https://claude.ai/directory/fbc6ce8e-ac9d-4b09-8b74-a69fd456bc39",
      "publisherUrl": "https://www.zoho.com/mcp/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "datasite",
      "name": "Datasite",
      "description": "Manage your M&A data room from Claude",
      "url": "https://mcp.global.datasite.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Datasite",
      "tags": ["financial-services", "legal"],
      "priority": "P1",
      "logo": "datasite.svg",
      "sourceUrl": "https://claude.ai/directory/3a148118-6b4a-443e-9a66-9e1ec243d119",
      "publisherUrl": "https://www.datasite.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "fmp",
      "name": "FMP",
      "description": "Comprehensive financial market data",
      "url": "https://financialmodelingprep.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Financial Modeling Prep",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "fmp.png",
      "sourceUrl": "https://claude.ai/directory/887934eb-b7e7-429a-b5e3-3523b9c3d45d",
      "publisherUrl": "https://financialmodelingprep.com/?utm_source=claude"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "courtlistener",
      "name": "CourtListener",
      "description": "Legal research across millions of court records",
      "url": "https://mcp.courtlistener.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Free Law Project",
      "tags": ["legal", "productivity"],
      "priority": "P1",
      "logo": "courtlistener.svg",
      "sourceUrl": "https://claude.ai/directory/58d5cff1-20b3-4bb8-9c51-9ac3e6bd0dac",
      "publisherUrl": "https://free.law/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "npi-registry",
      "name": "NPI Registry",
      "description": "Access US National Provider Identifier (NPI) Registry",
      "url": "https://hcls.mcp.claude.com/npi_registry/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["consumer-health"],
      "priority": "P1",
      "logo": "npi-registry.svg",
      "sourceUrl": "https://claude.ai/directory/e3b3e96f-6b4d-468d-a4b6-89f484b7e21c",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "tiktok-for-business",
      "name": "TikTok for Business",
      "description": "Create, manage, and analyze advertising campaigns on TikTok",
      "url": "https://business-api.tiktok.com/open_mcp/tt-ads-mcp-layer-anthropic",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "TikTok",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "tiktok-for-business.png",
      "sourceUrl": "https://claude.ai/directory/d4417762-8c16-42ec-ac3a-7b903b9d7fc9",
      "publisherUrl": "https://www.tiktok.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "carta",
      "name": "Carta",
      "description": "The connected ERP for private capital",
      "url": "https://mcp.app.carta.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Carta",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "carta.svg",
      "sourceUrl": "https://claude.ai/directory/4b463f8b-6db0-4d0e-9693-8b39f37e4447",
      "publisherUrl": "https://carta.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "ashby",
      "name": "Ashby",
      "description": "Search, analyze, and act on your recruiting data",
      "url": "https://mcp.ashbyhq.com/mcp/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ashby",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "ashby.png",
      "sourceUrl": "https://claude.ai/directory/dc1671e0-b14c-47b8-a625-e835ae4067ba",
      "publisherUrl": "https://www.ashbyhq.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "playmcp",
      "name": "PlayMCP",
      "description": "Connect and use PlayMCP servers in your toolbox",
      "url": "https://playmcp.kakao.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "KAKAO",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "playmcp.png",
      "sourceUrl": "https://claude.ai/directory/34269403-d1cc-468f-8c0d-4bd01e8042c8",
      "publisherUrl": "https://www.kakaocorp.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "open-targets",
      "name": "Open Targets",
      "description": "Drug target discovery and prioritisation platform",
      "url": "https://mcp.platform.opentargets.org/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "OpenTargets",
      "tags": ["data-analytics", "health-life-sciences"],
      "priority": "P1",
      "logo": "open-targets.png",
      "sourceUrl": "https://claude.ai/directory/097ab77c-338a-421c-8ba7-3960c928a540",
      "publisherUrl": "https://www.opentargets.org/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "adisinsight",
      "name": "AdisInsight",
      "description": "Pharmaceutical drug & clinical trial intelligence",
      "url": "https://adisinsight-mcp.springer.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Springer Nature",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "adisinsight.png",
      "sourceUrl": "https://claude.ai/directory/f73a5ee3-2b26-451d-8cb3-93bc451ac0fd",
      "publisherUrl": "https://www.springernature.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "tally",
      "name": "Tally",
      "description": "Create beautiful forms",
      "url": "https://api.tally.so/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tally Forms",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "tally.png",
      "sourceUrl": "https://claude.ai/directory/b1c26807-986e-4cf5-99ca-362e5abb7feb",
      "publisherUrl": "https://tally.so/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "daloopa",
      "name": "Daloopa",
      "description": "Financial fundamental data and KPIs with hyperlinks",
      "url": "https://mcp.daloopa.com/server/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Daloopa",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "daloopa.svg",
      "sourceUrl": "https://claude.ai/directory/67e0ebd7-f7c3-4917-b8f9-dc8c8cdcce13",
      "publisherUrl": "https://daloopa.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "slidesgpt",
      "name": "SlidesGPT",
      "description": "Make presentations and slides, export to PowerPoint",
      "url": "https://claude.slidesgpt.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Lightstone GmbH",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "slidesgpt.png",
      "sourceUrl": "https://claude.ai/directory/59eafa91-020f-435e-b8a4-1bfcd7a957d8",
      "publisherUrl": "https://slidesgpt.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "icd-10-codes",
      "name": "ICD-10 Codes",
      "description": "Access ICD-10-CM and ICD-10-PCS code sets",
      "url": "https://hcls.mcp.claude.com/icd10_codes/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["consumer-health"],
      "priority": "P1",
      "logo": "icd-10-codes.svg",
      "sourceUrl": "https://claude.ai/directory/bd8c051d-df35-44c0-a8b8-084b700e1f21",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "unsplash",
      "name": "Unsplash",
      "description": "Find and use free HD images",
      "url": "https://mcp.unsplash.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Unsplash",
      "tags": ["creative", "developer-tools", "productivity"],
      "priority": "P1",
      "logo": "unsplash.png",
      "sourceUrl": "https://claude.ai/directory/7805d669-c0f7-4ac0-ad69-ff15524ab8f1",
      "publisherUrl": "https://unsplash.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "railway",
      "name": "Railway",
      "description": "Deploy, manage, and debug your apps and infrastructure on Railway",
      "url": "https://mcp.railway.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Railway",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "railway.png",
      "sourceUrl": "https://claude.ai/directory/9ed5afff-a8dc-4f68-b97b-61dae12de3a5",
      "publisherUrl": "https://railway.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "lseg",
      "name": "LSEG",
      "description": "Access best in class data & analytics across a broad spectrum of asset classes.",
      "url": "https://api.analytics.lseg.com/lfa/mcp/server-cl",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LSEG",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "lseg.png",
      "sourceUrl": "https://claude.ai/directory/5f26bc32-8582-4df7-ab88-19c507f8505b",
      "publisherUrl": "https://www.lseg.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "brevo",
      "name": "Brevo",
      "description": "Analyze campaigns, know your audience and create drafts",
      "url": "https://mcp.brevo.com/v1/anthropic/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Brevo",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "brevo.png",
      "sourceUrl": "https://claude.ai/directory/01a9fda6-bd91-4f02-af05-d8e4c3f4f556",
      "publisherUrl": "https://www.brevo.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "adobe-journey-optimizer",
      "name": "Adobe Journey Optimizer",
      "description": "Understand and troubleshoot your Journeys and Campaigns",
      "url": "https://ajo-mcp.adobe.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adobe",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "adobe-journey-optimizer.png",
      "sourceUrl": "https://claude.ai/directory/4eb1485d-c3c6-4282-a72c-5bfc084cad27",
      "publisherUrl": "https://adobe.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "superhuman-docs",
      "name": "Superhuman Docs",
      "description": "Create, search, update docs and tables",
      "url": "https://docs.superhuman.com/apis/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Superhuman",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "superhuman-docs.png",
      "sourceUrl": "https://claude.ai/directory/efca073e-2bd7-48bd-a133-ffd0e87e5d9f",
      "publisherUrl": "https://superhuman.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "udemy-business",
      "name": "Udemy Business",
      "description": "Search and explore skill-building resources",
      "url": "https://api.udemy.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Udemy, Inc.",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "udemy-business.png",
      "sourceUrl": "https://claude.ai/directory/d4ba36c1-89dd-49ee-aea3-2317efccc424",
      "publisherUrl": "https://www.udemy.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "affinity",
      "name": "Affinity",
      "description": "Search, update, and prep deals without switching tabs.",
      "url": "https://mcp.affinity.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Affinity",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "affinity.svg",
      "sourceUrl": "https://claude.ai/directory/5c0aab87-9f11-478f-b7ed-03774fa6169c",
      "publisherUrl": "https://www.affinity.co/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "synapse-org",
      "name": "Synapse.org",
      "description": "Search and metadata tools for Synapse scientific data",
      "url": "https://mcp.synapse.org/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sage Bionetworks",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "synapse-org.png",
      "sourceUrl": "https://claude.ai/directory/81cc5080-a204-4aa1-a694-fa868a3c8719",
      "publisherUrl": "https://sagebionetworks.org/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "imanage-work",
      "name": "iManage Work",
      "description": "Governed knowledge. AI ready.",
      "url": "https://cloudimanage.com/mcp/work",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "iManage LLC",
      "tags": ["legal", "productivity"],
      "priority": "P1",
      "logo": "imanage-work.png",
      "sourceUrl": "https://claude.ai/directory/bfc6b32d-8cdb-451d-8132-d8a16bfe9f9c",
      "publisherUrl": "https://imanage.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "opusclip-mcp",
      "name": "OpusClip",
      "description": "Turn long videos into viral short clips",
      "url": "https://api.opus.pro/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Opusclip Inc.",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "opusclip-mcp.svg",
      "sourceUrl": "https://claude.ai/directory/9e38ad43-49d0-4504-98ad-f15cec49fbb1",
      "publisherUrl": "https://opus.pro/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "cb-insights",
      "name": "CB Insights",
      "description": "Predictive intelligence on private companies",
      "url": "https://mcp.cbinsights.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CB Insights",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "cb-insights.png",
      "sourceUrl": "https://claude.ai/directory/e7952077-b4e6-49f7-8670-ca53f8d50c40",
      "publisherUrl": "https://www.cbinsights.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "sanity",
      "name": "Sanity",
      "description": "Create, query, and manage structured content in Sanity",
      "url": "https://mcp.sanity.io/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sanity",
      "tags": ["developer-tools", "productivity"],
      "priority": "P1",
      "logo": "sanity.svg",
      "sourceUrl": "https://claude.ai/directory/118aa78d-5b78-4e2b-9191-7a6af7cf822e",
      "publisherUrl": "https://www.sanity.io/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "cortellis-regulatory-intelligence",
      "name": "Cortellis Regulatory Intelligence",
      "description": "Trusted Regulatory Answers, by Clarivate Cortellis",
      "url": "https://api.clarivate.com/lifesciences/mcp-regulatory/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Clarivate",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "cortellis-regulatory-intelligence.png",
      "sourceUrl": "https://claude.ai/directory/01fef5a3-baea-4490-8a31-39b119d1d238",
      "publisherUrl": "https://clarivate.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "era-context",
      "name": "Era Context",
      "description": "Manage your personal finances using Claude",
      "url": "https://context.era.app/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tinwell Labs Inc, DBA Era",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "era-context.svg",
      "sourceUrl": "https://claude.ai/directory/bfe1a594-962f-45db-9113-f5e9b6d1f070",
      "publisherUrl": "https://era.app/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "zoho-books",
      "name": "Zoho Books",
      "description": "Zoho Books MCP for Smart Finance Ops",
      "url": "https://claude-zohobooks.zohomcp.com/mcp/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "zoho-books.png",
      "sourceUrl": "https://claude.ai/directory/9e4a3416-f5b4-4a89-8e3a-a4955fa17475",
      "publisherUrl": "https://www.zoho.com/mcp/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "legal-data-hunter",
      "name": "Legal Data Hunter",
      "description": "Search 23M+ legal docs in 160+ jurisdictions.",
      "url": "https://legaldatahunter.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GoodLegal",
      "tags": ["legal", "productivity"],
      "priority": "P1",
      "logo": "legal-data-hunter.svg",
      "sourceUrl": "https://claude.ai/directory/a38cc6ae-c7fb-4136-b50e-cf49a4ded4b3",
      "publisherUrl": "https://legaldatahunter.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "brex",
      "name": "Brex",
      "description": "Intelligent finance automation",
      "url": "https://api.brex.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Brex",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "brex.svg",
      "sourceUrl": "https://claude.ai/directory/9fc52c5f-5a64-4f59-a6f8-4aa9571b8179",
      "publisherUrl": "https://brex.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "vanta",
      "name": "Vanta",
      "description": "Connect to Vanta's trust management platform",
      "url": "https://mcp.vanta.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vanta Inc",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P1",
      "logo": "vanta.png",
      "sourceUrl": "https://claude.ai/directory/a06a16f0-182d-43c1-a20d-0f95aee6027e",
      "publisherUrl": "https://www.vanta.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "autodesk-product-help",
      "name": "Autodesk Product Help",
      "description": "Securely access Autodesk's help documentation",
      "url": "https://developer.api.autodesk.com/knowledge/public/v1/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Autodesk, Inc.",
      "tags": ["creative", "productivity"],
      "priority": "P1",
      "logo": "autodesk-product-help.svg",
      "sourceUrl": "https://claude.ai/directory/1f5a311c-ea2d-4b9c-b78b-197e8f2974b9",
      "publisherUrl": "https://www.autodesk.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "omni-analytics",
      "name": "Omni Analytics",
      "description": "Query your data using natural language through Omni's semantic model",
      "url": "https://callbacks.omniapp.co/callback/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Omni Analytics",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "omni-analytics.png",
      "sourceUrl": "https://claude.ai/directory/8e7324aa-2671-46bf-9447-5bba8ccf8c2f",
      "publisherUrl": "https://www.omni.co/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "cms-coverage",
      "name": "CMS Coverage",
      "description": "Access the CMS Coverage Database",
      "url": "https://hcls.mcp.claude.com/cms_coverage/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Anthropic",
      "tags": ["consumer-health"],
      "priority": "P1",
      "logo": "cms-coverage.png",
      "sourceUrl": "https://claude.ai/directory/57dd8e8a-f030-4bb7-a9ed-4098933bd70b",
      "publisherUrl": "https://anthropic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "pandadoc",
      "name": "PandaDoc",
      "description": "Create, send, sign and track documents",
      "url": "https://mcp.pandadoc.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PandaDoc",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "pandadoc.svg",
      "sourceUrl": "https://claude.ai/directory/56998cd4-9a3a-4f40-8aa9-5019da8bf96e",
      "publisherUrl": "https://www.pandadoc.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "fellow-ai",
      "name": "Fellow.ai",
      "description": "Chat with your meetings to uncover actionable insights",
      "url": "https://fellow.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fellow.ai",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "fellow-ai.svg",
      "sourceUrl": "https://claude.ai/directory/069b18da-5c89-4a66-941f-0cb6eae49a8d",
      "publisherUrl": "https://fellow.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "profound",
      "name": "Profound",
      "description": "Pull Profound Visibility, Citation, & AI Bot Visit Data",
      "url": "https://mcp.tryprofound.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Profound",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "profound.svg",
      "sourceUrl": "https://claude.ai/directory/4738c35b-a9cc-4378-8bb2-ad09a1a23b5b",
      "publisherUrl": "https://tryprofound.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "egnyte",
      "name": "Egnyte",
      "description": "Securely search and analyze your Egnyte content",
      "url": "https://mcp-server.egnyte.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Egnyte, Inc.",
      "tags": ["data-analytics", "financial-services", "legal", "productivity"],
      "priority": "P1",
      "logo": "egnyte.png",
      "sourceUrl": "https://claude.ai/directory/5b938bac-8286-4844-bc51-d303f7c6cbde",
      "publisherUrl": "https://www.egnyte.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "guru",
      "name": "Guru",
      "description": "Search and interact with your company knowledge",
      "url": "https://mcp.api.getguru.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Guru",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "guru.svg",
      "sourceUrl": "https://claude.ai/directory/6d13e7f5-f465-498c-b7c9-b99c4bc74719",
      "publisherUrl": "https://www.getguru.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "nimble",
      "name": "Nimble",
      "description": "Real-time web search & extraction for AI agents",
      "url": "https://mcp.nimbleway.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Nimble",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "nimble.svg",
      "sourceUrl": "https://claude.ai/directory/41105597-badd-4563-aba3-88fe45348857",
      "publisherUrl": "https://www.nimbleway.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "square",
      "name": "Square",
      "description": "Search and manage transaction, merchant, and payment data",
      "url": "https://mcp.squareup.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Square, Inc.",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "square.png",
      "sourceUrl": "https://claude.ai/directory/25d61b20-3ba1-4477-b51a-a743d1ca65fb",
      "publisherUrl": "https://squareup.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "alphaxiv",
      "name": "alphaXiv",
      "description": "Fast search and full-text access over arXiv pre-prints",
      "url": "https://api.alphaxiv.org/mcp/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "alphaXiv",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "alphaxiv.png",
      "sourceUrl": "https://claude.ai/directory/fa0fb2e1-c3ba-4486-b576-0881432c5a4e",
      "publisherUrl": "https://www.alphaxiv.org/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "crossbeam",
      "name": "Crossbeam",
      "description": "Explore partner data and ecosystem insights in Claude",
      "url": "https://mcp.crossbeam.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Crossbeam",
      "tags": ["communication", "productivity"],
      "priority": "P1",
      "logo": "crossbeam.svg",
      "sourceUrl": "https://claude.ai/directory/42ce667a-962d-432c-b667-35f0266ac6b5",
      "publisherUrl": "https://crossbeam.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "bitly",
      "name": "Bitly",
      "description": "Shorten links, generate QR Codes, and track performance",
      "url": "https://api-ssl.bitly.com/v4/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bitly",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "bitly.png",
      "sourceUrl": "https://claude.ai/directory/a3b86f43-2d4d-41c1-819f-90bce24e7a39",
      "publisherUrl": "https://bitly.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "floot",
      "name": "Floot",
      "description": "Build and host websites and mobile apps using your own Claude subscription.",
      "url": "https://mcp.floot.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Floot",
      "tags": ["creative", "developer-tools"],
      "priority": "P1",
      "logo": "floot.png",
      "sourceUrl": "https://claude.ai/directory/9efb767c-73f8-44c4-a1b3-ad7715e2b258",
      "publisherUrl": "https://floot.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "mailerlite",
      "name": "MailerLite",
      "description": "Turn Claude into your email marketing assistant",
      "url": "https://mcp.mailerlite.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MailerLite",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "mailerlite.png",
      "sourceUrl": "https://claude.ai/directory/5807a545-cd93-4e71-bb21-f3727bf34df1",
      "publisherUrl": "https://www.mailerlite.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "ramp-data",
      "name": "Ramp Data",
      "description": "Search and analyze Ramp spend across 50,000+ businesses",
      "url": "https://mcp.ramp.com/ramp-data/anthropic/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Ramp",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "ramp-data.png",
      "sourceUrl": "https://claude.ai/directory/165b06c0-1959-451d-a8d0-c413295b84a2",
      "publisherUrl": "https://ramp.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "craft",
      "name": "Craft",
      "description": "Notes & second brain",
      "url": "https://mcp.craft.do/my/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Craft Docs Ltd",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "craft.png",
      "sourceUrl": "https://claude.ai/directory/ebf5e222-450b-4658-b566-ddb82c4c8382",
      "publisherUrl": "https://www.craft.do/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "medidata",
      "name": "Medidata",
      "description": "Clinical trial software and site ranking tools",
      "url": "https://mcp.imedidata.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Medidata Solutions",
      "tags": ["data-analytics", "health-life-sciences", "productivity"],
      "priority": "P1",
      "logo": "medidata.svg",
      "sourceUrl": "https://claude.ai/directory/2011b8ca-e6e5-4eed-b954-2249e521a3a9",
      "publisherUrl": "https://medidata.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "upwork",
      "name": "Upwork",
      "description": "Hire talent or find work",
      "url": "https://mcp.upwork.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Upwork",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "upwork.png",
      "sourceUrl": "https://claude.ai/directory/27973c01-c053-413b-997b-a08064f5b444",
      "publisherUrl": "https://upwork.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "brighthire",
      "name": "BrightHire",
      "description": "Search, summarize and analyze hiring data",
      "url": "https://app.brighthire.ai/mcp/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "BrightHire",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "brighthire.png",
      "sourceUrl": "https://claude.ai/directory/024923b0-b122-4eb0-bb25-c3887bdaa9b9",
      "publisherUrl": "https://brighthire.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "salesloft",
      "name": "Salesloft",
      "description": "Query live data about deals, engagement, and pipeline",
      "url": "https://mcp.salesloft.com/sse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Salesloft",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "salesloft.svg",
      "sourceUrl": "https://claude.ai/directory/b88a0129-d984-4c48-87a1-acf028e9f035",
      "publisherUrl": "https://www.salesloft.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "tl-dv",
      "name": "tl;dv",
      "description": "Meeting transcripts, notes & action items in Claude",
      "url": "https://mcp.tldv.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "tldx solutions GmbH",
      "tags": ["communication", "data-analytics", "productivity"],
      "priority": "P1",
      "logo": "tl-dv.svg",
      "sourceUrl": "https://claude.ai/directory/fe54565b-5acb-45b3-b27e-4f7d9752a257",
      "publisherUrl": "https://tldv.io/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "synthesize-bio",
      "name": "Synthesize Bio",
      "description": "Generate gene expression from a virtual human",
      "url": "https://app.synthesize.bio/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Synthesize Bio",
      "tags": ["health-life-sciences"],
      "priority": "P1",
      "logo": "synthesize-bio.png",
      "sourceUrl": "https://claude.ai/directory/ef243b27-ec39-440b-8bb2-c407871c3bc6",
      "publisherUrl": "https://www.synthesize.bio/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "metaview",
      "name": "Metaview",
      "description": "The AI platform for recruiting.",
      "url": "https://mcp.metaview.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Metaview",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "metaview.svg",
      "sourceUrl": "https://claude.ai/directory/7bc97e97-91fb-4da8-8a81-3602c9d4150b",
      "publisherUrl": "https://metaview.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "msci",
      "name": "MSCI",
      "description": "Data you can build on",
      "url": "https://mcp.msci.com/mcp/v1.0/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MSCI Inc",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "msci.png",
      "sourceUrl": "https://claude.ai/directory/2cc10749-99cb-4853-a9d7-b2292ec589fc",
      "publisherUrl": "https://msci.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "navan",
      "name": "Navan",
      "description": "Access and analyze your Navan financial and travel data",
      "url": "https://mcp.navan.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Navan",
      "tags": ["financial-services", "travel"],
      "priority": "P1",
      "logo": "navan.png",
      "sourceUrl": "https://claude.ai/directory/9077028d-a283-4012-9304-ef3c556ba683",
      "publisherUrl": "https://navan.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "euler",
      "name": "EULER",
      "description": "Manage your partner program and access your Partner Data Lake with Claude.",
      "url": "https://mcp.eulerapp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Euler Software Inc",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P1",
      "logo": "euler.png",
      "sourceUrl": "https://claude.ai/directory/5070225d-6c89-4bcc-92f9-e28184b0648d",
      "publisherUrl": "https://eulerapp.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "cocounsel-legal",
      "name": "CoCounsel Legal",
      "description": "Thomson Reuters CoCounsel Legal, in Claude",
      "url": "https://cocoagent-service.cocounsel.thomsonreuters.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Thomson Reuters",
      "tags": ["legal", "productivity"],
      "priority": "P1",
      "logo": "cocounsel-legal.png",
      "sourceUrl": "https://claude.ai/directory/084ce5af-6b81-471a-a754-d1a50d3f61a1",
      "publisherUrl": "https://www.thomsonreuters.com/en"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "gusto",
      "name": "Gusto",
      "description": "Query and analyze your Gusto data",
      "url": "https://mcp.api.gusto.com/anthropic",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gusto",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "gusto.png",
      "sourceUrl": "https://claude.ai/directory/cf2b53a4-45ef-4541-9425-0116d42286ca",
      "publisherUrl": "https://gusto.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "peec-ai",
      "name": "Peec AI",
      "description": "Analyze your brand's visibility across LLMs",
      "url": "https://api.peec.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Peec AI",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "peec-ai.png",
      "sourceUrl": "https://claude.ai/directory/ed56abc7-38aa-4ac9-a1a5-fbbb03a95855",
      "publisherUrl": "https://peec.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "adobe-customer-journey-analytics",
      "name": "Adobe Customer Journey Analytics",
      "description": "Run reports using your metrics, dimensions, and segments",
      "url": "https://cja-mcp.adobe.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adobe",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "adobe-customer-journey-analytics.png",
      "sourceUrl": "https://claude.ai/directory/a1b63edd-c598-4b04-b7b0-22dd02c328a3",
      "publisherUrl": "https://business.adobe.com/products/adobe-analytics/customer-journey-analytics.html"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "freee",
      "name": "freee",
      "description": "freeeの各種プロダクトへのデータ下書作成、自動登録、登録済みデータの分析 / Draft, register, and analyze data across freee products",
      "url": "https://mcp.freee.co.jp/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "freee K.K.",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "freee.png",
      "sourceUrl": "https://claude.ai/directory/edc0b710-daf6-4600-aecd-fc2c00f6b338",
      "publisherUrl": "https://corp.freee.co.jp/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "tactiq",
      "name": "Tactiq",
      "description": "Search, summarise & find answers in meetings",
      "url": "https://mcp.tactiq.io/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tactiq",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "tactiq.png",
      "sourceUrl": "https://claude.ai/directory/048d1a8e-abd1-4e3a-b8fc-77d7afb419b1",
      "publisherUrl": "https://tactiq.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "tinyfish",
      "name": "TinyFish",
      "description": "Browser automation, web scraping, web search and fetch via a cloud browser agent: automate websites, log in to portals, submit forms, scrape social media, listings, prices, reviews, monitor changes.",
      "url": "https://agent.tinyfish.ai/mcp/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "TinyFish Inc.",
      "tags": ["data-analytics", "developer-tools", "other", "productivity"],
      "priority": "P1",
      "logo": "tinyfish.png",
      "sourceUrl": "https://claude.ai/directory/e2dfb699-dcb9-4124-b190-9bb1f400adb4",
      "publisherUrl": "https://tinyfish.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "cloudinary",
      "name": "Cloudinary",
      "description": "Manage, transform and deliver your images & videos",
      "url": "https://asset-management.mcp.cloudinary.com/sse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Cloudinary",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P1",
      "logo": "cloudinary.png",
      "sourceUrl": "https://claude.ai/directory/c93e842b-830f-4b4a-bbd1-6e3af0199a8f",
      "publisherUrl": "https://cloudinary.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "otto-travel",
      "name": "Otto Travel",
      "description": "Plan, book, and manage business travel",
      "url": "https://api.ottotheagent.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Otto Trip, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "otto-travel.png",
      "sourceUrl": "https://claude.ai/directory/a758ddcc-4510-4774-b316-9ea13af188bc",
      "publisherUrl": "https://www.ottotheagent.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "third-bridge",
      "name": "Third Bridge",
      "description": "Expert-led enhanced insights",
      "url": "https://ai.thirdbridge.com/mcp/sse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Third Bridge Group",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "third-bridge.png",
      "sourceUrl": "https://claude.ai/directory/c8e8f367-5a12-4320-b715-eee2fbdd8088",
      "publisherUrl": "https://www.thirdbridge.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "clickhouse",
      "name": "ClickHouse",
      "description": "Query and explore your ClickHouse Cloud data",
      "url": "https://mcp.clickhouse.cloud/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ClickHouse",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "clickhouse.svg",
      "sourceUrl": "https://claude.ai/directory/01adc2b5-5676-4dda-9e32-2cce63929d5c",
      "publisherUrl": "https://clickhouse.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "zoho-projects",
      "name": "Zoho Projects",
      "description": "Zoho Projects MCP for Task & Project Automation",
      "url": "https://claude-zohoprojects.zohomcp.com/mcp/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "zoho-projects.png",
      "sourceUrl": "https://claude.ai/directory/bec78036-b8e2-4af1-9ccc-daec0669f426",
      "publisherUrl": "https://www.zoho.com/mcp/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "riverside",
      "name": "Riverside",
      "description": "Prep, edit, clip, and publish your videos and podcasts",
      "url": "https://mcp.riverside.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Riverside",
      "tags": ["communication", "creative", "media-entertainment", "other", "productivity"],
      "priority": "P2",
      "logo": "riverside.png",
      "sourceUrl": "https://claude.ai/directory/3366d1e9-5d1d-49b1-a758-677949a84fd9",
      "publisherUrl": "https://riverside.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "neon",
      "name": "Neon",
      "description": "Postgres, Object Storage, Managed Better Auth, and more",
      "url": "https://mcp.neon.tech/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Neon (A Databricks, Inc. company)",
      "tags": ["data-analytics", "developer-tools", "other", "productivity"],
      "priority": "P2",
      "logo": "neon.svg",
      "sourceUrl": "https://claude.ai/directory/33e1b084-f45e-4fa3-951a-b08ad61101c9",
      "publisherUrl": "https://neon.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "files-com",
      "name": "Files.com",
      "description": "The Secure File Orchestration Platform",
      "url": "https://app.files.com/api/ai/mcp/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Files.com",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "files-com.png",
      "sourceUrl": "https://claude.ai/directory/07ca4be9-1ada-48ff-a591-49737b152f45",
      "publisherUrl": "https://www.files.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "braze",
      "name": "Braze",
      "description": "Braze Marketers can use this connector to answer questions, analyze trends, and provide insights.",
      "url": "https://mcp.braze.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Braze Inc",
      "tags": ["communication", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "braze.png",
      "sourceUrl": "https://claude.ai/directory/1d31273d-65c8-41b1-9591-90c20abfa75d",
      "publisherUrl": "https://braze.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "latchbio",
      "name": "LatchBio",
      "description": "Analyze data and launch bioinformatics workflows",
      "url": "https://mcp.latch.bio/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LatchBio",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "latchbio.svg",
      "sourceUrl": "https://claude.ai/directory/a00dcc51-4d67-4d8d-a411-2ab9f78244fd",
      "publisherUrl": "https://latch.bio/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "workable",
      "name": "Workable",
      "description": "Your AI assistant for Hiring and HR — inside Workable",
      "url": "https://mcp.workable.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Workable",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "workable.svg",
      "sourceUrl": "https://claude.ai/directory/b788f00c-4417-40b2-9e3c-b0e916eb962f",
      "publisherUrl": "https://www.workable.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "mercury",
      "name": "Mercury",
      "description": "Search, analyze and understand your finances on Mercury",
      "url": "https://mcp.mercury.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mercury",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "mercury.svg",
      "sourceUrl": "https://claude.ai/directory/9c04294a-d69c-47e9-9fa6-6a0e780caf3a",
      "publisherUrl": "https://mercury.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "coindesk",
      "name": "CoinDesk",
      "description": "Access Live & Historical Crypto Data, Indices",
      "url": "https://mcp.coindesk.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CoinDesk",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "coindesk.svg",
      "sourceUrl": "https://claude.ai/directory/3b05dbce-1628-4c77-9b24-54455d1dbd5b",
      "publisherUrl": "https://www.coindesk.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "jam",
      "name": "Jam",
      "description": "Record screen and collect automatic context for issues",
      "url": "https://mcp.jam.dev/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jam",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "jam.png",
      "sourceUrl": "https://claude.ai/directory/923fb14b-ed65-4e41-8dd5-4c2c38c00457",
      "publisherUrl": "https://jam.dev/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "idiolect",
      "name": "Idiolect",
      "description": "Make Claude write in your real writing voice.",
      "url": "https://idiolect.app/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Moshpit",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "idiolect.svg",
      "sourceUrl": "https://claude.ai/directory/3aa07766-188c-4099-81c2-6c5a65f04751",
      "publisherUrl": "https://idiolect.app/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "deepl",
      "name": "DeepL",
      "description": "Translate text and documents across 100+ languages, with your preferred styles applied",
      "url": "https://mcp.deepl.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "DeepL",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "deepl.svg",
      "sourceUrl": "https://claude.ai/directory/6281926c-b9be-42d6-80eb-1d38c8c766ae",
      "publisherUrl": "https://deepl.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "frontify",
      "name": "Frontify",
      "description": "Access your brand guidelines, assets and creative templates",
      "url": "https://mcp.frontify-integrations.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Frontify",
      "tags": ["communication", "creative", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "frontify.png",
      "sourceUrl": "https://claude.ai/directory/a1c213e1-70d1-4bed-8505-878f4792dd5f",
      "publisherUrl": "https://frontify.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "inductive-bio",
      "name": "Inductive Bio",
      "description": "State-of-the-art ADMET prediction models for drug discovery",
      "url": "https://api.inductive.bio/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Inductive Bio",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "inductive-bio.png",
      "sourceUrl": "https://claude.ai/directory/b3dd180f-5722-4194-af20-b253347d4f7b",
      "publisherUrl": "https://inductive.bio/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "tomtom-maps",
      "name": "TomTom Maps",
      "description": "TomTom maps, routing, geocoding & traffic data",
      "url": "https://mcp.tomtom.com/maps",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "TomTom",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "tomtom-maps.png",
      "sourceUrl": "https://claude.ai/directory/5775e1f2-124a-4f56-be6c-105a5cb33acc",
      "publisherUrl": "https://www.tomtom.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "eden-by-basecamp-research",
      "name": "EDEN by Basecamp Research",
      "description": "Design antibiotics and prioritise vaccine targets against drug-resistant pathogens using EDEN, Basecamp Research's biological foundation model",
      "url": "https://mcp-public.basecamp-research.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Basecamp Research",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "eden-by-basecamp-research.png",
      "sourceUrl": "https://claude.ai/directory/a93abec3-44cb-47e2-a35f-ab87ba8e4a86",
      "publisherUrl": "https://basecamp-research.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "oreilly",
      "name": "O’Reilly",
      "description": "Discover O'Reilly's expert learning content",
      "url": "https://api.oreilly.com/api/content-discovery/v1/mcp/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "O’Reilly Media",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "oreilly.png",
      "sourceUrl": "https://claude.ai/directory/c36bb242-cf93-4886-a48a-7257d22ce856",
      "publisherUrl": "https://www.oreilly.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "cdata-connect-ai",
      "name": "CData Connect AI",
      "description": "Managed MCP platform for 350 sources",
      "url": "https://mcp.cloud.cdata.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CData",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "cdata-connect-ai.png",
      "sourceUrl": "https://claude.ai/directory/9df925ce-a2fc-42f1-93dd-748516052caf",
      "publisherUrl": "https://www.cdata.com/ai"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "krisp",
      "name": "Krisp",
      "description": "Add your meetings context via transcripts and notes",
      "url": "https://mcp.krisp.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Krisp",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "krisp.svg",
      "sourceUrl": "https://claude.ai/directory/0543a3d3-3312-440f-ae60-789953179770",
      "publisherUrl": "https://krisp.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "wolfram",
      "name": "Wolfram",
      "description": "Inject precise, real-time computation and knowledge",
      "url": "https://agenttools.wolfram.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Wolfram Research",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "wolfram.svg",
      "sourceUrl": "https://claude.ai/directory/de1d1dc7-ec10-459d-b511-797982834b43",
      "publisherUrl": "https://www.wolfram.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "twelve-data",
      "name": "Twelve Data",
      "description": "Real-time prices, 100+ technical indicators, and fundamentals for stocks, forex, crypto, and ETFs — ask in plain English, no API knowledge needed.",
      "url": "https://mcp.twelvedata.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Twelve Data",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "twelve-data.png",
      "sourceUrl": "https://claude.ai/directory/9d86a6fc-7979-4b69-b827-02769041d57c",
      "publisherUrl": "https://twelvedata.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "v0",
      "name": "v0",
      "description": "Build Full-Stack Web Apps with AI",
      "url": "https://v0.app/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vercel",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "v0.png",
      "sourceUrl": "https://claude.ai/directory/4a42060f-e997-4b2c-bc4b-60c0f417a9e4",
      "publisherUrl": "https://vercel.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "lunarcrush",
      "name": "LunarCrush",
      "description": "Add real-time social media data to your searches",
      "url": "https://lunarcrush.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LunarCrush",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "lunarcrush.png",
      "sourceUrl": "https://claude.ai/directory/837cceff-9820-4510-823f-9bdc5ef21f3a",
      "publisherUrl": "https://lunarcrush.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "inkbox",
      "name": "Inkbox",
      "description": "Email, SMS, and iMessage for AI agents",
      "url": "https://inkbox.ai/mcp/anthropic",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Inkbox",
      "tags": ["communication", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "inkbox.png",
      "sourceUrl": "https://claude.ai/directory/39b95a4e-4c4a-4291-9755-dc8fd38ad7be",
      "publisherUrl": "https://inkbox.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "mintlify",
      "name": "Mintlify",
      "description": "Search, read, and edit your documentation",
      "url": "https://mcp.mintlify.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mintlify",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "mintlify.svg",
      "sourceUrl": "https://claude.ai/directory/b66b1fcc-a173-4cc4-8060-a7cf0e971a9c",
      "publisherUrl": "https://mintlify.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "contentful",
      "name": "Contentful",
      "description": "Manage your content from Claude.",
      "url": "https://mcp.contentful.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Contentful Inc.",
      "tags": ["creative", "developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "contentful.png",
      "sourceUrl": "https://claude.ai/directory/caf98118-2da7-45bd-8ce8-ea7b49220782",
      "publisherUrl": "https://www.contentful.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "quo",
      "name": "Quo",
      "description": "Surface call insights and missed opportunities",
      "url": "https://mcp.quo.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Quo",
      "tags": ["communication"],
      "priority": "P2",
      "logo": "quo.svg",
      "sourceUrl": "https://claude.ai/directory/5b1d1665-4793-4a8c-98cf-909e00e97a29",
      "publisherUrl": "https://quo.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "expensify",
      "name": "Expensify",
      "description": "Search and analyze your Expensify data",
      "url": "https://www.expensify.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Expensify, Inc.",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "expensify.png",
      "sourceUrl": "https://claude.ai/directory/fa0c935a-b6b0-4d4d-ade0-17d227838c56",
      "publisherUrl": "https://www.expensify.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "close",
      "name": "Close",
      "description": "Connect Claude to Close CRM to securely access and act on your sales data",
      "url": "https://mcp.close.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Close",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "close.png",
      "sourceUrl": "https://claude.ai/directory/3e12bb5c-11e5-409c-8e73-64d4b625b498",
      "publisherUrl": "https://www.close.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "contentsquare",
      "name": "Contentsquare",
      "description": "Experience analytics platform for digital businesses",
      "url": "https://api.contentsquare.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Contentsquare",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "contentsquare.png",
      "sourceUrl": "https://claude.ai/directory/385882c7-2b55-4c12-b331-57babd22e643",
      "publisherUrl": "https://www.contentsquare.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "midpage-legal-research",
      "name": "Midpage Legal Research",
      "description": "Conduct legal research and create work product",
      "url": "https://app.midpage.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Midpage",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "midpage-legal-research.png",
      "sourceUrl": "https://claude.ai/directory/1a6a40cd-43c9-4752-9052-fed9c5e8c45c",
      "publisherUrl": "https://www.midpage.ai/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "amass",
      "name": "Amass",
      "description": "Life sciences intelligence, unified — publications, trials, drugs, genes, regulatory approvals, and patents in one cross-linked connector",
      "url": "https://mcp.amass.tech/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Amass technologies Aps",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "amass.png",
      "sourceUrl": "https://claude.ai/directory/6cc00fbf-8b71-47d0-850f-c35013276b97",
      "publisherUrl": "https://amass.tech/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "crustdata",
      "name": "Crustdata",
      "description": "Search and enrich B2B company and people data",
      "url": "https://mcp.crustdata.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Crustdata",
      "tags": ["data-analytics", "developer-tools", "sales-and-marketing"],
      "priority": "P2",
      "logo": "crustdata.png",
      "sourceUrl": "https://claude.ai/directory/f9db3929-fb0b-4f1c-bcce-41d8cf014257",
      "publisherUrl": "https://crustdata.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "teamtailor",
      "name": "Teamtailor",
      "description": "Chat with your recruitment data: jobs, candidates, pipelines, and todos from Teamtailor.",
      "url": "https://mcp.teamtailor.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Teamtailor",
      "tags": ["other", "productivity"],
      "priority": "P2",
      "logo": "teamtailor.svg",
      "sourceUrl": "https://claude.ai/directory/5e72079c-eae5-494c-87a4-d5af7361b7d7",
      "publisherUrl": "https://teamtailor.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "swagger",
      "name": "Swagger",
      "description": "Build, govern, and document APIs",
      "url": "https://swagger.mcp.smartbear.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "SmartBear",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "swagger.svg",
      "sourceUrl": "https://claude.ai/directory/653a5f84-8819-4215-9ba7-9b384eb2ddc2",
      "publisherUrl": "https://smartbear.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "within",
      "name": "Within",
      "description": "Explore your org's processes",
      "url": "https://api.within.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Within",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "within.png",
      "sourceUrl": "https://claude.ai/directory/e49f08f7-f144-484b-86bb-3b1eab7a5602",
      "publisherUrl": "https://www.within.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "common-room",
      "name": "Common Room",
      "description": "Your GTM Copilot",
      "url": "https://mcp.commonroom.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Common Room",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "common-room.svg",
      "sourceUrl": "https://claude.ai/directory/e56221b4-925f-48bb-9176-6cd6e8fae3c1",
      "publisherUrl": "https://commonroom.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "website-generator-by-b12",
      "name": "Website Generator by B12",
      "description": "Build a website or web app in minutes! Generate, design, write code, and create copy for your website. Powered by B12. Contact: hello@b12.io",
      "url": "https://mcp.b12.io/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "B12",
      "tags": ["creative", "developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "website-generator-by-b12.png",
      "sourceUrl": "https://claude.ai/directory/e25b319d-9c6a-4baa-90a3-0bb8eb5e25b0",
      "publisherUrl": "https://www.b12.io/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "mem",
      "name": "Mem",
      "description": "The AI notebook for everything on your mind",
      "url": "https://mcp.mem.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mem Labs, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "mem.svg",
      "sourceUrl": "https://claude.ai/directory/fab5214d-eb35-4038-8271-2a0be421a086",
      "publisherUrl": "https://get.mem.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "fullstory",
      "name": "Fullstory",
      "description": "Product analytics with receipts. Build segments, compute metrics, and analyze conversions from your Fullstory behavioral data. Then pull the real sessions to back it up.",
      "url": "https://api.fullstory.com/mcp/fullstory",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fullstory",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "fullstory.png",
      "sourceUrl": "https://claude.ai/directory/c9be8097-5a98-4c0f-a652-d41b0ed141e5",
      "publisherUrl": "https://www.fullstory.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "moda-slides-and-designs",
      "name": "Moda - Slides and Designs",
      "description": "Fully editable PowerPoints, Meta ads, motion graphics & social.",
      "url": "https://agents.moda.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Moda",
      "tags": ["communication", "creative", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "moda-slides-and-designs.png",
      "sourceUrl": "https://claude.ai/directory/ea86601d-514b-42e4-aefc-32c6c51baf7e",
      "publisherUrl": "https://moda.app/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "lawve-ai",
      "name": "Lawve AI",
      "description": "Discover expert-written skills for legal work",
      "url": "https://mcp.lawve.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lawve AI",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "lawve-ai.png",
      "sourceUrl": "https://claude.ai/directory/afce8e96-04a4-4d3c-9e63-0e47c64468ea",
      "publisherUrl": "https://lawve.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "parallel-search",
      "name": "Parallel Search",
      "description": "Free token-efficient search using Parallel",
      "url": "https://search.parallel.ai/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Parallel Web Systems",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "parallel-search.png",
      "sourceUrl": "https://claude.ai/directory/fe70d12e-aad9-4b33-b5bf-47afede277a3",
      "publisherUrl": "https://parallel.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "harmonic",
      "name": "Harmonic",
      "description": "Discover, research, and enrich companies and people",
      "url": "https://mcp.api.harmonic.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Harmonic",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "harmonic.png",
      "sourceUrl": "https://claude.ai/directory/27e16103-e402-4223-b8b2-a7324bfdebab",
      "publisherUrl": "https://harmonic.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "ubersuggest",
      "name": "Ubersuggest",
      "description": "Keyword research, competitor analysis, backlinks, site audits and AI search visibility — powered by Ubersuggest.",
      "url": "https://ubersuggest-mcp.neilpatelapi.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ubersuggest",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "ubersuggest.png",
      "sourceUrl": "https://claude.ai/directory/412cc075-00c9-44cb-9b59-58438a57819b",
      "publisherUrl": "https://ubersuggest.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "mongodb-atlas",
      "name": "MongoDB Atlas",
      "description": "Manage MongoDB Atlas resources and read & write cluster data",
      "url": "https://mcp.mongodb.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MongoDB",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "mongodb-atlas.png",
      "sourceUrl": "https://claude.ai/directory/c700435a-e86b-41f6-a377-ee226164a909",
      "publisherUrl": "https://mongodb.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "airops",
      "name": "AirOps",
      "description": "Craft content that wins AI search",
      "url": "https://app.airops.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AirOps",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "airops.svg",
      "sourceUrl": "https://claude.ai/directory/3d915617-ebcc-489f-b603-57ec21f7d1d0",
      "publisherUrl": "https://www.airops.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "oxford-economics",
      "name": "Oxford Economics",
      "description": "Access Oxford Economics’ trusted economic analysis and data directly in Claude.",
      "url": "https://services.oxfordeconomics.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Oxford Economics",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "oxford-economics.png",
      "sourceUrl": "https://claude.ai/directory/1bc4c26c-2611-4cb0-8aeb-cd0f93622c2c",
      "publisherUrl": "https://www.oxfordeconomics.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "send",
      "name": "Send",
      "description": "Create HTML in Claude. Share it with Send.",
      "url": "https://www.send.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Send",
      "tags": [
        "communication",
        "creative",
        "data-analytics",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "send.png",
      "sourceUrl": "https://claude.ai/directory/d4b6d94e-8fd7-4936-a525-a1852acd3bb4",
      "publisherUrl": "https://www.send.co/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "yardi-virtuoso",
      "name": "Yardi Virtuoso",
      "description": "Real-time Yardi data & insights",
      "url": "https://mcp.virtuoso.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Yardi",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "yardi-virtuoso.png",
      "sourceUrl": "https://claude.ai/directory/01953ddd-4139-40c5-bbf9-47c1e2499623",
      "publisherUrl": "https://yardi.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "drata",
      "name": "Drata",
      "description": "Agentic Trust Management on demand.",
      "url": "https://mcp.drata.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Drata Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "drata.png",
      "sourceUrl": "https://claude.ai/directory/930ec419-a0ea-4790-8946-88344426d7f8",
      "publisherUrl": "https://drata.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "grain",
      "name": "Grain",
      "description": "Put your meetings to work",
      "url": "https://api.grain.com/_/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Grain",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "grain.svg",
      "sourceUrl": "https://claude.ai/directory/a034aa1a-a6b5-418e-9fa3-43cf80e2a611",
      "publisherUrl": "https://grain.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "runway-runway-team",
      "name": "Runway (runway.team)",
      "description": "Automate, coordinate, and monitor your team's mobile app releases.",
      "url": "https://mcp.runway.team/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Runway (runway.team)",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "runway-runway-team.png",
      "sourceUrl": "https://claude.ai/directory/d884a8ac-514d-4551-9d63-ccacf958c008",
      "publisherUrl": "https://www.runway.team/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "monte-carlo",
      "name": "Monte Carlo",
      "description": "Data & AI observability",
      "url": "https://mcp.getmontecarlo.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Monte Carlo",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "monte-carlo.png",
      "sourceUrl": "https://claude.ai/directory/54c8ca93-5e6e-4f30-89ca-207c3d3a438b",
      "publisherUrl": "https://www.montecarlodata.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "qonto",
      "name": "Qonto",
      "description": "Manage your Qonto business finances from Claude",
      "url": "https://mcp.qonto.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Qonto",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "qonto.svg",
      "sourceUrl": "https://claude.ai/directory/56de4854-49c8-4f8f-a53a-4badef6a472f",
      "publisherUrl": "https://qonto.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "expo",
      "name": "Expo",
      "description": "Build, ship, and monitor apps with Expo",
      "url": "https://mcp.expo.dev/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Expo",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "expo.png",
      "sourceUrl": "https://claude.ai/directory/8717a405-6e93-47c1-929d-9da08129290d",
      "publisherUrl": "https://expo.dev/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "magic-patterns",
      "name": "Magic Patterns",
      "description": "Discuss and iterate on Magic Patterns designs",
      "url": "https://mcp.magicpatterns.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Magic Patterns",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "magic-patterns.png",
      "sourceUrl": "https://claude.ai/directory/088e0355-cb01-44fa-ba0b-23525fde8d5a",
      "publisherUrl": "https://www.magicpatterns.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "adspirer",
      "name": "Adspirer",
      "description": "Your performance marketing and paid media agent — an Agent that plans, launches, and autonomously runs your ad campaigns across Google, Meta, LinkedIn, TikTok, and more.",
      "url": "https://mcp.adspirer.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adspirer",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "adspirer.png",
      "sourceUrl": "https://claude.ai/directory/cd33c38a-66e7-41a4-8777-bec24d4bba3a",
      "publisherUrl": "https://www.adspirer.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "agentmail",
      "name": "AgentMail",
      "description": "Email inboxes for AI agents",
      "url": "https://mcp.agentmail.to/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AgentMail, Inc.",
      "tags": ["communication", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "agentmail.png",
      "sourceUrl": "https://claude.ai/directory/a99a3b09-26fc-4251-a412-fa2593123267",
      "publisherUrl": "https://www.agentmail.to/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "gem",
      "name": "Gem",
      "description": "Access, analyze, and manage your Gem data in Claude",
      "url": "https://mcp.gem.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gem",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "gem.svg",
      "sourceUrl": "https://claude.ai/directory/14499861-17c1-44c7-9d9e-2266ac4d04bf",
      "publisherUrl": "https://www.gem.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "greenhouse",
      "name": "Greenhouse",
      "description": "Connect Claude to Greenhouse. Search, analyze and update candidates, applications, jobs, interviews, scorecards, offers and more in plain language.",
      "url": "https://mcp.greenhouse.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Greenhouse Software, Inc.",
      "tags": ["communication", "data-analytics", "developer-tools", "other", "productivity"],
      "priority": "P2",
      "logo": "greenhouse.png",
      "sourceUrl": "https://claude.ai/directory/7da178a3-8f92-41a0-a823-89a89125e562",
      "publisherUrl": "https://www.greenhouse.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "brightdeck",
      "name": "Brightdeck",
      "description": "Create presentations and slides, compatible with PowerPoint",
      "url": "https://api.brightdeck.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Brightdeck",
      "tags": ["communication", "creative", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "brightdeck.png",
      "sourceUrl": "https://claude.ai/directory/c0a11a21-c9c7-4b10-9118-629035443c7b",
      "publisherUrl": "https://brightdeck.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "eraser",
      "name": "Eraser",
      "description": "Generate, manage, and update Eraser diagrams and files",
      "url": "https://app.eraser.io/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Eraser",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "eraser.svg",
      "sourceUrl": "https://claude.ai/directory/7643fc71-6be5-4bc1-8001-10d45239078d",
      "publisherUrl": "https://eraser.io/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "coralogix",
      "name": "Coralogix",
      "description": "Explore and debug your Coralogix observability data",
      "url": "https://api.eu2.coralogix.com/mgmt/api/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Coralogix",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "coralogix.svg",
      "sourceUrl": "https://claude.ai/directory/a1d8f399-3c9f-44ca-aa70-8959be5c9f9c",
      "publisherUrl": "https://coralogix.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "evernote",
      "name": "Evernote",
      "description": "Connect Evernote to search, edit, and organize your notes, create new ones, and bring your knowledge into every conversation.",
      "url": "https://mcp.evernote.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Evernote",
      "tags": ["communication", "creative", "education", "productivity"],
      "priority": "P2",
      "logo": "evernote.png",
      "sourceUrl": "https://claude.ai/directory/5c2ae4c2-535f-4a19-a45f-a23493f28b4e",
      "publisherUrl": "https://evernote.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "fiscal-ai",
      "name": "Fiscal.ai",
      "description": "Clean Public Equity Fundamental Data",
      "url": "https://api.fiscal.ai/mcp/sse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fiscal.ai",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "fiscal-ai.svg",
      "sourceUrl": "https://claude.ai/directory/9620ff48-f0d9-4f7f-bda0-4d7240894538",
      "publisherUrl": "https://fiscal.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "letsbot",
      "name": "LetsBot",
      "description": "Manage your Letsbot conversations and get smart reports",
      "url": "https://letsbot.net/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "BOT FOR DIGITAL SOLUTIONS LIMITED",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "letsbot.svg",
      "sourceUrl": "https://claude.ai/directory/3455d00e-518f-425f-9e0d-6a9eac2f54ef",
      "publisherUrl": "https://letsbot.net/en/home.html"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "openseo",
      "name": "OpenSEO",
      "description": "SEO made simple.",
      "url": "https://app.openseo.so/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "OpenSEO",
      "tags": ["developer-tools", "sales-and-marketing"],
      "priority": "P2",
      "logo": "openseo.png",
      "sourceUrl": "https://claude.ai/directory/3d15fac7-4fc6-4aaf-9b4e-9abfa46f7b31",
      "publisherUrl": "https://openseo.so/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "readwise",
      "name": "Readwise",
      "description": "Save, read, search, and learn",
      "url": "https://mcp2.readwise.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Readwise Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "readwise.png",
      "sourceUrl": "https://claude.ai/directory/1bdc2099-1cf5-4b5e-bf03-76ca9c6c6248",
      "publisherUrl": "https://readwise.io/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "motherduck",
      "name": "MotherDuck",
      "description": "Get answers from your data",
      "url": "https://api.motherduck.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MotherDuck Corporation",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "motherduck.svg",
      "sourceUrl": "https://claude.ai/directory/0929a5c7-38ce-40ab-8aad-af9ce34553c7",
      "publisherUrl": "https://motherduck.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "local-falcon",
      "name": "Local Falcon",
      "description": "AI visibility and local search intelligence platform",
      "url": "https://mcp.localfalcon.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Local Falcon",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "local-falcon.svg",
      "sourceUrl": "https://claude.ai/directory/30b72fda-c127-4a95-b7a3-f18476e0a06f",
      "publisherUrl": "https://www.localfalcon.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "chronograph",
      "name": "Chronograph",
      "description": "Interact with your Chronograph data directly in Claude",
      "url": "https://ai.chronograph.pe/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Chronograph",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "chronograph.png",
      "sourceUrl": "https://claude.ai/directory/01744591-790c-471b-9452-f338eff230af",
      "publisherUrl": "https://www.chronograph.pe/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "tropic",
      "name": "Tropic",
      "description": "Save money on Software + AI contracts",
      "url": "https://app.tropicapp.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tropic",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "tropic.svg",
      "sourceUrl": "https://claude.ai/directory/1561bc95-0862-4c90-8720-6ac8d683340e",
      "publisherUrl": "https://www.tropicapp.io/mcp-demo"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "meridian-connector-for-quickbooks",
      "name": "Meridian Connector for QuickBooks",
      "description": "Make changes to QuickBooks Online from within Claude.",
      "url": "https://qbo-connector.meridian.pilot.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pilot.com, Inc.",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "meridian-connector-for-quickbooks.png",
      "sourceUrl": "https://claude.ai/directory/72e8740e-8922-4d91-a850-d4d47d3f8ab4",
      "publisherUrl": "https://meridian.pilot.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "snomed-ct-terminology",
      "name": "SNOMED CT Terminology",
      "description": "Search, validate, and expand SNOMED CT concepts, directly from SNOMED International",
      "url": "https://snowstorm-mcp.snomedtools.org/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "SNOMED International",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "snomed-ct-terminology.png",
      "sourceUrl": "https://claude.ai/directory/b07954c3-84df-4843-b861-6229435ce9e3",
      "publisherUrl": "https://snomed.org/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "aiera",
      "name": "Aiera",
      "description": "Live events, filings, company publications, and more",
      "url": "https://mcp-pub.aiera.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Aiera",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "aiera.png",
      "sourceUrl": "https://claude.ai/directory/4ef6cb78-9212-4b0e-b067-bb30e4d27a6f",
      "publisherUrl": "https://www.aiera.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "circleback",
      "name": "Circleback",
      "description": "Search and access context from meetings",
      "url": "https://circleback.ai/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Circleback",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "circleback.png",
      "sourceUrl": "https://claude.ai/directory/91c3f3e4-8c61-4f73-b912-96d035f69f24",
      "publisherUrl": "https://circleback.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "speko",
      "name": "Speko",
      "description": "Make phone calls, transcribe audio, and narrate text.",
      "url": "https://mcp.speko.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Speko",
      "tags": ["communication", "developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "speko.png",
      "sourceUrl": "https://claude.ai/directory/e70653f5-76ec-4712-b8d7-8454ebf955c1",
      "publisherUrl": "https://speko.ai/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "netdocuments",
      "name": "NetDocuments",
      "description": "Securely access your documents in NetDocuments",
      "url": "https://web-api.us.netdocuments.app/connect/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "NetDocuments",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "netdocuments.svg",
      "sourceUrl": "https://claude.ai/directory/de658515-71ab-4e82-bf83-0677cbc2f6cd",
      "publisherUrl": "https://www.netdocuments.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "enterpret",
      "name": "Enterpret",
      "description": "Get answers from unified feedback of your customers.",
      "url": "https://wisdom-api.enterpret.com/server/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Enterpret Inc",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "enterpret.svg",
      "sourceUrl": "https://claude.ai/directory/ce5cb342-4965-4ab1-b725-48ba06b72bbc",
      "publisherUrl": "https://enterpret.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "bird",
      "name": "Bird",
      "description": "Send email, SMS, and WhatsApp, place calls, verify users, and run your agent's inbox",
      "url": "https://mcp.bird.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bird",
      "tags": ["communication", "developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "bird.svg",
      "sourceUrl": "https://claude.ai/directory/d5656e8b-eb8b-4d79-ad06-9c8556f9f7f8",
      "publisherUrl": "https://www.bird.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "pdf-net",
      "name": "PDF.net",
      "description": "Generate and edit pdfs",
      "url": "https://mcp.pdf.net/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PDF.net",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "pdf-net.png",
      "sourceUrl": "https://claude.ai/directory/3e426783-a80c-4b53-9287-584f5c9557f5",
      "publisherUrl": "https://pdf.net/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "ibisworld",
      "name": "IBISWorld",
      "description": "Financials, risk data and analysis on 50,000 industries",
      "url": "https://mcp.ibisworld.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "IBISWorld",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "ibisworld.svg",
      "sourceUrl": "https://claude.ai/directory/fa7af7d8-e1b2-4c8f-83f9-d2936bdc0aa7",
      "publisherUrl": "https://www.ibisworld.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "sumble",
      "name": "Sumble",
      "description": "Deep research any account's teams, tech, and people",
      "url": "https://mcp.sumble.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sumble, Inc",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "sumble.png",
      "sourceUrl": "https://claude.ai/directory/cec39b4a-ee57-40e4-be4e-0e9ceddcb4a0",
      "publisherUrl": "https://sumble.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "have-i-been-pwned",
      "name": "Have I Been Pwned",
      "description": "Check email addresses and domains for data breaches",
      "url": "https://haveibeenpwned.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Have I Been Pwned",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "have-i-been-pwned.svg",
      "sourceUrl": "https://claude.ai/directory/da758d89-9c8b-4f6c-a5bf-65eb14b9fc21",
      "publisherUrl": "https://haveibeenpwned.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "shutterstock",
      "name": "Shutterstock",
      "description": "Spark ideas with Shutterstock",
      "url": "https://www.shutterstock.com/cciq/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Shutterstock",
      "tags": ["creative", "sales-and-marketing"],
      "priority": "P2",
      "logo": "shutterstock.png",
      "sourceUrl": "https://claude.ai/directory/e7da5cf7-cfea-4ee4-a61b-8da6ae48594f",
      "publisherUrl": "https://www.shutterstock.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "fyxer",
      "name": "Fyxer",
      "description": "Search your inbox, and draft replies in your voice",
      "url": "https://app.fyxer.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fyxer",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "fyxer.png",
      "sourceUrl": "https://claude.ai/directory/69feb637-7aa9-48f1-9443-71b881c0167c",
      "publisherUrl": "https://www.fyxer.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "attention",
      "name": "Attention",
      "description": "Search, analyze, and act on client conversations",
      "url": "https://api.attention.tech/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Attention",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "attention.svg",
      "sourceUrl": "https://claude.ai/directory/352baac0-d2ab-4458-ba9a-85bf162f0980",
      "publisherUrl": "https://attention.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "financial-datasets",
      "name": "Financial Datasets",
      "description": "Access stock market data",
      "url": "https://mcp.financialdatasets.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Financial Datasets, Inc.",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "financial-datasets.png",
      "sourceUrl": "https://claude.ai/directory/c6bd5a29-89cc-4b2b-a5e4-3b58363c58c1",
      "publisherUrl": "https://www.financialdatasets.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "glg",
      "name": "GLG",
      "description": "Expert intelligence, instantly in your workflow",
      "url": "https://mcp.glgresearch.com/myglg/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gerson Lehrman Group",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "glg.png",
      "sourceUrl": "https://claude.ai/directory/e6b925d6-dee4-4f11-baa8-0248a7830f94",
      "publisherUrl": "https://glg.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "rocketreach",
      "name": "RocketReach",
      "description": "Verified work emails and phones from 700M+ contacts",
      "url": "https://mcp.rocketreach.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "RocketReach",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "rocketreach.png",
      "sourceUrl": "https://claude.ai/directory/75cd1115-5e2a-4172-b848-04fcdef7426d",
      "publisherUrl": "https://rocketreach.co/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "sandp-global-adaptive-retrieval",
      "name": "S&P Global - Adaptive Retrieval",
      "description": "Flexible data access for complex workflows",
      "url": "https://grounding.kensho.com/integrations/v2/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "S&P Global",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "sandp-global-adaptive-retrieval.png",
      "sourceUrl": "https://claude.ai/directory/8c7d2d59-39e6-4013-a88c-93daea04d49c",
      "publisherUrl": "https://www.spglobal.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "anythingmcp",
      "name": "AnythingMCP",
      "description": "Connect Claude to SAP, weclapp, DATEV, Odoo, Etsy, Shopware, Billbee, Sendcloud, Deutsche Bahn, Telegram, Bundesbank & 180+ business APIs — or turn any REST, SOAP, GraphQL or SQL API into MCP tools.",
      "url": "https://cloud.anythingmcp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "helpcode.ai",
      "tags": [
        "data-analytics",
        "developer-tools",
        "financial-services",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "anythingmcp.png",
      "sourceUrl": "https://claude.ai/directory/5940dec3-cae5-48f8-9312-d8b17abda129",
      "publisherUrl": "https://helpcode.ai/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "candid",
      "name": "Candid",
      "description": "Research nonprofits and funders using Candid's data",
      "url": "https://mcp.candid.org/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Candid",
      "tags": ["nonprofit"],
      "priority": "P2",
      "logo": "candid.svg",
      "sourceUrl": "https://claude.ai/directory/875faf93-08c4-469c-980f-6f79f70f10d3",
      "publisherUrl": "https://candid.org/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "openrush",
      "name": "OpenRush",
      "description": "SEO and competitor analysis with live search data: keyword research, rank tracking, gap analysis, and site audits",
      "url": "https://api.openrush.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "OpenRush",
      "tags": ["commerce-shopping", "data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "openrush.png",
      "sourceUrl": "https://claude.ai/directory/9af032f3-e69f-4789-b456-1e2f276eb2c8",
      "publisherUrl": "https://openrush.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "workos",
      "name": "WorkOS",
      "description": "Manage your WorkOS workspace from Claude",
      "url": "https://mcp.workos.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "WorkOS",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "workos.png",
      "sourceUrl": "https://claude.ai/directory/d3b03e81-aeaa-42bf-9c52-5270d5273b2d",
      "publisherUrl": "https://workos.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "demographic-and-health-surveys",
      "name": "Demographic and Health Surveys",
      "description": "Data from The Demographic and Health Surveys Program",
      "url": "https://api.dhsprogram.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ICF",
      "tags": ["consumer-health"],
      "priority": "P2",
      "logo": "demographic-and-health-surveys.png",
      "sourceUrl": "https://claude.ai/directory/9e5b81c6-d26f-43bb-9425-2d132ccdea40",
      "publisherUrl": "https://dhsprogram.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "ticket-tailor",
      "name": "Ticket Tailor",
      "description": "Event platform for managing tickets, orders & more",
      "url": "https://mcp.tickettailor.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ticket Tailor",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "ticket-tailor.png",
      "sourceUrl": "https://claude.ai/directory/7a28094f-541d-4ef8-89e2-6abc653d77a2",
      "publisherUrl": "https://www.tickettailor.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "brandfetch",
      "name": "Brandfetch",
      "description": "Make everything Claude creates on-brand",
      "url": "https://mcp.brandfetch.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Brandfetch",
      "tags": ["communication", "creative", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "brandfetch.png",
      "sourceUrl": "https://claude.ai/directory/76d2c5db-e971-4091-8901-ddb66088956c",
      "publisherUrl": "https://brandfetch.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "kit",
      "name": "Kit",
      "description": "Search, analyze, draft, and manage your email marketing",
      "url": "https://app.kit.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Kit, Inc.",
      "tags": ["communication", "data-analytics", "productivity"],
      "priority": "P2",
      "logo": "kit.png",
      "sourceUrl": "https://claude.ai/directory/700d102e-5a17-44c8-b715-5db9cca82105",
      "publisherUrl": "https://kit.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "datahub",
      "name": "DataHub",
      "description": "Connect AI agents to enterprise data & context",
      "url": "https://mcp.datahub.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Acryl Data, Inc.",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "datahub.svg",
      "sourceUrl": "https://claude.ai/directory/5ccb820e-419d-4683-9646-90ea294ada71",
      "publisherUrl": "https://datahub.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "flourish",
      "name": "Flourish",
      "description": "Turn data into interactive charts you can edit",
      "url": "https://app.flourish.studio/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Flourish",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "flourish.png",
      "sourceUrl": "https://claude.ai/directory/ebd57d53-3d93-4981-831b-d6648dbc87a4",
      "publisherUrl": "https://flourish.studio/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "plaid-developer-tools",
      "name": "Plaid Developer Tools",
      "description": "Monitor, debug, and optimize your Plaid integration",
      "url": "https://api.dashboard.plaid.com/mcp/sse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Plaid",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "plaid-developer-tools.png",
      "sourceUrl": "https://claude.ai/directory/bacac1ad-ccb1-401e-a5d7-915da9742dce",
      "publisherUrl": "https://plaid.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "unwrap",
      "name": "Unwrap",
      "description": "Search and analyze customer feedback",
      "url": "https://nlp.api.production.unwrap.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Unwrap AI",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "unwrap.svg",
      "sourceUrl": "https://claude.ai/directory/92d00407-7fa7-49bc-8d90-55a59434099c",
      "publisherUrl": "https://www.unwrap.ai/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "orshot",
      "name": "Orshot",
      "description": "Automate Videos, PDFs and Images from templates for marketing, post to social platforms, and track and grow engagement",
      "url": "https://mcp.orshot.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Orshot",
      "tags": ["creative", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "orshot.png",
      "sourceUrl": "https://claude.ai/directory/68b8b4d0-aaec-416a-9bcf-4d2ff3bf7142",
      "publisherUrl": "https://orshot.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "blockscout",
      "name": "Blockscout",
      "description": "Access and analyze blockchain data",
      "url": "https://mcp.blockscout.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Blockscout",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "blockscout.png",
      "sourceUrl": "https://claude.ai/directory/48425fdb-37c1-408d-9606-30e16847b6a8",
      "publisherUrl": "https://www.blockscout.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "helena-by-enrich-labs",
      "name": "Helena by Enrich Labs",
      "description": "Your AI marketer for paid ads, SEO, email, social, and analytics",
      "url": "https://agent.enrichlabs.ai/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Enrich Labs",
      "tags": ["commerce-shopping", "creative", "sales-and-marketing"],
      "priority": "P2",
      "logo": "helena-by-enrich-labs.png",
      "sourceUrl": "https://claude.ai/directory/0da6abdc-62c3-4272-940b-898189371a48",
      "publisherUrl": "https://www.enrichlabs.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "text-to-quant",
      "name": "TEXT TO QUANT",
      "description": "Backtest trading strategies written in plain English on real market data, with graded, honesty flagged reports.",
      "url": "https://www.texttoquant.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Spekule",
      "tags": ["data-analytics", "developer-tools", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "text-to-quant.png",
      "sourceUrl": "https://claude.ai/directory/85a9449d-5331-4bec-8219-1fd94823c94d",
      "publisherUrl": "https://www.texttoquant.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "autosheet",
      "name": "Autosheet",
      "description": "Agent for Google Sheets work",
      "url": "https://mcp.autosheet.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Talarian",
      "tags": [
        "commerce-shopping",
        "data-analytics",
        "financial-services",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "autosheet.png",
      "sourceUrl": "https://claude.ai/directory/4b8d4ae0-c655-47ca-ae59-296a2416763b",
      "publisherUrl": "https://talarian.io/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "aleph",
      "name": "Aleph",
      "description": "Ask, analyze, act on FP&A data",
      "url": "https://mcp.getaleph.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Aleph",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "aleph.png",
      "sourceUrl": "https://claude.ai/directory/b14690cb-5720-4b14-be27-bde7bc859aeb",
      "publisherUrl": "https://getaleph.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "maven-bio",
      "name": "Maven Bio",
      "description": "Biopharma catalysts, pipelines, trials, deals, and the citable primary sources behind them",
      "url": "https://mcp.mavenbio.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Maven Bio",
      "tags": ["data-analytics", "health-life-sciences", "productivity"],
      "priority": "P2",
      "logo": "maven-bio.png",
      "sourceUrl": "https://claude.ai/directory/f5a911e0-39a7-4dc3-bbde-fb9b6b2aaa02",
      "publisherUrl": "https://mavenbio.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "crunchbase",
      "name": "Crunchbase",
      "description": "Access reliable company data, market signals, and forward-looking predictions to research organizations, compare performance, uncover emerging trends, and make faster, more informed business decisions",
      "url": "https://mcp.crunchbase.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Crunchbase",
      "tags": ["data-analytics", "financial-services", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "crunchbase.png",
      "sourceUrl": "https://claude.ai/directory/81b11acd-1115-4354-9142-91e2a2c13b0b",
      "publisherUrl": "https://www.crunchbase.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "signnow",
      "name": "SignNow",
      "description": "Automate eSignature workflows directly from Claude",
      "url": "https://mcp-server.signnow.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "airSlate Inc",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "signnow.svg",
      "sourceUrl": "https://claude.ai/directory/4bf06559-36bf-4aab-b7f7-360af4e2db86",
      "publisherUrl": "https://www.airslate.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "cortellis-cmc-intelligence",
      "name": "Cortellis CMC Intelligence",
      "description": "Trusted regulatory CMC insights, powered by Clarivate’s Cortellis CMC Intelligence.",
      "url": "https://api.clarivate.com/lifesciences/mcp-cmc/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Clarivate",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "cortellis-cmc-intelligence.png",
      "sourceUrl": "https://claude.ai/directory/6d85e32b-e41b-44bc-b451-aa020b7640b1",
      "publisherUrl": "https://clarivate.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "taplio",
      "name": "Taplio",
      "description": "Run your LinkedIn by talking to Claude. Schedule content, pull inspiration from 5M+ viral posts, and get your analytics as plain answers.",
      "url": "https://mcp.taplio.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Taplio",
      "tags": ["communication", "media-entertainment", "sales-and-marketing"],
      "priority": "P2",
      "logo": "taplio.svg",
      "sourceUrl": "https://claude.ai/directory/24cb9436-8e07-42ce-b2d9-cd921bf9d45c",
      "publisherUrl": "https://taplio.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "listen-labs",
      "name": "Listen Labs",
      "description": "Analyze user insights from Listen Labs",
      "url": "https://listenlabs.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Listen Labs",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "listen-labs.svg",
      "sourceUrl": "https://claude.ai/directory/6d886b6e-cc36-4ba2-a6c4-4d2d3b7a352b",
      "publisherUrl": "https://listenlabs.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "rillet",
      "name": "Rillet",
      "description": "Query your live GL and financials in plain English",
      "url": "https://api.rillet.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Rillet",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "rillet.svg",
      "sourceUrl": "https://claude.ai/directory/48437749-3dd3-4811-b0d5-80984473903d",
      "publisherUrl": "https://www.rillet.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "macaly-cloud",
      "name": "Macaly Cloud",
      "description": "Claude writes the code, Macaly runs it - a git repo, cloud sandbox, database, live preview and production hosting for the apps you build in chat.",
      "url": "https://www.macaly.com/api/cloud/claude/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Macaly",
      "tags": ["creative", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "macaly-cloud.png",
      "sourceUrl": "https://claude.ai/directory/db272bc3-0c46-43e9-bb09-3562f9965014",
      "publisherUrl": "https://macaly.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "yardi-matrix",
      "name": "Yardi Matrix",
      "description": "Real estate market intelligence from Yardi Matrix",
      "url": "https://matrixmcp.virtuoso.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Yardi Systems Inc",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "yardi-matrix.png",
      "sourceUrl": "https://claude.ai/directory/2b245db2-8a73-491a-9849-8f44b9ce9488",
      "publisherUrl": "https://www.yardi.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "reclaim-ai",
      "name": "Reclaim.ai",
      "description": "Advanced scheduling for personal and work calendars",
      "url": "https://mcp.reclaim.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Reclaim.ai",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "reclaim-ai.png",
      "sourceUrl": "https://claude.ai/directory/71019906-2fd6-4e40-bb97-be3323375265",
      "publisherUrl": "https://reclaim.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "thoughtspot-spotter",
      "name": "ThoughtSpot Spotter",
      "description": "Your AI data analyst, from question to trusted insights",
      "url": "https://agent.thoughtspot.app/mcp?api-version=latest",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ThoughtSpot",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "thoughtspot-spotter.svg",
      "sourceUrl": "https://claude.ai/directory/576048a9-f4be-43c6-8cdb-787897c49b03",
      "publisherUrl": "https://www.thoughtspot.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "ontra",
      "name": "Ontra",
      "description": "Query your Ontra data directly from any AI tool",
      "url": "https://mcp.ontra.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ontra",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "ontra.svg",
      "sourceUrl": "https://claude.ai/directory/44c1fc8d-e5df-4846-be1d-a57db7070783",
      "publisherUrl": "https://www.ontra.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "mem0",
      "name": "Mem0",
      "description": "Persistent memory for AI agents & assistants",
      "url": "https://mcp.mem0.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mem0",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "mem0.svg",
      "sourceUrl": "https://claude.ai/directory/3119bc71-0dfd-48f8-a764-c2fca895325c",
      "publisherUrl": "https://mem0.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "rippit",
      "name": "Rippit",
      "description": "Run dynamic AI analysis on 100% of conversations",
      "url": "https://mcp.rippit.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "rippit",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "rippit.png",
      "sourceUrl": "https://claude.ai/directory/0659bf76-65d6-4ff8-94d1-a79f8a5327a5",
      "publisherUrl": "https://www.rippit.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "jasper",
      "name": "Jasper",
      "description": "Keep every Claude session on-brand",
      "url": "https://mcp.jasper.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jasper",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "jasper.svg",
      "sourceUrl": "https://claude.ai/directory/72bd46ed-02ea-4078-9295-17eab38c514c",
      "publisherUrl": "https://jasper.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "ringcentral-chat",
      "name": "RingCentral Chat",
      "description": "Stay on top of team communications and collaborate in RingCentral Team Chat directly within Claude.",
      "url": "https://mcp.labs.ringcentral.com/ringex/v1.1.0/team-chat",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "RingCentral, Inc.",
      "tags": ["communication"],
      "priority": "P2",
      "logo": "ringcentral-chat.png",
      "sourceUrl": "https://claude.ai/directory/f962df79-31ce-4f9f-b8dc-d2840a2e58f2",
      "publisherUrl": "https://ringcentral.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "felt-maps",
      "name": "Felt Maps",
      "description": "Map and analyze your geospatial data",
      "url": "https://felt.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Felt Maps",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "felt-maps.svg",
      "sourceUrl": "https://claude.ai/directory/9133bf4a-0a23-402b-8b04-bd0a400fd5f9",
      "publisherUrl": "https://felt.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "remote",
      "name": "Remote",
      "description": "Connect any AI to your Remote employment infrastructure",
      "url": "https://mcp.remote.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Remote Technology Services, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "remote.png",
      "sourceUrl": "https://claude.ai/directory/4a3dc72b-b8f6-4654-ac43-ad060b89bbf9",
      "publisherUrl": "https://remote.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "general-legal",
      "name": "General Legal",
      "description": "Submit contracts for attorney review, answer their questions, and get redlined documents back — without leaving Claude.",
      "url": "https://mcp.general.legal/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "General Legal",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "general-legal.png",
      "sourceUrl": "https://claude.ai/directory/dba73da3-6015-4b3e-8acc-0ff38e2c511b",
      "publisherUrl": "https://general.legal/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "phoenix-by-hg-insights",
      "name": "Phoenix by HG Insights",
      "description": "AI-powered B2B data intelligence & analytics",
      "url": "https://phoenix.hginsights.com/api/ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "HG Insights",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P2",
      "logo": "phoenix-by-hg-insights.svg",
      "sourceUrl": "https://claude.ai/directory/0796df0d-3911-42f6-b47d-9b1c8b259300",
      "publisherUrl": "https://hginsights.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "trellis",
      "name": "Trellis",
      "description": "Claude for Trial Court Litigators",
      "url": "https://mcp.trellis.law/anthropic",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Trellis",
      "tags": ["data-analytics", "legal", "productivity"],
      "priority": "P2",
      "logo": "trellis.svg",
      "sourceUrl": "https://claude.ai/directory/0a45d87b-7a46-4e43-a0ce-113eb0e9f002",
      "publisherUrl": "https://trellis.law/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "seamless",
      "name": "Seamless",
      "description": "Find leads and automate outreach",
      "url": "https://mcp.seamless.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Seamless",
      "tags": [
        "communication",
        "data-analytics",
        "developer-tools",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "seamless.png",
      "sourceUrl": "https://claude.ai/directory/1f689250-b58b-435c-8a60-2080b5d6b133",
      "publisherUrl": "https://seamless.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "vaisala-xweather",
      "name": "Vaisala Xweather",
      "description": "Access real-time, forecast, and historical weather.",
      "url": "https://mcp.api.xweather.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vaisala Xweather",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P2",
      "logo": "vaisala-xweather.png",
      "sourceUrl": "https://claude.ai/directory/295db52b-93db-4429-a489-2be633d33249",
      "publisherUrl": "https://xweather.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "razorpay",
      "name": "Razorpay",
      "description": "Turn Claude into your Razorpay Dashboard Assistant",
      "url": "https://mcp.razorpay.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Razorpay Software Private Limited",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "razorpay.png",
      "sourceUrl": "https://claude.ai/directory/c4259182-2a73-4a5f-91ab-0867a3eade9d",
      "publisherUrl": "https://razorpay.com/about/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "granted",
      "name": "Granted",
      "description": "Discover every grant opportunity in existence.",
      "url": "https://grantedai.com/api/mcp/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Granted AI",
      "tags": ["nonprofit"],
      "priority": "P2",
      "logo": "granted.png",
      "sourceUrl": "https://claude.ai/directory/59156499-2b9f-42b9-8438-8994d7ce5dad",
      "publisherUrl": "https://grantedai.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "circleci",
      "name": "CircleCI",
      "description": "Manage CI/CD pipelines, debug failed builds, and optimize test suites directly from Claude - no terminal required.",
      "url": "https://mcp.circleci.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CircleCI Engineering",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "circleci.png",
      "sourceUrl": "https://claude.ai/directory/09103c21-59c7-480e-8fb4-69914bfa311e",
      "publisherUrl": "https://circleci.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "brightflag",
      "name": "Brightflag",
      "description": "Connect to Brightflag to interact with matter, vendor and spend data within Claude.",
      "url": "https://mcp-us.brightflag.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Brightflag",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "brightflag.png",
      "sourceUrl": "https://claude.ai/directory/707aed89-3a32-4fe9-a8e2-7d44232ac160",
      "publisherUrl": "https://brightflag.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "govtribe",
      "name": "GovTribe",
      "description": "Search government procurement & spending data",
      "url": "https://govtribe.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Government Executive Media Group LLC",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "govtribe.svg",
      "sourceUrl": "https://claude.ai/directory/f40e6edf-6955-4810-848b-19d98b2f4f4e",
      "publisherUrl": "https://govtribe.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "planetscale",
      "name": "PlanetScale",
      "description": "Authenticated access to your Postgres and MySQL DB's",
      "url": "https://mcp.pscale.dev/mcp/planetscale",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PlanetScale",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "planetscale.png",
      "sourceUrl": "https://claude.ai/directory/97efeba5-ffd8-4b9c-a1d9-35978d0fdb9f",
      "publisherUrl": "https://planetscale.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "paxton-legal-research",
      "name": "Paxton Legal Research",
      "description": "Research U.S. law in Claude—with citations you can open and verify.",
      "url": "https://paxton-mcp-connector-xmfvvq3waa-uc.a.run.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Paxton",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "paxton-legal-research.png",
      "sourceUrl": "https://claude.ai/directory/4285c08a-451c-46e7-a320-7ccc0d6447b1",
      "publisherUrl": "https://www.paxton.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "unblocked",
      "name": "Unblocked",
      "description": "Bring full context to every agent and AI tools",
      "url": "https://getunblocked.com/api/mcpsse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Unblocked",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "unblocked.png",
      "sourceUrl": "https://claude.ai/directory/1b8a4683-0406-4864-a170-7dca2a255200",
      "publisherUrl": "https://getunblocked.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "coinmarketcap",
      "name": "CoinMarketCap",
      "description": "Real-time crypto market and on-chain data analysis",
      "url": "https://mcp.coinmarketcap.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CoinMarketCap",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "coinmarketcap.png",
      "sourceUrl": "https://claude.ai/directory/bd037f04-e12e-4ca0-879d-21576f188fa7",
      "publisherUrl": "https://coinmarketcap.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "perspective-ai",
      "name": "Perspective AI",
      "description": "An AI Concierge that turns forms into conversations",
      "url": "https://getperspective.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Perspective AI",
      "tags": [
        "communication",
        "creative",
        "data-analytics",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "perspective-ai.png",
      "sourceUrl": "https://claude.ai/directory/ac16a66e-c876-4447-a723-cfa55a3bce1b",
      "publisherUrl": "https://getperspective.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "jotform-sign",
      "name": "Jotform Sign",
      "description": "Create, share, and edit e-signature documents right inside Claude",
      "url": "https://mcp.jotform.com/mcp-sign-v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jotform",
      "tags": ["education", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "jotform-sign.png",
      "sourceUrl": "https://claude.ai/directory/c8e5e99b-788d-4e64-bf4d-ef65b4cb92d5",
      "publisherUrl": "https://www.jotform.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "fibery",
      "name": "Fibery",
      "description": "Build your modular workspace with Claude: describe any process, from roadmaps and CRM to hiring and OKRs, and get it set up in Fibery, a work platform for orgs run by nerds",
      "url": "https://mcp.fibery.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fibery",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "fibery.svg",
      "sourceUrl": "https://claude.ai/directory/446b6256-cdd8-4ef8-be10-203ebc22d1d7",
      "publisherUrl": "https://fibery.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "rootly",
      "name": "Rootly",
      "description": "Connect AI agents to Rootly for incident management, on-call, and reliability data",
      "url": "https://mcp.rootly.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Rootly",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "rootly.png",
      "sourceUrl": "https://claude.ai/directory/df7a5ffa-5d49-4b4b-9a69-911f927fb65d",
      "publisherUrl": "https://rootly.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "campfire",
      "name": "Campfire",
      "description": "Search, analyze, and export Campfire data",
      "url": "https://api.meetcampfire.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Campfire",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "campfire.png",
      "sourceUrl": "https://claude.ai/directory/ccafdad0-bc2b-46fe-b10b-f193d9baa64a",
      "publisherUrl": "https://campfire.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "sybill",
      "name": "Sybill",
      "description": "Ask AI about your sales calls, deals & pipeline",
      "url": "https://mcp.sybill.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sybill Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "sybill.svg",
      "sourceUrl": "https://claude.ai/directory/2273f645-4b1d-4842-a52f-c0032296ccad",
      "publisherUrl": "https://www.sybill.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "codewords",
      "name": "CodeWords",
      "description": "Build AI agents and automations by chatting",
      "url": "https://runtime.codewords.ai/run/devx_mcp/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Agemo",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "codewords.png",
      "sourceUrl": "https://claude.ai/directory/6232d9e5-10d2-4e64-baa2-c2c41c08c81c",
      "publisherUrl": "https://codewords.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "digits",
      "name": "Digits",
      "description": "Track and analyze your finances with Digits",
      "url": "https://api.digits.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Digits Financial, Inc.",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "digits.svg",
      "sourceUrl": "https://claude.ai/directory/38c1453f-9bb0-40cf-b6b0-79fd8b349ffa",
      "publisherUrl": "https://digits.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "descrybe-legal-engine",
      "name": "Descrybe Legal Engine",
      "description": "Ground your work in clean, structured U.S. primary law",
      "url": "https://mcp.descrybe.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Descrybe",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "descrybe-legal-engine.svg",
      "sourceUrl": "https://claude.ai/directory/9ce05d07-3fb2-474f-b427-d5a4496ab1ac",
      "publisherUrl": "https://descrybe.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "appfolio-realm-x",
      "name": "AppFolio Realm-X",
      "description": "Operate your portfolio directly from Claude",
      "url": "https://mcp.appfolio.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AppFolio, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "appfolio-realm-x.png",
      "sourceUrl": "https://claude.ai/directory/7ee5e27a-c9cf-49bd-9cdc-324310605cfe",
      "publisherUrl": "https://appfolio.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "airwallex-developer",
      "name": "Airwallex Developer",
      "description": "Integrate with the Airwallex Platform using Claude",
      "url": "https://mcp-demo.airwallex.com/developer",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Airwallex",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "airwallex-developer.png",
      "sourceUrl": "https://claude.ai/directory/f9e2f745-d688-42a7-8c79-98fe7990dc03",
      "publisherUrl": "https://www.airwallex.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "gocardless",
      "name": "GoCardless",
      "description": "Build GoCardless payment API integrations",
      "url": "https://mcp.gocardless.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GoCardless",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "gocardless.svg",
      "sourceUrl": "https://claude.ai/directory/d242c454-3a8c-4271-8a8a-e334b111c7c5",
      "publisherUrl": "https://gocardless.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "day-ai",
      "name": "Day AI",
      "description": "Know everything about your prospects & customers with CRMx",
      "url": "https://day.ai/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Day AI",
      "tags": ["communication", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "day-ai.png",
      "sourceUrl": "https://claude.ai/directory/87d31b20-90c3-42ca-94a7-51270953869d",
      "publisherUrl": "https://day.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "fastmail",
      "name": "Fastmail",
      "description": "An MCP server for Fastmail customers and accounts",
      "url": "https://api.fastmail.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fastmail",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "fastmail.png",
      "sourceUrl": "https://claude.ai/directory/3a2788fb-9861-4234-b1a3-c929c3a4d4f9",
      "publisherUrl": "https://fastmail.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "tineo",
      "name": "Tineo",
      "description": "Connect Tineo to Claude to review trips, flights, hotels and activities, and add or update itinerary details. Organize and share plans with friends in Tineo.",
      "url": "https://api.tineo.ai/mcp/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tineo LLC",
      "tags": ["communication", "productivity", "travel"],
      "priority": "P2",
      "logo": "tineo.png",
      "sourceUrl": "https://claude.ai/directory/47af3906-6905-49b7-bde9-363c6b6fa3b8",
      "publisherUrl": "https://tineo.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "gainsight-customer-communities",
      "name": "Gainsight (Customer Communities)",
      "description": "Ask your AI for the community insights you need",
      "url": "https://mcp.insided.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gainsight",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "gainsight-customer-communities.png",
      "sourceUrl": "https://claude.ai/directory/a34c0784-a7b7-4adf-882a-530a6a50d3c0",
      "publisherUrl": "https://communities.gainsight.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "aftership-channels-for-tiktok-shop",
      "name": "AfterShip Channels for TikTok Shop",
      "description": "List, sync & grow your TikTok Shop business",
      "url": "https://mcp.aftership.com/channels",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AfterShip",
      "tags": ["commerce-shopping"],
      "priority": "P2",
      "logo": "aftership-channels-for-tiktok-shop.svg",
      "sourceUrl": "https://claude.ai/directory/d875e9bd-a012-44cb-aa0c-84eb53ecdfc8",
      "publisherUrl": "https://www.aftership.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "rally",
      "name": "Rally",
      "description": "Find participant, pull study data and create studies",
      "url": "https://mcp.rallyuxr.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Rally HQ, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "rally.png",
      "sourceUrl": "https://claude.ai/directory/60e9305c-793b-4791-8085-1d2470bcaf9e",
      "publisherUrl": "https://rallyuxr.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "spinach-ai",
      "name": "Spinach AI",
      "description": "The system of action for conversation data",
      "url": "https://mcp.spinach.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Spinach AI",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "spinach-ai.png",
      "sourceUrl": "https://claude.ai/directory/50817992-a7f8-4ac2-bdc4-2f655b87168c",
      "publisherUrl": "https://www.spinach.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "clarify",
      "name": "Clarify",
      "description": "Query your CRM. Create records. Ask anything.",
      "url": "https://api.clarify.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Clarify",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "clarify.png",
      "sourceUrl": "https://claude.ai/directory/27a89255-1541-408d-bb03-d003ae5d1481",
      "publisherUrl": "https://www.clarify.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "sprinto",
      "name": "Sprinto",
      "description": "Manage trust workflows",
      "url": "https://mcp.sprinto.com/tools",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sprinto",
      "tags": ["other"],
      "priority": "P2",
      "logo": "sprinto.svg",
      "sourceUrl": "https://claude.ai/directory/d1e853bb-e524-4771-bb2c-21cef5c67805",
      "publisherUrl": "https://sprinto.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "datarails-financeos",
      "name": "Datarails FinanceOS",
      "description": "Query and analyze your company's consolidated financial data from Datarails FinanceOS.",
      "url": "https://mcp.datarails.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Datarails",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "datarails-financeos.png",
      "sourceUrl": "https://claude.ai/directory/ad38dac2-592c-4269-947a-ab44fe5c3f4f",
      "publisherUrl": "https://www.datarails.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "bigin-by-zoho-crm",
      "name": "Bigin by Zoho CRM",
      "description": "Simplify sales and customer management for small businesses",
      "url": "https://bigin.zohomcp.com/mcp/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho Corporation",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "bigin-by-zoho-crm.png",
      "sourceUrl": "https://claude.ai/directory/013d0803-4052-40b5-91f5-833ec5e7b714",
      "publisherUrl": "https://www.zoho.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "productive",
      "name": "Productive",
      "description": "Run projects, tasks, time tracking, budgets, and invoicing in your Productive workspace, straight from chat.",
      "url": "https://mcp.productive.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Productive",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "productive.png",
      "sourceUrl": "https://claude.ai/directory/99dcbad3-0519-4a43-a411-14f2ee31133e",
      "publisherUrl": "https://productive.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "klue",
      "name": "Klue",
      "description": "Access competitive intelligence, win-loss, & deal support",
      "url": "https://mcp.app.klue.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Klue Labs",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "klue.png",
      "sourceUrl": "https://claude.ai/directory/b0f6f371-4166-472f-841a-133f9e43d86e",
      "publisherUrl": "https://klue.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "bloomberg-law",
      "name": "Bloomberg Law",
      "description": "Legal intelligence powered by Bloomberg AI",
      "url": "https://gw.mcp.bindg.ai/blaw/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bloomberg Industry Group",
      "tags": ["data-analytics", "legal", "productivity"],
      "priority": "P2",
      "logo": "bloomberg-law.png",
      "sourceUrl": "https://claude.ai/directory/7975e863-730c-46f3-8196-105257ba4e6d",
      "publisherUrl": "https://www.bloombergindustry.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "mychatbot",
      "name": "MyChatBot",
      "description": "Build and run an AI sales agent for your business",
      "url": "https://connector.mychatbot.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MyChatBot Corp",
      "tags": ["commerce-shopping", "communication", "sales-and-marketing"],
      "priority": "P2",
      "logo": "mychatbot.svg",
      "sourceUrl": "https://claude.ai/directory/3341d9da-dda5-4581-a64b-93322dfc6ce2",
      "publisherUrl": "https://mychatbot.app/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "padlet",
      "name": "Padlet",
      "description": "Create and manage padlets",
      "url": "https://mcp.padlet.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wallwisher, Inc.",
      "tags": ["education", "productivity"],
      "priority": "P2",
      "logo": "padlet.png",
      "sourceUrl": "https://claude.ai/directory/618a4a60-3705-448f-b86f-b43e85fb37ba",
      "publisherUrl": "https://padlet.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "unstructured-transform",
      "name": "Unstructured Transform",
      "description": "Turn any document into AI-ready structured data",
      "url": "https://mcp.transform.unstructured.io/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Unstructured",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "unstructured-transform.png",
      "sourceUrl": "https://claude.ai/directory/8fb2ce1a-a838-4844-b01c-ac67797da538",
      "publisherUrl": "https://unstructured.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "sprouts-data-intelligence",
      "name": "Sprouts Data Intelligence",
      "description": "From query to qualified lead in seconds.",
      "url": "https://sprouts-mcp-server.kartikay-dhar.workers.dev/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sprouts.ai",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "sprouts-data-intelligence.svg",
      "sourceUrl": "https://claude.ai/directory/fadebf8c-fa8d-42f0-b754-4635bd480ab0",
      "publisherUrl": "https://sprouts.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "pinegap",
      "name": "Pinegap",
      "description": "AI-powered Equity Research Platform",
      "url": "https://mcp.pinegap.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PineGap",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "pinegap.png",
      "sourceUrl": "https://claude.ai/directory/3bc29d58-8b73-49f3-bb74-39fcf5867a5f",
      "publisherUrl": "https://www.pinegap.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "tango",
      "name": "Tango",
      "description": "Search for US Government Contracting Data",
      "url": "https://govcon.dev/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MakeGov Inc",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "tango.png",
      "sourceUrl": "https://claude.ai/directory/af83346b-0499-4fcc-ae7c-22235705bdcd",
      "publisherUrl": "https://makegov.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "jotform-app-builder",
      "name": "Jotform App Builder",
      "description": "Build and manage no-code apps with AI. Create CRM apps, event apps, school apps, and internal tools. Customize layouts, automate workflows, and publish and share apps.",
      "url": "https://mcp.jotform.com/mcp-jotform-apps-v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jotform Inc.",
      "tags": ["developer-tools", "education", "nonprofit", "productivity"],
      "priority": "P2",
      "logo": "jotform-app-builder.png",
      "sourceUrl": "https://claude.ai/directory/47f4bce8-bac1-4872-be7e-b296a1e6f707",
      "publisherUrl": "https://www.jotform.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "roboflow",
      "name": "Roboflow",
      "description": "Build, search, and run computer vision with Roboflow",
      "url": "https://mcp.roboflow.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Roboflow",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "roboflow.svg",
      "sourceUrl": "https://claude.ai/directory/dbbc26cf-80b0-4a85-9877-f85874282794",
      "publisherUrl": "https://roboflow.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "etherscan",
      "name": "Etherscan",
      "description": "Explore wallets, tokens, transactions, contracts, logs, blocks, and gas across 60+ EVM chains with Etherscan",
      "url": "https://mcp-keyless.etherscan.io/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "etherscan",
      "tags": ["data-analytics", "developer-tools", "financial-services"],
      "priority": "P2",
      "logo": "etherscan.png",
      "sourceUrl": "https://claude.ai/directory/62130cf5-e5a6-40db-82e7-437c49718e26",
      "publisherUrl": "https://etherscan.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "sumsub",
      "name": "Sumsub",
      "description": "Verify identities, businesses, and prevent fraud",
      "url": "https://api.sumsub.com/mcp/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sumsub",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "sumsub.png",
      "sourceUrl": "https://claude.ai/directory/72396321-bc37-4407-88e5-c07339b80704",
      "publisherUrl": "https://sumsub.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "kajabi",
      "name": "Kajabi",
      "description": "Build and grow your Kajabi business with Claude",
      "url": "https://mcp.kajabi.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Kajabi",
      "tags": [
        "commerce-shopping",
        "creative",
        "data-analytics",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "kajabi.png",
      "sourceUrl": "https://claude.ai/directory/b80d1410-c440-4d4a-9cc2-fdbe467e984b",
      "publisherUrl": "https://kajabi.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "llamaparse",
      "name": "LlamaParse",
      "description": "Turn your documents into agent-ready context for Claude",
      "url": "https://mcp.llamaindex.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LlamaIndex",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "llamaparse.png",
      "sourceUrl": "https://claude.ai/directory/d0585e82-4190-4588-ab31-b1afd254cf0f",
      "publisherUrl": "https://llamaindex.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "smartling",
      "name": "Smartling",
      "description": "Translate content and manage Smartling projects, jobs, and quality issues directly from your AI assistant.",
      "url": "https://mcp.smartling.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Smartling, Inc.",
      "tags": ["creative", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "smartling.png",
      "sourceUrl": "https://claude.ai/directory/493d699b-dd21-43ae-afec-c47c914bae9c",
      "publisherUrl": "https://www.smartling.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "lumin",
      "name": "Lumin",
      "description": "Send documents for signature, track them to completion, and generate agreements from templates — without leaving the chat.",
      "url": "https://mcp.luminpdf.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lumin",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "lumin.svg",
      "sourceUrl": "https://claude.ai/directory/b04d70ca-c220-4d15-b7c9-e2eb6ace0a2c",
      "publisherUrl": "https://www.luminpdf.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "tabs",
      "name": "Tabs",
      "description": "Make complex revenue simple at scale.",
      "url": "https://integrators.prod.api.tabsplatform.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tabs Platform, Inc.",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "tabs.png",
      "sourceUrl": "https://claude.ai/directory/1c64d334-6dd8-4aed-9f0c-ee91b7f3fabb",
      "publisherUrl": "https://tabs.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "payhawk",
      "name": "Payhawk",
      "description": "Ask and act on company spend: cards, invoices, travel",
      "url": "https://mcp.payhawk.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Payhawk",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "payhawk.png",
      "sourceUrl": "https://claude.ai/directory/03c3c911-2bf9-4a90-b4e9-228bfb2d627d",
      "publisherUrl": "https://payhawk.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "planning-center",
      "name": "Planning Center",
      "description": "Interact with your church data",
      "url": "https://mcp.planningcenteronline.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Planning Center",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "planning-center.png",
      "sourceUrl": "https://claude.ai/directory/edfb7283-0e7b-4366-9e55-899a53ef0036",
      "publisherUrl": "https://www.planningcenter.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "moodys-credit",
      "name": "Moody's Credit",
      "description": "Risk insights, analytics, and decision intelligence",
      "url": "https://mcp.moodys.com/genai-ready-data/Credit/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Moody's Analytics",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "moodys-credit.png",
      "sourceUrl": "https://claude.ai/directory/83a7523b-d6c5-45f8-89de-90a2998bae49",
      "publisherUrl": "https://moodys.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "morning-consult",
      "name": "Morning Consult",
      "description": "Global market intelligence: brands, economy & politics",
      "url": "https://api.morningconsult.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Morning Consult",
      "tags": ["communication", "data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "morning-consult.png",
      "sourceUrl": "https://claude.ai/directory/df464305-771d-4b17-b276-62cefc0270eb",
      "publisherUrl": "https://morningconsult.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "orion-by-gravity",
      "name": "Orion by Gravity",
      "description": "Get insights from your autonomous AI analyst",
      "url": "https://g.runorion.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gravity",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "orion-by-gravity.svg",
      "sourceUrl": "https://claude.ai/directory/6e891213-b720-4ac4-a895-570b2e2639c5",
      "publisherUrl": "https://bygravity.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "topcounsel-by-the-l-suite",
      "name": "TopCounsel by The L Suite",
      "description": "Outside Counsel recommendations from Inhouse Counsel",
      "url": "https://api.techgc.co/api/mcp/topcounsel",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "The L Suite",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "topcounsel-by-the-l-suite.png",
      "sourceUrl": "https://claude.ai/directory/dc0a67bc-7db2-4f4a-b391-9a46964ac5cf",
      "publisherUrl": "https://lsuite.co/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "mt-newswires",
      "name": "MT Newswires",
      "description": "Trusted real-time global financial news provider",
      "url": "https://mcp.mtnewswires.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MT Newswires",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "mt-newswires.png",
      "sourceUrl": "https://claude.ai/directory/441c79ad-8a68-4d73-9263-7cfcadd5d8cf",
      "publisherUrl": "https://www.mtnewswires.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "zite",
      "name": "Zite",
      "description": "Manage and query your Zite data",
      "url": "https://mcp.zite.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zite",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "zite.svg",
      "sourceUrl": "https://claude.ai/directory/dbc52c7f-cbc6-49f4-be8d-ca58126b85ed",
      "publisherUrl": "https://www.zite.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "lawstronaut",
      "name": "Lawstronaut",
      "description": "52+ million verified legal records, sourced directly from official authorities.",
      "url": "https://mcp.lawstronaut.com/",
      "auth": "none",
      "oneClick": true,
      "publisher": "Lawstronaut",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "lawstronaut.png",
      "sourceUrl": "https://claude.ai/directory/2b5cf683-adbd-4324-91c7-f1a46c30b6a7",
      "publisherUrl": "https://lawstronaut.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "angellist",
      "name": "AngelList",
      "description": "Turn your fund into something you can talk to.",
      "url": "https://mcp.angellist.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AngelList",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "angellist.png",
      "sourceUrl": "https://claude.ai/directory/dde63f10-f6b0-4246-a87c-a7cc62ce81b7",
      "publisherUrl": "https://www.angellist.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "quicknode",
      "name": "QuickNode",
      "description": "Manage blockchain infrastructure right in Claude",
      "url": "https://mcp.quicknode.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "QuickNode",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "quicknode.svg",
      "sourceUrl": "https://claude.ai/directory/356a8580-5936-40a0-9a06-5ab54bdaa344",
      "publisherUrl": "https://www.quicknode.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "blaze-sql",
      "name": "Blaze SQL",
      "description": "Let claude query any SQL Database or warehouse with accuracy, context, governance, and observability. BlazeSQL is a full BI Layer with visualizations, dashboards, scheduled reports, and more.",
      "url": "https://claude.blazesql.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "BlazeSQL",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "blaze-sql.png",
      "sourceUrl": "https://claude.ai/directory/a6a88aa0-b038-43ba-ac83-912f459bf576",
      "publisherUrl": "https://www.blazesql.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "onesignal",
      "name": "OneSignal",
      "description": "Agentic access to OneSignal’s customer engagement platform for messaging, users, and analytics.",
      "url": "https://api.onesignal.com/mcp/oauth",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "OneSignal",
      "tags": [
        "commerce-shopping",
        "communication",
        "data-analytics",
        "developer-tools",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "onesignal.svg",
      "sourceUrl": "https://claude.ai/directory/f42c585c-280f-4f7b-bf37-9eb34144b04a",
      "publisherUrl": "https://onesignal.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "pophive",
      "name": "PopHIVE",
      "description": "Yale's harmonized US public health surveillance data",
      "url": "https://mcp.pophive.org/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Yale School of Public Health",
      "tags": ["consumer-health"],
      "priority": "P2",
      "logo": "pophive.svg",
      "sourceUrl": "https://claude.ai/directory/cd7d9174-5546-440a-822d-1e9026e7334c",
      "publisherUrl": "https://www.pophive.org/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "zocks",
      "name": "Zocks",
      "description": "Analyze client conversations, patterns, and insights.",
      "url": "https://mcp.zocks.io/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zocks",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "zocks.svg",
      "sourceUrl": "https://claude.ai/directory/4f05b447-c6da-4f35-88f8-b078c21293bb",
      "publisherUrl": "https://www.zocks.io/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "lawvu",
      "name": "LawVu",
      "description": "Operating system for in-house legal teams",
      "url": "https://mcp.lawvu.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LawVu Limited",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "lawvu.png",
      "sourceUrl": "https://claude.ai/directory/d3f27588-0106-4dc2-a7f1-49fee3340cfe",
      "publisherUrl": "https://lawvu.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "shapes",
      "name": "Shapes",
      "description": "Analyse your live people data, right in Claude",
      "url": "https://mcp.shapes.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Shapes",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "shapes.svg",
      "sourceUrl": "https://claude.ai/directory/b9c73e61-98e6-4658-b946-0fd6c00accb3",
      "publisherUrl": "https://shapes.co/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "mospi",
      "name": "MoSPI",
      "description": "India's official statistics via natural language",
      "url": "https://mcp.mospi.gov.in/",
      "auth": "none",
      "oneClick": true,
      "publisher": "Ministry of Statistics and Programme Implementation (MoSPI), Government of India",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "mospi.png",
      "sourceUrl": "https://claude.ai/directory/49a84267-c5d5-4c7b-8070-ab6b0875d886",
      "publisherUrl": "https://www.mospi.gov.in/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "leadfeeder",
      "name": "Leadfeeder",
      "description": "Find, enrich, and act on the companies on your site",
      "url": "https://mcp.leadfeeder.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Leadfeeder",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "leadfeeder.png",
      "sourceUrl": "https://claude.ai/directory/e51d4ae7-2cba-4c80-b8db-1cfd48894c82",
      "publisherUrl": "https://leadfeeder.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "menti",
      "name": "Menti",
      "description": "Make Mentimeter presentations",
      "url": "https://ai.mentimeter.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mentimeter",
      "tags": ["creative", "data-analytics", "education", "productivity"],
      "priority": "P2",
      "logo": "menti.png",
      "sourceUrl": "https://claude.ai/directory/3d710b29-535c-42c1-882a-56d4c1d6a849",
      "publisherUrl": "https://www.mentimeter.com/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "kuliko-ai",
      "name": "Kuliko AI",
      "description": "Your Learning Companion",
      "url": "https://mcp.kuliko.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Kuliko Inc.",
      "tags": ["education", "productivity"],
      "priority": "P2",
      "logo": "kuliko-ai.png",
      "sourceUrl": "https://claude.ai/directory/a7bebd72-83a0-4f7e-a157-af173fbfe41c",
      "publisherUrl": "https://kuliko.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "process-street",
      "name": "Process Street",
      "description": "Explore and update your Process Street data",
      "url": "https://mcp.process.st/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Process Street",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "process-street.svg",
      "sourceUrl": "https://claude.ai/directory/bc7e0573-b43a-4f38-bb11-bd167110a895",
      "publisherUrl": "https://www.process.st/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "chartmogul",
      "name": "ChartMogul",
      "description": "Analyze subscribers, recurring revenue, and churn",
      "url": "https://mcp.chartmogul.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ChartMogul",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "chartmogul.png",
      "sourceUrl": "https://claude.ai/directory/4788c307-479d-4f6a-aa80-e934c71c5b9a",
      "publisherUrl": "https://chartmogul.com/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "kindora-funder-discovery",
      "name": "Kindora Funder Discovery",
      "description": "Find funders who support causes like yours",
      "url": "https://kindora-mcp.azurewebsites.net/mcp/",
      "auth": "none",
      "oneClick": true,
      "publisher": "Kindora",
      "tags": ["nonprofit"],
      "priority": "P2",
      "logo": "kindora-funder-discovery.png",
      "sourceUrl": "https://claude.ai/directory/df363d23-97ef-4ccd-a36e-5369846f5506",
      "publisherUrl": "https://www.kindora.co/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "weweb",
      "name": "WeWeb",
      "description": "Build your WeWeb projects using Claude",
      "url": "https://ai-api.weweb.io/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "WeWeb",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "weweb.png",
      "sourceUrl": "https://claude.ai/directory/a8734131-692f-47ff-8e08-e0fc42f73dd8",
      "publisherUrl": "https://www.weweb.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "graphos",
      "name": "GraphOS",
      "description": "Search Apollo docs, specs, and best practices",
      "url": "https://mcp.apollographql.com/",
      "auth": "none",
      "oneClick": true,
      "publisher": "Apollo GraphQL",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "graphos.png",
      "sourceUrl": "https://claude.ai/directory/b97d991c-e50a-4345-8aa8-8e42ec8e99bc",
      "publisherUrl": "https://www.apollographql.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "abency",
      "name": "Abency",
      "description": "Gestiona todas las marcas de tu agencia desde Claude",
      "url": "https://app.abency.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Additiu Marketing Digital SL",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "abency.png",
      "sourceUrl": "https://claude.ai/directory/ea7da8b1-d17e-4a88-af4f-c9d71608298e",
      "publisherUrl": "https://abency.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "livestorm",
      "name": "Livestorm",
      "description": "Manage and analyze your webinars from Claude",
      "url": "https://mcp.livestorm.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Livestorm",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "livestorm.png",
      "sourceUrl": "https://claude.ai/directory/5e397f67-452e-4bad-a7d4-b81cf2ed31f3",
      "publisherUrl": "https://livestorm.co/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "lilt",
      "name": "LILT",
      "description": "High-quality translation with human verification",
      "url": "https://mcp.lilt.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LILT",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "lilt.png",
      "sourceUrl": "https://claude.ai/directory/88245f33-e3a7-468f-ae27-3f118bef198a",
      "publisherUrl": "https://lilt.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "dot",
      "name": "dot.",
      "description": "Get feedback on anything you build in Claude.",
      "url": "https://mcp.leaveadot.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "dot.",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "dot.png",
      "sourceUrl": "https://claude.ai/directory/95f211c1-7c28-4a1c-9b2c-a63d2bf607ab",
      "publisherUrl": "https://www.leaveadot.com/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "roam-research",
      "name": "Roam Research",
      "description": "Let Claude read, search, and write in your Roam graphs",
      "url": "https://mcp.roamresearch.com/mcp/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Roam Research Inc.",
      "tags": ["education", "productivity"],
      "priority": "P2",
      "logo": "roam-research.png",
      "sourceUrl": "https://claude.ai/directory/205baeff-860d-4119-a63e-329332d49c01",
      "publisherUrl": "https://roamresearch.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "lightfield",
      "name": "Lightfield",
      "description": "CRM that remembers everything and works for you.",
      "url": "https://mcp.lightfield.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lightfield",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "lightfield.svg",
      "sourceUrl": "https://claude.ai/directory/c1496483-94ab-4a4e-885c-d7d2696e6eeb",
      "publisherUrl": "https://lightfield.app/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "stytch",
      "name": "Stytch",
      "description": "Manage your Stytch Project",
      "url": "https://mcp.stytch.dev/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Stytch",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "stytch.png",
      "sourceUrl": "https://claude.ai/directory/b873d3db-0781-4a3d-9245-9c6213e6d785",
      "publisherUrl": "https://stytch.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "wingify",
      "name": "Wingify",
      "description": "Optimize digital experiences directly from Claude and supercharge your CRO workflow.",
      "url": "https://mcp.wingify.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wingify Software Pvt. Ltd",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "wingify.png",
      "sourceUrl": "https://claude.ai/directory/a87a8ab0-bc14-4030-8900-76222684c7ec",
      "publisherUrl": "https://vwo.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "lz-virtual-mail",
      "name": "LZ Virtual Mail",
      "description": "Manage your physical mail from anywhere",
      "url": "https://api.earthclassmail.com/v2/mcp/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LegalZoom",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "lz-virtual-mail.png",
      "sourceUrl": "https://claude.ai/directory/683309bd-c3f3-4d9b-bba6-2e7f74d24876",
      "publisherUrl": "https://www.legalzoom.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "jus-ai-by-jus-mundi",
      "name": "Jus AI by Jus Mundi",
      "description": "AI-powered global arbitration intelligence",
      "url": "https://mcp.jusmundi.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jus Mundi",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "jus-ai-by-jus-mundi.png",
      "sourceUrl": "https://claude.ai/directory/f15b18a4-e4f0-4a4e-be24-ee8a4c17f41a",
      "publisherUrl": "https://jusmundi.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "mdn",
      "name": "MDN",
      "description": "Search & retrieval of MDN docs & browser compat data",
      "url": "https://mcp.mdn.mozilla.net/",
      "auth": "none",
      "oneClick": true,
      "publisher": "Mozilla",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "mdn.svg",
      "sourceUrl": "https://claude.ai/directory/731a302b-c364-488f-a727-2f35e91b9ab0",
      "publisherUrl": "https://developer.mozilla.org/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "browserstack",
      "name": "BrowserStack",
      "description": "Plan, run, debug, and fix tests across web and mobile",
      "url": "https://mcp.browserstack.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "BrowserStack",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "browserstack.png",
      "sourceUrl": "https://claude.ai/directory/f30854c6-f587-4fb3-ba06-60e55cedf605",
      "publisherUrl": "https://browserstack.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "subtext",
      "name": "Subtext",
      "description": "Session replay, built for agents. Give Claude a session link and it investigates the real production session—DOM, screenshots, console, network—to find the root cause.",
      "url": "https://api.fullstory.com/mcp/subtext",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fullstory",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P2",
      "logo": "subtext.png",
      "sourceUrl": "https://claude.ai/directory/ba1a54c3-9b80-4113-8c04-4a599cc48936",
      "publisherUrl": "https://subtext.fullstory.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "softr",
      "name": "Softr",
      "description": "Build internal tools, workflows and databases all in one platform",
      "url": "https://mcp.softr.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Softr",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "softr.png",
      "sourceUrl": "https://claude.ai/directory/16835a62-70b6-4a4b-9be7-0f5ecaa742a4",
      "publisherUrl": "https://www.softr.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "grasshopper-bank",
      "name": "Grasshopper Bank",
      "description": "Query and analyze your financial data",
      "url": "https://grasshopper-mcp.prd.narmitech.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Grasshopper Bank",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "grasshopper-bank.png",
      "sourceUrl": "https://claude.ai/directory/2bd58a48-6693-4964-9a00-b95861911928",
      "publisherUrl": "https://www.grasshopper.bank/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "zacks-data",
      "name": "Zacks Data",
      "description": "Trusted Financial Data from Zacks Investment Research",
      "url": "https://mcp.zacksdata.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zacks Investment Research",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "zacks-data.png",
      "sourceUrl": "https://claude.ai/directory/2823d140-e557-491a-a7fc-bc95b67c2ce2",
      "publisherUrl": "https://ai.zacksdata.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "cargoai",
      "name": "CargoAi",
      "description": "Instant air cargo rates, quotes & tracking",
      "url": "https://api.cargoai.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CargoAi",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "cargoai.png",
      "sourceUrl": "https://claude.ai/directory/7faad730-e6ed-4eef-8e43-cb76c88399ce",
      "publisherUrl": "https://www.cargoai.co/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "vianexus-vast",
      "name": "viaNexus vAST",
      "description": "Power AI workflows with viaNexus: a financial data marketplace delivering prices, news, fundamentals, and global macro economic data directly from trusted provider partners.",
      "url": "https://vast.blueskyapi.com/vianexus/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "viaNexus",
      "tags": ["communication", "data-analytics", "financial-services", "other"],
      "priority": "P2",
      "logo": "vianexus-vast.png",
      "sourceUrl": "https://claude.ai/directory/01c43f47-7757-4ae7-91f2-310eff8bb58d",
      "publisherUrl": "https://vianexus.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "harness",
      "name": "Harness",
      "description": "Build, Ship and Secure your apps on Harness Platform",
      "url": "https://mcp.harness.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Harness.io",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "harness.png",
      "sourceUrl": "https://claude.ai/directory/b98c06f8-3945-46ff-a81d-14233c0bc9a6",
      "publisherUrl": "https://www.harness.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "freshbooks",
      "name": "FreshBooks",
      "description": "Ask Claude how your business is really doing — straight from your FreshBooks financials",
      "url": "https://mcp.freshbooks.com/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "FreshBooks",
      "tags": ["financial-services", "productivity"],
      "priority": "P2",
      "logo": "freshbooks.png",
      "sourceUrl": "https://claude.ai/directory/d45f13bc-1614-4827-8e99-ce563b29958d",
      "publisherUrl": "https://www.freshbooks.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "pg-aiguide",
      "name": "pg-aiguide",
      "description": "Search pg and Tiger docs, learn database skills",
      "url": "https://mcp.tigerdata.com/docs",
      "auth": "none",
      "oneClick": true,
      "publisher": "Tiger Data",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "pg-aiguide.svg",
      "sourceUrl": "https://claude.ai/directory/4039eae1-e1f2-4080-9f3c-b1cc7059c2e6",
      "publisherUrl": "https://tigerdata.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "kpler",
      "name": "Kpler",
      "description": "Explore Kpler's maritime and commodities intelligence",
      "url": "https://claude.mcp.kpler.com/v1/mcp/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Kpler",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "kpler.svg",
      "sourceUrl": "https://claude.ai/directory/da9095ee-b79c-4e1c-a43f-6d82f9125429",
      "publisherUrl": "https://www.kpler.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "patlytics",
      "name": "Patlytics",
      "description": "Prior art, claims, and portfolio search",
      "url": "https://mcp.patlytics.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Patlytics",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "patlytics.png",
      "sourceUrl": "https://claude.ai/directory/bbf58559-0ce4-4567-a5c9-947ce33e9f81",
      "publisherUrl": "https://www.patlytics.ai/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "iubenda",
      "name": "iubenda",
      "description": "GDPR and CCPA compliance: cookie consent, cookie scanner, and terms and conditions",
      "url": "https://mcp-server.iubenda.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "iubenda",
      "tags": ["developer-tools", "legal", "productivity"],
      "priority": "P2",
      "logo": "iubenda.png",
      "sourceUrl": "https://claude.ai/directory/a448a6de-6440-420a-a7fe-1cace7e65f5f",
      "publisherUrl": "https://www.iubenda.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "addepar",
      "name": "Addepar",
      "description": "Bring Addepar portfolio intelligence into Claude",
      "url": "https://mcp.addepar.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Addepar",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "addepar.svg",
      "sourceUrl": "https://claude.ai/directory/bc2b011f-5db9-4aef-9df0-fe500264075d",
      "publisherUrl": "https://addepar.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "gis-cloud",
      "name": "GIS Cloud",
      "description": "Run your entire GIS workflow in plain language: maps, data, analysis, field apps, and reports",
      "url": "https://mcp.giscloud.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GIS Cloud",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "gis-cloud.png",
      "sourceUrl": "https://claude.ai/directory/f7caef2e-05b9-45f8-b9d5-a43ccc02881e",
      "publisherUrl": "https://www.giscloud.com/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "instrumentl",
      "name": "Instrumentl",
      "description": "Find, evaluate, and manage your grants",
      "url": "https://mcp.instrumentl.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Instrumentl",
      "tags": ["nonprofit"],
      "priority": "P2",
      "logo": "instrumentl.svg",
      "sourceUrl": "https://claude.ai/directory/5eb73e73-c172-433d-b3ad-b91da73c9ecd",
      "publisherUrl": "https://www.instrumentl.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "manufact",
      "name": "Manufact",
      "description": "Deploy and monitor MCP servers",
      "url": "https://mcp.manufact.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Manufact",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "manufact.png",
      "sourceUrl": "https://claude.ai/directory/5f441d92-3d5d-42e9-8387-cd20bb3218e6",
      "publisherUrl": "https://manufact.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "corraldata",
      "name": "CorralData",
      "description": "Connect Claude to CorralData so it can query your data, build dashboards, and manage boards and data apps without leaving the conversation.",
      "url": "https://mcp.corraldata.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CorralData",
      "tags": ["data-analytics", "health-life-sciences"],
      "priority": "P2",
      "logo": "corraldata.png",
      "sourceUrl": "https://claude.ai/directory/002c551b-caa1-488c-8be9-a807a7cc835c",
      "publisherUrl": "https://corraldata.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "paytm-payment-gateway",
      "name": "Paytm Payment Gateway",
      "description": "Make Claude your Paytm Payments assistant",
      "url": "https://mcp.paytmpayments.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Paytm Payments Services Limited",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "paytm-payment-gateway.png",
      "sourceUrl": "https://claude.ai/directory/7c2f4b78-5630-4f5f-9524-27e6f8d8cb01",
      "publisherUrl": "https://www.paytmpayments.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "actively",
      "name": "Actively",
      "description": "1:1 account agents for GTM teams",
      "url": "https://api.actively.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Taurus Labs, Inc.",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "actively.png",
      "sourceUrl": "https://claude.ai/directory/ce5e0577-7004-470c-91f8-5abdc9335ae3",
      "publisherUrl": "https://www.actively.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "usafacts",
      "name": "USAFacts",
      "description": "Give Claude a better source for government data",
      "url": "https://data.mcp.usafacts.org/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "USAFacts",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "usafacts.png",
      "sourceUrl": "https://claude.ai/directory/aeb6f889-85b1-42f9-80b4-a7df9db4a1f6",
      "publisherUrl": "https://usafacts.org/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "manatal",
      "name": "Manatal",
      "description": "Your AI recruiting assistant, inside Manatal",
      "url": "https://mcp.manatal.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Manatal",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "manatal.png",
      "sourceUrl": "https://claude.ai/directory/12ea6ea5-6214-4a92-81e0-2c428bb7ee51",
      "publisherUrl": "https://www.manatal.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "wealth-com",
      "name": "Wealth.com",
      "description": "Bring your clients' estate plans, tax returns, and documents into Claude — with instant snapshots, risk analysis, and advisor-ready summaries.",
      "url": "https://mcp.wealth.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wealth.com",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "wealth-com.png",
      "sourceUrl": "https://claude.ai/directory/3901f2b7-ddfb-4d32-a0ae-280106224cb1",
      "publisherUrl": "https://www.wealth.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "mygeotab",
      "name": "MyGeotab",
      "description": "Bring your fleet into Claude — analyze, manage, and act",
      "url": "https://mcp.geotab.com/mygeotab",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Geotab",
      "tags": ["other"],
      "priority": "P2",
      "logo": "mygeotab.png",
      "sourceUrl": "https://claude.ai/directory/610d7eb7-7928-42e3-994f-c6d58b2adeee",
      "publisherUrl": "https://geotab.com/geotab-mcp-connector"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "orion",
      "name": "Orion",
      "description": "Bring Orion Connect portfolio data and Redtail CRM together in Claude — prep for client meetings, capture follow-ups, prioritize your pipeline, and turn reports into talking points.",
      "url": "https://gateway.oriondenali.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Orion",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "orion.png",
      "sourceUrl": "https://claude.ai/directory/ae7131fa-f9e7-4f96-b776-b582c7fa09a1",
      "publisherUrl": "https://orion.com/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "blackthorn-events",
      "name": "Blackthorn Events",
      "description": "Blackthorn's MCP server for Salesforce events: create, query, and report on events, attendees, tickets, sessions, forms, and email campaigns, over 100 available tools, live against your org.",
      "url": "https://forge.blackthorn.io/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Blackthorn.io",
      "tags": ["education", "nonprofit"],
      "priority": "P2",
      "logo": "blackthorn-events.png",
      "sourceUrl": "https://claude.ai/directory/bb966230-ca18-4d33-8601-7d54184931c1",
      "publisherUrl": "https://blackthorn.io/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "xtiles",
      "name": "xTiles",
      "description": "Projects that keep Claude in context",
      "url": "https://mcp.xtiles.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "XTILES INC.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "xtiles.png",
      "sourceUrl": "https://claude.ai/directory/50ec1cae-d124-4fd5-8d8d-4816614e30ab",
      "publisherUrl": "https://xtiles.app/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "verisk-xactrestore",
      "name": "Verisk XactRestore",
      "description": "Natural-language estimating for XactRestore",
      "url": "https://xactrestore-xactremodelserver-usw2-prod.propsol.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Verisk Analytics, Inc.",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "verisk-xactrestore.png",
      "sourceUrl": "https://claude.ai/directory/ca0cd7ba-6a50-4aba-a1c9-45367fc80cc2",
      "publisherUrl": "https://verisk.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "paperoffice",
      "name": "PaperOffice",
      "description": "Built for companies. Ready for AI agents. The headless DMS for Claude: search, read, extract, approve, send for signing and archive documents in your own account, with your permissions.",
      "url": "https://mcp.paperoffice.ai/claude",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PaperOffice",
      "tags": ["data-analytics", "financial-services", "legal", "productivity"],
      "priority": "P2",
      "logo": "paperoffice.png",
      "sourceUrl": "https://claude.ai/directory/7fc51aa2-cf7e-4429-9ed8-623b92395e60",
      "publisherUrl": "https://paperoffice.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "bling",
      "name": "Bling",
      "description": "Access and manage your Bling directly in Claude.",
      "url": "https://mcp.bling.com.br/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bling",
      "tags": [
        "commerce-shopping",
        "developer-tools",
        "financial-services",
        "other",
        "productivity"
      ],
      "priority": "P2",
      "logo": "bling.png",
      "sourceUrl": "https://claude.ai/directory/6fce81f4-47a2-4fa3-b8de-ad218b494730",
      "publisherUrl": "https://www.bling.com.br/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "flexport",
      "name": "Flexport",
      "description": "Make global trade so easy that there will be more of it.",
      "url": "https://mcp.flexport.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Flexport Inc",
      "tags": ["communication", "data-analytics", "other", "productivity"],
      "priority": "P2",
      "logo": "flexport.png",
      "sourceUrl": "https://claude.ai/directory/e72f41ad-cdc9-44d2-9365-b9d62cfdaf85",
      "publisherUrl": "https://www.flexport.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "chariot",
      "name": "Chariot",
      "description": "Manage your nonprofit's DAF donations and deposits",
      "url": "https://api.givechariot.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Chariot",
      "tags": ["financial-services", "nonprofit"],
      "priority": "P2",
      "logo": "chariot.png",
      "sourceUrl": "https://claude.ai/directory/ea93389e-9fac-4639-b2e2-77ebf2dc0b3b",
      "publisherUrl": "https://givechariot.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "vuetify",
      "name": "Vuetify",
      "description": "Official Vuetify docs, APIs, and bins for AI agents",
      "url": "https://mcp.vuetifyjs.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Vuetify",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "vuetify.svg",
      "sourceUrl": "https://claude.ai/directory/2d017c91-27a4-487a-b5d4-784f2d83f917",
      "publisherUrl": "https://vuetifyjs.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "control-plane",
      "name": "Control Plane",
      "description": "Deploy, scale, and debug cloud apps from one platform",
      "url": "https://mcp.cpln.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Control Plane Corporation",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "control-plane.png",
      "sourceUrl": "https://claude.ai/directory/254e954c-da06-44e1-8f83-e0c599a1a495",
      "publisherUrl": "https://controlplane.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "vani-by-zoho",
      "name": "Vani by Zoho",
      "description": "Create diagrams, visualize workflows, and manage Spaces in Vani.",
      "url": "https://app.vanihq.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "vani-by-zoho.svg",
      "sourceUrl": "https://claude.ai/directory/9411aa63-2ca4-40be-8cb4-26b3f9f41aab",
      "publisherUrl": "https://zoho.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "myob",
      "name": "MYOB",
      "description": "Understand your MYOB business finances with Claude.",
      "url": "https://mcp.myob.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MYOB",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "myob.png",
      "sourceUrl": "https://claude.ai/directory/09087a34-a8b8-4024-bb24-9c30a51b8927",
      "publisherUrl": "https://www.myob.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "sent",
      "name": "Sent",
      "description": "Send and manage customer messages across SMS, WhatsApp, and RCS. Build and manage production messaging workflows.",
      "url": "https://mcp.sent.dm/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sent, Inc.",
      "tags": ["communication", "data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "sent.png",
      "sourceUrl": "https://claude.ai/directory/61b2e77b-c7b5-4d25-92d1-5021054e9978",
      "publisherUrl": "https://www.sent.dm/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "ihme-gbd",
      "name": "IHME GBD",
      "description": "Explore IHME Global Burden of Disease data: causes of death, disease burden, and risk factors worldwide.",
      "url": "https://gbdmcp.healthdata.org/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Institute for Health Metrics and Evaluation",
      "tags": ["health-life-sciences"],
      "priority": "P2",
      "logo": "ihme-gbd.png",
      "sourceUrl": "https://claude.ai/directory/b787eaac-ad6b-4f07-94b1-d45b5e125f97",
      "publisherUrl": "https://www.healthdata.org/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "intuit-developer",
      "name": "Intuit Developer",
      "description": "Build and test integrations with Intuit APIs.",
      "url": "https://ai-inc-developer.intuit.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Intuit",
      "tags": ["developer-tools", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "intuit-developer.png",
      "sourceUrl": "https://claude.ai/directory/210a0e53-5a79-4903-8cd1-0754db99b194",
      "publisherUrl": "https://developer.intuit.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "grasp",
      "name": "Grasp",
      "description": "Find, screen and analyse private-market opportunities",
      "url": "https://app.grasp-ai.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Grasp AI",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "grasp.svg",
      "sourceUrl": "https://claude.ai/directory/c6911aa0-7aea-4f16-ab31-8944044e2863",
      "publisherUrl": "https://grasp-ai.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "wealthbox",
      "name": "Wealthbox",
      "description": "Search, update, and manage Wealthbox data from inside Claude",
      "url": "https://mcp.crmworkspace.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wealthbox",
      "tags": ["financial-services", "productivity"],
      "priority": "P2",
      "logo": "wealthbox.svg",
      "sourceUrl": "https://claude.ai/directory/95dfb71b-dd9a-4176-adc4-293d6d7246eb",
      "publisherUrl": "https://www.wealthbox.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "windmill-hr",
      "name": "Windmill HR",
      "description": "Draft performance reviews, manage 1:1s, send pulses, and collect feedback in Windmill, without ever leaving Claude.",
      "url": "https://mcp.gowindmill.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Windmill",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "windmill-hr.png",
      "sourceUrl": "https://claude.ai/directory/9af5c0c8-b270-4457-851e-196b591e43b1",
      "publisherUrl": "https://gowindmill.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "8am-mycase",
      "name": "8am MyCase",
      "description": "Connect your MyCase practice data to Claude — look up matters, contacts, tasks, time, and billing without leaving your AI workspace.",
      "url": "https://mcp.mycase.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "8am",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "8am-mycase.png",
      "sourceUrl": "https://claude.ai/directory/ba542ef5-98a6-4ed3-a06c-d6ac184737cd",
      "publisherUrl": "https://8am.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "turquoise",
      "name": "Turquoise",
      "description": "Query Turquoise's proprietary healthcare pricing data",
      "url": "https://mcp.turquoise.health/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Turquoise Health",
      "tags": ["consumer-health"],
      "priority": "P2",
      "logo": "turquoise.svg",
      "sourceUrl": "https://claude.ai/directory/78e4613c-7869-4be4-b58f-3794060c704e",
      "publisherUrl": "https://turquoise.health/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "bitrise",
      "name": "Bitrise",
      "description": "Set up and manage mobile CI/CD on Bitrise: build, test, and distribute iOS, Android, Flutter, and React Native apps from your AI assistant.",
      "url": "https://mcp.bitrise.io/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bitrise, Inc.",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "bitrise.png",
      "sourceUrl": "https://claude.ai/directory/fe049fc9-9284-48b0-ad3d-2d7184c7cb2f",
      "publisherUrl": "https://bitrise.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "phished",
      "name": "Phished",
      "description": "Phished's entire ZIR app at your fingertips directly in Claude",
      "url": "https://mcp.phished.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Phished BV",
      "tags": ["developer-tools", "other", "productivity"],
      "priority": "P2",
      "logo": "phished.png",
      "sourceUrl": "https://claude.ai/directory/dca5e54b-c05e-4c7f-8a00-bf01c9e74b71",
      "publisherUrl": "https://phished.io/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "robin-workplace",
      "name": "Robin (Workplace)",
      "description": "Robin is the workplace platform teams use to manage desks, rooms, and hybrid office schedules, and optimize how their workplace is planned and used.",
      "url": "https://mcp.robinpowered.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Robin Powered, Inc.",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "robin-workplace.png",
      "sourceUrl": "https://claude.ai/directory/b955cf44-cd8f-4551-8730-cbc5a31d2003",
      "publisherUrl": "https://robinpowered.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "ketryx",
      "name": "Ketryx",
      "description": "Search and explore regulated software lifecycle data",
      "url": "https://app.ketryx.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ketryx",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "ketryx.png",
      "sourceUrl": "https://claude.ai/directory/c190c061-702f-48da-97cb-6e32cedf47b0",
      "publisherUrl": "https://www.ketryx.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "atlar",
      "name": "Atlar",
      "description": "Query your live treasury data: accounts, balances, transactions, and forecasts—directly from Claude.",
      "url": "https://mcp.atlar.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Atlar AB",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "atlar.png",
      "sourceUrl": "https://claude.ai/directory/0421c58f-f79c-4626-8a83-427d30879719",
      "publisherUrl": "https://www.atlar.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "catalyst-by-zoho",
      "name": "Catalyst by Zoho",
      "description": "Build, deploy and host apps.",
      "url": "https://catalystbyzoho.zohomcp.com/mcp/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Catalyst by Zoho",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "catalyst-by-zoho.png",
      "sourceUrl": "https://claude.ai/directory/0ab34a9e-bc65-4f77-98a0-e70c456ca3dd",
      "publisherUrl": "https://catalyst.zoho.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "embat",
      "name": "Embat",
      "description": "Ask Embat about cash, debt, payments, and accounting",
      "url": "https://tellme.embat.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Embat",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "embat.svg",
      "sourceUrl": "https://claude.ai/directory/c261e4da-e467-4805-b2cb-458addbb360b",
      "publisherUrl": "https://www.embat.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "vertiso-memory",
      "name": "Vertiso Memory",
      "description": "Portable, durable memory for every AI agent you use",
      "url": "https://memory.vertiso.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vertiso Corporation",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "vertiso-memory.png",
      "sourceUrl": "https://claude.ai/directory/d683d022-090c-4f0c-ad5e-77c5f4be5df8",
      "publisherUrl": "https://www.vertiso.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "lumonic",
      "name": "Lumonic",
      "description": "Analyze portfolio data and reporting in Claude",
      "url": "https://mcp.lumonic.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lumonic",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "lumonic.png",
      "sourceUrl": "https://claude.ai/directory/9abe7a5c-927e-4da4-a5b3-199beb12dc64",
      "publisherUrl": "https://www.lumonic.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "ninout",
      "name": "Ninout",
      "description": "Design, publish, and analyze forms entirely in chat",
      "url": "https://mcp.svy.ooo/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Ninout, Inc.",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "ninout.png",
      "sourceUrl": "https://claude.ai/directory/d6c4eff2-695f-4696-a10a-9341a1cccd34",
      "publisherUrl": "https://www.ninout.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "superbooks",
      "name": "SuperBooks",
      "description": "Financial OS for small businesses",
      "url": "https://app.superbooks.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Devino Solutions",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "superbooks.png",
      "sourceUrl": "https://claude.ai/directory/f80d20ad-23dc-46d7-bca4-0057424eb163",
      "publisherUrl": "https://devino.ca/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "aurora",
      "name": "Aurora",
      "description": "Search your Consilio matters, docs, and more.",
      "url": "https://mcp.ai.consilio.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Consilio, LLC",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "aurora.png",
      "sourceUrl": "https://claude.ai/directory/dee803ac-4887-4e73-a3c5-ab167f8f1fe8",
      "publisherUrl": "https://www.consilio.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "mastercard-developers",
      "name": "Mastercard Developers",
      "description": "Up-to-date Mastercard APIs, docs, and guides",
      "url": "https://developer.mcp.mastercard.com/",
      "auth": "none",
      "oneClick": true,
      "publisher": "Mastercard",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "mastercard-developers.png",
      "sourceUrl": "https://claude.ai/directory/18c736e4-140d-4c63-bced-fec98bcc6943",
      "publisherUrl": "https://developer.mastercard.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "wetransfer",
      "name": "WeTransfer",
      "description": "Send files from your chat via WeTransfer — get a shareable link or email them to recipients, using your own WeTransfer account.",
      "url": "https://mcp-server.wetransfer.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "WeTransfer",
      "tags": ["communication", "creative", "productivity"],
      "priority": "P2",
      "logo": "wetransfer.png",
      "sourceUrl": "https://claude.ai/directory/2ebcbf09-aafd-4234-b2ac-6af5701ea2e1",
      "publisherUrl": "https://wetransfer.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "twinmind",
      "name": "TwinMind",
      "description": "AI notes & Memory",
      "url": "https://api.twinmind.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "TwinMind",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "twinmind.png",
      "sourceUrl": "https://claude.ai/directory/22a27621-abd1-45a3-b745-0e5249097b89",
      "publisherUrl": "https://twinmind.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "craft-io",
      "name": "Craft.io",
      "description": "Manage your end-to-end product lifecycle - backlog, PRDs, customer feedback, roadmaps, and strategic OKRs - with Claude connected directly to your Craft.io data.",
      "url": "https://mcp.craft.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Craft.io",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "craft-io.png",
      "sourceUrl": "https://claude.ai/directory/594b217c-7933-411c-b67c-06c6d88deb93",
      "publisherUrl": "https://craft.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "productised",
      "name": "Productised",
      "description": "AI-Powered Inbound for Claude",
      "url": "https://mcp.productised.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Productised",
      "tags": [
        "creative",
        "data-analytics",
        "developer-tools",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "productised.png",
      "sourceUrl": "https://claude.ai/directory/f9efc548-1533-4b9d-b498-e34727caf3ef",
      "publisherUrl": "https://www.productised.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "cloze",
      "name": "Cloze",
      "description": "Cloze Relationship Management",
      "url": "https://api.cloze.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Cloze, Inc.",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "cloze.png",
      "sourceUrl": "https://claude.ai/directory/c55ee7b3-d783-4f8e-adb2-3c05247b9cad",
      "publisherUrl": "https://cloze.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "origin",
      "name": "Origin",
      "description": "See what AI agents are doing across your endpoint fleet",
      "url": "https://mcp.prod.originhq.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Origin",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "origin.png",
      "sourceUrl": "https://claude.ai/directory/4add6101-9562-4ebb-9ac7-ebdaabed6257",
      "publisherUrl": "https://www.originhq.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "hubstaff",
      "name": "Hubstaff",
      "description": "AI-ready workforce insights",
      "url": "https://mcp.hubstaff.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hubstaff",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "hubstaff.png",
      "sourceUrl": "https://claude.ai/directory/ead66338-54e5-4996-bc0b-6e8029d7604b",
      "publisherUrl": "https://hubstaff.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "contract-factory",
      "name": "Contract-Factory",
      "description": "Infos officielles des entreprises françaises (RNE)",
      "url": "https://www.contract-factory.com/mcp.php",
      "auth": "none",
      "oneClick": true,
      "publisher": "Contract-Factory",
      "tags": ["data-analytics", "financial-services", "legal"],
      "priority": "P2",
      "logo": "contract-factory.png",
      "sourceUrl": "https://claude.ai/directory/e12ee257-b5f5-496f-a24d-db08d779b330",
      "publisherUrl": "https://www.contract-factory.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "metal",
      "name": "Metal",
      "description": "Access your deal intelligence",
      "url": "https://mcp.metal.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Metal",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "metal.png",
      "sourceUrl": "https://claude.ai/directory/98a92b54-d1e1-4025-87b6-906e028033be",
      "publisherUrl": "https://www.metal.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "grtwo-docs",
      "name": "grtwo-docs",
      "description": "Publish -docs. from Claude and get a shareable link.",
      "url": "https://www.grtwo.app/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GRTwo Digital LLC",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "grtwo-docs.svg",
      "sourceUrl": "https://claude.ai/directory/8a9942d7-2d07-4f24-bbc2-8454ae290d4a",
      "publisherUrl": "https://grtwo.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "jupiterone",
      "name": "JupiterOne",
      "description": "Ask questions about your JupiterOne agentic security and it asset graph and manage alerts, rules, and dashboards — in natural language.",
      "url": "https://mcp.us.jupiterone.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "JupiterOne",
      "tags": ["data-analytics", "developer-tools", "other"],
      "priority": "P2",
      "logo": "jupiterone.svg",
      "sourceUrl": "https://claude.ai/directory/a12a9e90-4b84-4dcc-a2c3-146f91e46f25",
      "publisherUrl": "https://www.jupiterone.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "zoho-show",
      "name": "Zoho Show",
      "description": "Create, edit and manage presentation decks",
      "url": "https://show.zoho.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Zoho",
      "tags": [
        "communication",
        "data-analytics",
        "education",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "zoho-show.svg",
      "sourceUrl": "https://claude.ai/directory/9e291979-eb81-47c5-949e-67f150f84711",
      "publisherUrl": "https://zoho.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "pi-security",
      "name": "Pi Security",
      "description": "Agentic product security platform",
      "url": "https://mcp.pi.security/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pi Security",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "pi-security.png",
      "sourceUrl": "https://claude.ai/directory/c703ddc2-743d-4677-b37e-4f58476c6a60",
      "publisherUrl": "https://pi.security/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "isometric",
      "name": "Isometric",
      "description": "Agentic certification for the industrial economy",
      "url": "https://api.isometric.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Isometric HQ Ltd",
      "tags": ["other"],
      "priority": "P2",
      "logo": "isometric.png",
      "sourceUrl": "https://claude.ai/directory/f362ba22-f754-4b33-b0df-59d6336e2fdb",
      "publisherUrl": "https://isometric.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "richpanel-ai",
      "name": "Richpanel AI",
      "description": "Run your Richpanel helpdesk and AI support agent from Claude.",
      "url": "https://mcp.richpanel.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Richpanel Inc",
      "tags": ["communication", "data-analytics", "productivity"],
      "priority": "P2",
      "logo": "richpanel-ai.png",
      "sourceUrl": "https://claude.ai/directory/d14ac5bd-ef35-436e-8718-fc65e4dac283",
      "publisherUrl": "https://richpanel.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "jump",
      "name": "Jump",
      "description": "Trusted AI for advisors & financial professionals",
      "url": "https://my.jumpapp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jump",
      "tags": ["financial-services", "productivity"],
      "priority": "P2",
      "logo": "jump.svg",
      "sourceUrl": "https://claude.ai/directory/ea5ae1e7-92e6-4cac-a753-9be1a67e3446",
      "publisherUrl": "https://jump.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "infobip-message",
      "name": "Infobip Message",
      "description": "Send SMS, RCS, MMS, and Viber messages through Infobip in Claude",
      "url": "https://mcp.infobip.com/message",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Infobip",
      "tags": ["communication"],
      "priority": "P2",
      "logo": "infobip-message.png",
      "sourceUrl": "https://claude.ai/directory/c6474f8f-481d-4258-b34b-fee34f346f8d",
      "publisherUrl": "https://infobip.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "voluum",
      "name": "Voluum",
      "description": "Manage and analyze your Voluum ad-tracking campaigns directly from Claude.",
      "url": "https://mcp.voluum.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Voluum",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P2",
      "logo": "voluum.png",
      "sourceUrl": "https://claude.ai/directory/a41d15de-2cf7-4610-83f8-ec8c74e81e58",
      "publisherUrl": "https://voluum.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "jedify",
      "name": "Jedify",
      "description": "Governed, live business context for you and your agents - so they reason and act on your organization’s trusted data, definitions, and knowledge.",
      "url": "https://be.jedify.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Jedify",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "jedify.png",
      "sourceUrl": "https://claude.ai/directory/01749f9c-7f7f-4934-8644-1e31e86eb08b",
      "publisherUrl": "https://jedify.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "bonsai",
      "name": "Bonsai",
      "description": "Manage your CRM, client projects and invoices from Claude",
      "url": "https://mcp.hellobonsai.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bonsai by Zoom",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "bonsai.png",
      "sourceUrl": "https://claude.ai/directory/2dc67572-c7a2-425e-8ccb-423b3cf29ec4",
      "publisherUrl": "https://hellobonsai.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "cloverleaf",
      "name": "Cloverleaf",
      "description": "Bring Cloverleaf's personality insights into Claude to understand how you and your colleagues work together, and get coaching grounded in real assessment data, not generic advice.",
      "url": "https://app.cloverleaf.me/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Cloverleaf",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "cloverleaf.png",
      "sourceUrl": "https://claude.ai/directory/3a12374d-cc96-4ccb-999a-0c17056921e5",
      "publisherUrl": "https://cloverleaf.me/"
    },
    {
      "category": "Research",
      "subcategory": "Education & nonprofits",
      "id": "givebutter",
      "name": "Givebutter",
      "description": "Manage your fundraising",
      "url": "https://mcp.givebutter.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Givebutter",
      "tags": ["nonprofit"],
      "priority": "P2",
      "logo": "givebutter.svg",
      "sourceUrl": "https://claude.ai/directory/d4d95e77-c166-4ee8-b2e5-fae34743cfe3",
      "publisherUrl": "https://givebutter.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "prefect",
      "name": "Prefect",
      "description": "Inspect Prefect workflows",
      "url": "https://prefect.fastmcp.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Prefect Technologies",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P2",
      "logo": "prefect.svg",
      "sourceUrl": "https://claude.ai/directory/a278dc29-a087-4ddd-9fb9-66390bc06543",
      "publisherUrl": "https://www.prefect.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "badger-maps-standard",
      "name": "Badger Maps (Standard)",
      "description": "Badger Maps is the #1 field sales platform",
      "url": "https://mcp.badgermapping.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Badger Maps, Inc",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "badger-maps-standard.png",
      "sourceUrl": "https://claude.ai/directory/80032da6-208f-4250-978f-83226c20fbb7",
      "publisherUrl": "https://www.badgermapping.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "sprites",
      "name": "Sprites",
      "description": "Let Claude manage your Sprites",
      "url": "https://sprites.dev/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fly.io",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "sprites.png",
      "sourceUrl": "https://claude.ai/directory/98670155-4f80-423f-949a-cde375c9668f",
      "publisherUrl": "https://fly.io/sprites"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "alpic",
      "name": "Alpic",
      "description": "Manage your MCP Servers and MCP Apps hosted on Alpic",
      "url": "https://mcp.alpic.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Alpic",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "alpic.png",
      "sourceUrl": "https://claude.ai/directory/3a931cc2-bfb7-463f-a2a5-dea7d1254d1e",
      "publisherUrl": "https://alpic.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "synthflow",
      "name": "Synthflow",
      "description": "Build and manage AI voice agents from chat",
      "url": "https://mcp.synthflow.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Synthflow.ai",
      "tags": ["communication", "data-analytics", "productivity"],
      "priority": "P2",
      "logo": "synthflow.svg",
      "sourceUrl": "https://claude.ai/directory/cd555870-e96b-4b83-aa83-014420901518",
      "publisherUrl": "https://synthflow.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "valuecase-app",
      "name": "Valuecase App",
      "description": "Search, create and update Valuecase spaces",
      "url": "https://mcp.valuecase.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Valuecase",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "valuecase-app.png",
      "sourceUrl": "https://claude.ai/directory/e49222d4-ea6f-4f0a-b7ad-5635bf3bde38",
      "publisherUrl": "https://valuecase.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "meridian-ai",
      "name": "Meridian AI",
      "description": "Query your deals, companies, documents, and more.",
      "url": "https://mcp.meridian-ai.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Meridian AI",
      "tags": ["communication", "data-analytics", "productivity"],
      "priority": "P2",
      "logo": "meridian-ai.png",
      "sourceUrl": "https://claude.ai/directory/8c21356f-1ccf-43a9-a0dd-736b64c0a87d",
      "publisherUrl": "https://www.meridian-ai.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "rockhopper",
      "name": "Rockhopper",
      "description": "Spreadsheet audit and observability for finance teams working with AI agents.",
      "url": "https://mcp.rockhopper.co/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Rockhopper Inc.",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "rockhopper.png",
      "sourceUrl": "https://claude.ai/directory/94867493-5b74-4124-82ac-c6d2e43ea52e",
      "publisherUrl": "https://www.rockhopper.co/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "dext",
      "name": "Dext",
      "description": "For accounting and bookkeeping firms: ask Dext about client data health, VAT and CT positions, aged debt, workflow and team capacity - across one client or your whole portfolio. Read-only.",
      "url": "https://app.dext.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Dext",
      "tags": ["financial-services", "productivity"],
      "priority": "P2",
      "logo": "dext.png",
      "sourceUrl": "https://claude.ai/directory/e8478db2-5336-4f7f-9c15-093427a88b89",
      "publisherUrl": "https://dext.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "extend",
      "name": "Extend",
      "description": "Turn documents into structured data",
      "url": "https://mcp.extend.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Extend",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "extend.png",
      "sourceUrl": "https://claude.ai/directory/1e23b148-2355-4ead-95e9-9b9b359985f7",
      "publisherUrl": "https://www.extend.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "breezy-hr",
      "name": "Breezy HR",
      "description": "Turn a conversation with Claude into actual work. Connect to Breezy to manage your hiring workflow, from job creation to reporting on hiring activity",
      "url": "https://mcp.breezy.hr/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Breezy HR",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "breezy-hr.png",
      "sourceUrl": "https://claude.ai/directory/c276ba8e-3729-450d-817f-1a97e291a62d",
      "publisherUrl": "https://breezy.hr/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "vasara",
      "name": "Vasara",
      "description": "Search case law and legislation across Lithuania and the EU, with verifiable citations.",
      "url": "https://mcp.vasara.ai/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vasara",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "vasara.png",
      "sourceUrl": "https://claude.ai/directory/73be62dc-6aed-4263-804c-ada9a6323a8e",
      "publisherUrl": "https://vasara.ai/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "restream",
      "name": "Restream",
      "description": "Create and manage live streams on 30+ destinations",
      "url": "https://mcp.restream.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Restream",
      "tags": [
        "communication",
        "creative",
        "media-entertainment",
        "productivity",
        "sales-and-marketing"
      ],
      "priority": "P2",
      "logo": "restream.png",
      "sourceUrl": "https://claude.ai/directory/de6a5289-fc31-4202-872a-feee7a5bbd2c",
      "publisherUrl": "https://restream.io/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "sendcloud",
      "name": "Sendcloud",
      "description": "Manage your shipping without leaving the chat.",
      "url": "https://mcp.sendcloud.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Sendcloud",
      "tags": ["commerce-shopping", "productivity"],
      "priority": "P2",
      "logo": "sendcloud.png",
      "sourceUrl": "https://claude.ai/directory/c5d77c73-cb2d-4ba2-8acb-51134c335d56",
      "publisherUrl": "https://sendcloud.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "energy-aspects",
      "name": "Energy Aspects",
      "description": "Access Energy Aspects' energy market research and data",
      "url": "https://mcp.energyaspects.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Energy Aspects",
      "tags": ["data-analytics", "other"],
      "priority": "P2",
      "logo": "energy-aspects.png",
      "sourceUrl": "https://claude.ai/directory/33042f3c-59c4-44b1-b057-c0105031b31d",
      "publisherUrl": "https://www.energyaspects.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "bolna",
      "name": "bolna",
      "description": "Manage Bolna voice AI agents and review call history and transcripts from Claude.",
      "url": "https://mcp.bolna.ai/api/connector/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bolna",
      "tags": ["communication", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "bolna.png",
      "sourceUrl": "https://claude.ai/directory/fa067f0c-abcb-4a3c-8228-171a83b2e03a",
      "publisherUrl": "https://bolna.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "supersei-crm",
      "name": "Supersei CRM",
      "description": "Run your Supersei sales CRM from a conversation: leads, calls, WhatsApp, meetings, campaigns, reports and workspace setup, with exactly your permissions.",
      "url": "https://api.supersei.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Supersei",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "supersei-crm.png",
      "sourceUrl": "https://claude.ai/directory/212996f4-6857-4c69-b7a0-d50b6cf15301",
      "publisherUrl": "https://supersei.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "bill",
      "name": "BILL",
      "description": "Finance answers, where you need them.",
      "url": "https://gateway.prod.bill.com/ai-mcp-server/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "BILL",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "bill.png",
      "sourceUrl": "https://claude.ai/directory/15d44cf2-b1c7-4109-93c6-bab471ab5f33",
      "publisherUrl": "https://www.bill.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "keel",
      "name": "Keel",
      "description": "Build & backtest Hyperliquid strategies",
      "url": "https://mcp.usekeel.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Keel Software, Inc.",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "keel.png",
      "sourceUrl": "https://claude.ai/directory/5d401eef-9944-4811-8204-96e40dc752dd",
      "publisherUrl": "https://usekeel.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "mollie",
      "name": "Mollie",
      "description": "Online and in-person payments, subscriptions, funding, reconciliation, and fraud prevention – so growth never means more providers.",
      "url": "https://mcp.mollie.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mollie B.V.",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "mollie.png",
      "sourceUrl": "https://claude.ai/directory/7407d19d-d56f-4701-99d5-b33cdb08ab7f",
      "publisherUrl": "https://mollie.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "rocket-lawyer",
      "name": "Rocket Lawyer",
      "description": "Attorney access for contract reviews & legal protection",
      "url": "https://api.rocketlawyer.com/mcp-du/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Rocket Lawyer, Inc.",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "rocket-lawyer.png",
      "sourceUrl": "https://claude.ai/directory/c67ec61e-2669-4917-85f3-88a8c29a9451",
      "publisherUrl": "https://www.rocketlawyer.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "vibe-ai",
      "name": "Vibe AI",
      "description": "Transcripts, summaries, action items, and memos from your Vibe Bot and Vibe Dot meetings",
      "url": "https://mcp.vibe.us/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Vibe Inc",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "vibe-ai.png",
      "sourceUrl": "https://claude.ai/directory/7f525b50-0315-45f2-9bcb-5b4c08bcd129",
      "publisherUrl": "https://vibe.us/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "omega-point",
      "name": "Omega Point",
      "description": "Turn market, index, and portfolio data into decisions: institutional risk, performance, and factor analytics in one place.",
      "url": "https://mcp.ompnt.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Omega Point",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "omega-point.png",
      "sourceUrl": "https://claude.ai/directory/ee3fd8cf-3e83-4f46-96a1-dd5af097af46",
      "publisherUrl": "https://omegapoint.ai/?ref=claude-directory"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "mittwald",
      "name": "mittwald",
      "description": "Connect your agent to the mittwald managed container hosting platform",
      "url": "https://mcp.mittwald.de/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "mittwald",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "mittwald.png",
      "sourceUrl": "https://claude.ai/directory/cabfa505-c39d-4fe6-ab60-3b642d86a9b2",
      "publisherUrl": "https://mittwald.de/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "duvo",
      "name": "Duvo",
      "description": "Create, monitor, and manage your Duvo automations",
      "url": "https://api.duvo.ai/v2/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Duvo",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "duvo.png",
      "sourceUrl": "https://claude.ai/directory/c18411ac-92ca-44ca-92d6-e58ef0a58259",
      "publisherUrl": "https://duvo.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "astravue-app",
      "name": "Astravue App",
      "description": "Manage projects, tasks, and team workload in one place",
      "url": "https://api.astravue.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Astravue",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "astravue-app.png",
      "sourceUrl": "https://claude.ai/directory/ee8b5c29-7eb2-4735-a353-b9012c68b0ef",
      "publisherUrl": "https://astravue.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "haloo-trademark-clearance",
      "name": "Haloo Trademark Clearance",
      "description": "Full trademark clearance search, direct in Claude.",
      "url": "https://connect.haloo.ai/trademark-search/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Haloo Inc",
      "tags": ["data-analytics", "legal", "productivity"],
      "priority": "P2",
      "logo": "haloo-trademark-clearance.png",
      "sourceUrl": "https://claude.ai/directory/d80c170f-bfc4-4839-9cb4-cc295d228883",
      "publisherUrl": "https://haloo.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "hanover-park",
      "name": "Hanover Park",
      "description": "Run your investment firm in real-time with access to portfolio, accounting, performance and LP data.",
      "url": "https://app.hanoverpark.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hanover Park",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "hanover-park.png",
      "sourceUrl": "https://claude.ai/directory/f32ec4e2-fa7c-49b8-9835-98bd82641dc8",
      "publisherUrl": "https://www.hanoverpark.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "chatbase",
      "name": "Chatbase",
      "description": "Manage Chatbase agents, sources, conversations, tickets.",
      "url": "https://mcp.chatbase.co/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Chatbase",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "chatbase.png",
      "sourceUrl": "https://claude.ai/directory/48ba489e-160f-4965-913b-667cce063da2",
      "publisherUrl": "https://www.chatbase.co/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "pine-labs-payments-assistant",
      "name": "Pine Labs Payments Assistant",
      "description": "Query your Pine Labs payments data in plain language — orders, transactions, settlements, subscriptions and success rates, plus integration help for developers.",
      "url": "https://mcp.pinelabs.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pine Labs",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "pine-labs-payments-assistant.svg",
      "sourceUrl": "https://claude.ai/directory/b20c4865-4ef3-4a57-8f8f-7e36f4fe4e89",
      "publisherUrl": "https://www.pinelabs.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "agility-cms",
      "name": "Agility CMS",
      "description": "AI pipelines for developers and marketers. Model content, author pages, publish updates, and manage media across multiple Agility CMS instances through natural language.",
      "url": "https://mcp.agilitycms.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Agility CMS",
      "tags": ["developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "agility-cms.png",
      "sourceUrl": "https://claude.ai/directory/225d5116-af54-410f-b553-d706bb869014",
      "publisherUrl": "https://agilitycms.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "checkout-com",
      "name": "Checkout.com",
      "description": "Investigate, troubleshoot, and understand payment operations.",
      "url": "https://mcp.checkout.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Checkout.com",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "checkout-com.png",
      "sourceUrl": "https://claude.ai/directory/6b9d0b1b-cc83-4dae-8212-e0b4f3bde20a",
      "publisherUrl": "https://www.checkout.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "dualentry",
      "name": "DualEntry",
      "description": "Search, create, and manage your DualEntry accounting data",
      "url": "https://api.dualentry.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "DualEntry",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "dualentry.png",
      "sourceUrl": "https://claude.ai/directory/ccd9d644-a951-4168-aa2c-ebc3c7a54ae6",
      "publisherUrl": "https://dualentry.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "papermark",
      "name": "Papermark",
      "description": "Manage your data rooms and tracked documents from Claude",
      "url": "https://mcp.papermark.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Papermark",
      "tags": ["financial-services", "legal", "productivity"],
      "priority": "P2",
      "logo": "papermark.png",
      "sourceUrl": "https://claude.ai/directory/4b0cc0a6-8e58-413f-820e-b00f9c96b7c4",
      "publisherUrl": "https://www.papermark.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "cashfree",
      "name": "Cashfree",
      "description": "Your All in One AI Assistant",
      "url": "https://mcp.cashfree.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Cashfree Payments Pvt. Ltd.",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "cashfree.png",
      "sourceUrl": "https://claude.ai/directory/003f921f-d0e6-4dd9-a1c1-38af9bc831d2",
      "publisherUrl": "https://www.cashfree.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "august",
      "name": "august",
      "description": "Understand your users with august Digital Twins",
      "url": "https://mcp.getaugust.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Fermat Commerce",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "august.png",
      "sourceUrl": "https://claude.ai/directory/7226c76b-649d-472c-8c57-cb4af2c419db",
      "publisherUrl": "https://getaugust.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "item",
      "name": "item",
      "description": "Search, analyze, and act on CRM data",
      "url": "https://mcp.item.app/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "item",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "item.png",
      "sourceUrl": "https://claude.ai/directory/f3c7ae42-8124-4037-9937-838e6ce97081",
      "publisherUrl": "https://item.app/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "meko",
      "name": "Meko",
      "description": "Shared context for agents that work and learn together.",
      "url": "https://mcp.mekodata.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "YugabyteDB",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "meko.png",
      "sourceUrl": "https://claude.ai/directory/d7e0c27c-a722-420a-ae2c-e4fb16ea853e",
      "publisherUrl": "https://www.mekodata.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "revealed",
      "name": "Revealed",
      "description": "Always-on sales intelligence for healthcare",
      "url": "https://mcp.revealed.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Assure AI, Inc (dba Revealed)",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P2",
      "logo": "revealed.png",
      "sourceUrl": "https://claude.ai/directory/ce1d70d0-7b9b-490e-ac48-45b42d96540c",
      "publisherUrl": "https://www.revealed.ai/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "aftership-post-purchase",
      "name": "AfterShip Post-Purchase",
      "description": "Track shipments and returns with AfterShip context",
      "url": "https://mcp.aftership.com/post-purchase",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AfterShip",
      "tags": ["commerce-shopping"],
      "priority": "P2",
      "logo": "aftership-post-purchase.svg",
      "sourceUrl": "https://claude.ai/directory/5416a6ef-1df5-44a6-a9b0-fb90a57625d1",
      "publisherUrl": "https://www.aftership.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "dagster",
      "name": "Dagster+",
      "description": "Investigate issues and take action in your Dagster+ deployment from Claude.",
      "url": "https://mcp.agent.dagster.cloud/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Prefect",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P2",
      "logo": "dagster.png",
      "sourceUrl": "https://claude.ai/directory/d3920698-6e07-4f44-9572-c6a52ada0c2b",
      "publisherUrl": "https://prefect.io/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "tana",
      "name": "Tana",
      "description": "Your meetings, decisions, and docs as Claude context.",
      "url": "https://home.tana.inc/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tana Labs, Inc.",
      "tags": ["communication", "productivity"],
      "priority": "P2",
      "logo": "tana.png",
      "sourceUrl": "https://claude.ai/directory/5aa751b0-19fc-45a6-a0a0-64aad866f4a8",
      "publisherUrl": "https://tana.inc/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "spara",
      "name": "Spara",
      "description": "Build the agents that run your GTM.",
      "url": "https://app.spara.co/mcp/customer/stream",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Spara, Inc.",
      "tags": ["data-analytics", "sales-and-marketing"],
      "priority": "P2",
      "logo": "spara.png",
      "sourceUrl": "https://claude.ai/directory/2d98f504-8ad8-4f8a-95f8-709ca97e3ffd",
      "publisherUrl": "https://www.spara.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "entendre",
      "name": "Entendre",
      "description": "Manage accounting and reporting with agents",
      "url": "https://mcp.entendre.finance/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Entendre AI",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "entendre.png",
      "sourceUrl": "https://claude.ai/directory/2041628e-b7b0-4a73-89fa-0a95b952468c",
      "publisherUrl": "https://entendre.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "dandb-hoovers",
      "name": "D&B Hoovers",
      "description": "Access trusted D&B intelligence, contacts, and signals to uncover opportunities and take the next best action.",
      "url": "https://mcp.hoovers.dnb.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Dun & Bradstreet",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "dandb-hoovers.png",
      "sourceUrl": "https://claude.ai/directory/94d5d3c5-5968-44b0-8fdb-22d55ed77a00",
      "publisherUrl": "https://www.dnb.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "trainual",
      "name": "Trainual",
      "description": "Ground Claude in how your company actually operates — documented processes, training progress, goals, scorecards, and meeting history from Trainual.",
      "url": "https://mcp.trainual.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Trainual",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "trainual.png",
      "sourceUrl": "https://claude.ai/directory/cf5e1558-6e8c-4c37-8273-e8efb63a8f46",
      "publisherUrl": "https://trainual.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "savri",
      "name": "Savri",
      "description": "Privacy-friendly web analytics, ask in plain English.",
      "url": "https://savri.io/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Digisol AB",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "savri.png",
      "sourceUrl": "https://claude.ai/directory/baa6ade8-0c2d-45c8-bb0b-695e2e5307e4",
      "publisherUrl": "https://savri.io/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "clerq",
      "name": "Clerq",
      "description": "AI-powered patent retrieval and analysis capabilities",
      "url": "https://mcp.us.clerq-ip.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Clerq",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "clerq.png",
      "sourceUrl": "https://claude.ai/directory/19033db0-eb00-4345-b8e9-eb4ad2292dcc",
      "publisherUrl": "https://www.clerq-ip.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "mojo-pocket-capture",
      "name": "Mojo — Pocket Capture",
      "description": "Talk to your leads, funnel, and capture setup",
      "url": "https://mcp.mojosystems.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mojo Systems LLC",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "mojo-pocket-capture.svg",
      "sourceUrl": "https://claude.ai/directory/202d94d6-4c9e-4334-83fe-fb63b696e2c8",
      "publisherUrl": "https://www.mojosystems.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "bronto",
      "name": "Bronto",
      "description": "Query your Observability data in plain language, then turn what you find into monitors, saved searches, and Investigation Reports.",
      "url": "https://mcp.eu.bronto.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bronto",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "bronto.png",
      "sourceUrl": "https://claude.ai/directory/b5c89e56-5e04-4871-9ecd-6bdcf5d6ec62",
      "publisherUrl": "https://bronto.io/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "honeybadger",
      "name": "Honeybadger",
      "description": "Investigate production errors, query logs, and manage dashboards and alarms from your AI assistant",
      "url": "https://mcp.honeybadger.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Honeybadger",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P2",
      "logo": "honeybadger.png",
      "sourceUrl": "https://claude.ai/directory/ce420c56-758f-48c2-ac7f-5ca589042af7",
      "publisherUrl": "https://www.honeybadger.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "kepler",
      "name": "Kepler",
      "description": "Connect your Kepler account for sourced financial analysis and model building",
      "url": "https://mcp.kepler.ai/api/mcp/v1",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Kepler",
      "tags": ["financial-services", "productivity"],
      "priority": "P2",
      "logo": "kepler.png",
      "sourceUrl": "https://claude.ai/directory/50690df1-6912-4a59-b30f-d7ae70d08c01",
      "publisherUrl": "https://kepler.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "numbersgame",
      "name": "NumbersGame",
      "description": "Query and update QuickBooks Online and Xero from Claude — invoices, bills, reports, and reconciliations.",
      "url": "https://mcp.numbersgame.xyz/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Numbers Game B.V.",
      "tags": ["financial-services", "productivity"],
      "priority": "P2",
      "logo": "numbersgame.png",
      "sourceUrl": "https://claude.ai/directory/e76c8700-3129-4de0-ada4-11cebdb27e15",
      "publisherUrl": "https://numbersgame.xyz/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "signeasy",
      "name": "Signeasy",
      "description": "Track contract status, activity, and signers",
      "url": "https://mcp.signeasy.com/mcp/sse",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Signeasy",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "signeasy.png",
      "sourceUrl": "https://claude.ai/directory/219ef2ba-096a-4a99-ac90-d4c13b482a88",
      "publisherUrl": "https://signeasy.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "belvo",
      "name": "Belvo",
      "description": "Understand your finances on your own terms",
      "url": "https://panorama-mcp.belvo.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Belvo",
      "tags": ["data-analytics", "financial-services"],
      "priority": "P2",
      "logo": "belvo.svg",
      "sourceUrl": "https://claude.ai/directory/37b45397-dbef-41bd-ae7f-ec850557cd45",
      "publisherUrl": "https://belvo.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "rsvpify",
      "name": "RSVPify",
      "description": "Run your event operations in RSVPify, end-to-end",
      "url": "https://mcp.rsvpify.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "RSVPify Inc.",
      "tags": ["communication", "nonprofit", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "rsvpify.png",
      "sourceUrl": "https://claude.ai/directory/10622bb7-fadd-4edf-bf2d-29d73138711e",
      "publisherUrl": "https://rsvpify.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "cloudbees-unify",
      "name": "CloudBees Unify",
      "description": "Connect AI agents to CloudBees Unify: feature flags, CI/CD, release orchestration, and security",
      "url": "https://mcp.cloudbees.io/v1/mcp?toolset=all",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "CloudBees",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "cloudbees-unify.png",
      "sourceUrl": "https://claude.ai/directory/cd12e050-6c36-4d6a-8865-95e7d2743c41",
      "publisherUrl": "http://cloudbees.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "lightbringer",
      "name": "Lightbringer",
      "description": "Patent and invention management for your AI assistant — search your portfolio, draft, validate and submit inventions, and collaborate on patent reviews without leaving the chat.",
      "url": "https://mcp.lightbringer.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lightbringer",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "lightbringer.png",
      "sourceUrl": "https://claude.ai/directory/64c754d2-d5af-42de-8c7e-9a3d8d604f60",
      "publisherUrl": "https://lightbringer.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "infotrack",
      "name": "InfoTrack",
      "description": "Australian legal, property and compliance searches",
      "url": "https://mcp.infotrack.ai/servers/infotrack-all/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "InfoTrack Australia",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "infotrack.png",
      "sourceUrl": "https://claude.ai/directory/9d0b8983-8fad-4238-a87a-921e437ea117",
      "publisherUrl": "https://www.infotrack.ai/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "ai-producer-by-opusclip",
      "name": "AI Producer by OpusClip",
      "description": "Edit videos with AI",
      "url": "https://producer.opus.pro/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "OpusClip Inc.",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "ai-producer-by-opusclip.png",
      "sourceUrl": "https://claude.ai/directory/3944f79f-c1a8-40ef-9f8e-d24f6d0f3f08",
      "publisherUrl": "https://www.opus.pro/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "bitmovin",
      "name": "Bitmovin",
      "description": "Connect Bitmovin to access player, observability, encoding, ads and more in one place",
      "url": "https://mcp.bitmovin.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Bitmovin",
      "tags": ["media-entertainment"],
      "priority": "P2",
      "logo": "bitmovin.png",
      "sourceUrl": "https://claude.ai/directory/8ce692ed-12b2-476f-8f1b-44fabef88cf0",
      "publisherUrl": "https://bitmovin.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "sparxx-io",
      "name": "spArxx.io",
      "description": "Prove you made it first. Timestamp your creative work on the blockchain via Claude or any MCP-enabled AI agent.",
      "url": "https://gateway.sparxx.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "spArxx.io",
      "tags": ["creative", "developer-tools", "legal", "media-entertainment", "productivity"],
      "priority": "P2",
      "logo": "sparxx-io.png",
      "sourceUrl": "https://claude.ai/directory/d401ca21-adb0-480c-bc89-dbd8c6ebf3af",
      "publisherUrl": "https://www.sparxx.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "lseg-ai",
      "name": "LSEG AI",
      "description": "Data Analytics and Trading",
      "url": "https://mcp.lseg.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LSEG",
      "tags": ["financial-services"],
      "priority": "P2",
      "logo": "lseg-ai.png",
      "sourceUrl": "https://claude.ai/directory/1195d151-ccdb-4f4b-bf57-2b4ce425055c",
      "publisherUrl": "https://www.lseg.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "plotly-cloud",
      "name": "Plotly Cloud",
      "description": "Build and deploy Plotly Dash apps to Plotly Cloud from a conversation with Claude.",
      "url": "https://cloud.plotly.com/_mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Plotly",
      "tags": ["data-analytics", "developer-tools", "productivity"],
      "priority": "P2",
      "logo": "plotly-cloud.png",
      "sourceUrl": "https://claude.ai/directory/0ccc351d-aa82-4d5a-bed6-2035e79914d8",
      "publisherUrl": "https://plotly.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "neimo",
      "name": "neimo.",
      "description": "Answer any kids' privacy or age-assurance question for 200+ markets, with the law cited.",
      "url": "https://mcp.neimo.ai/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "k-ID",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "neimo.svg",
      "sourceUrl": "https://claude.ai/directory/b7b6a760-4653-44aa-9613-8da54e589df1",
      "publisherUrl": "https://k-id.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "infobip-documentation",
      "name": "Infobip Documentation",
      "description": "Search and browse Infobip docs from Claude",
      "url": "https://mcp.infobip.com/search",
      "auth": "none",
      "oneClick": true,
      "publisher": "Infobip",
      "tags": ["communication"],
      "priority": "P2",
      "logo": "infobip-documentation.png",
      "sourceUrl": "https://claude.ai/directory/e8158a73-1228-4901-82dd-2ebb6b6bf85d",
      "publisherUrl": "https://infobip.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "breezing",
      "name": "Breezing",
      "description": "Crypto accounting for Xero, QuickBooks and Bexio Alternative: Categorize, reconcile and book crypto in your ledger",
      "url": "https://mcp.breezing.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Breezing SA",
      "tags": ["developer-tools", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "breezing.png",
      "sourceUrl": "https://claude.ai/directory/6af0ef66-c76e-4ce1-a63d-95554e60b4ca",
      "publisherUrl": "https://breezing.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "clutch-co",
      "name": "Clutch.co",
      "description": "Find the perfect B2B company with verified client reviews",
      "url": "https://bot.clutch.co/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Clutch Co LLC",
      "tags": ["productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "clutch-co.png",
      "sourceUrl": "https://claude.ai/directory/318ca654-e47c-4bbd-b602-c34c4d3b9b64",
      "publisherUrl": "https://clutch.co/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "pointone",
      "name": "PointOne",
      "description": "Timekeeping and firm intelligence",
      "url": "https://mcp.pointone.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "PointOne Technologies Inc.",
      "tags": ["data-analytics", "legal", "productivity"],
      "priority": "P2",
      "logo": "pointone.png",
      "sourceUrl": "https://claude.ai/directory/08c6eea4-6ecb-4e0e-8487-97eed2241965",
      "publisherUrl": "https://pointone.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "smarter-drafter",
      "name": "Smarter Drafter",
      "description": "Draft client-ready legal documents from your firm's approved templates, inside Claude.",
      "url": "https://mcp.smarterdrafter.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tensis",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "smarter-drafter.png",
      "sourceUrl": "https://claude.ai/directory/ec9af272-d785-4f83-9475-83453aac8860",
      "publisherUrl": "https://tensis.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "muumuu-domain-bygmo-pepabo",
      "name": "MuuMuu Domain byGMO Pepabo",
      "description": "ムームードメインと接続し、ドメインの空き検索・価格確認から購入手続きまでを会話で進められます。決済はムームードメインのサイト上でご自身が完了させる方式です。保有ドメインの一覧・詳細確認、ネームサーバーの確認・変更、DNSレコードの一覧・作成・更新・削除、更新日や自動更新設定の確認・変更にも対応します。",
      "url": "https://mcp.muumuu-domain.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GMO Pepabo, Inc.",
      "tags": ["developer-tools", "productivity"],
      "priority": "P2",
      "logo": "muumuu-domain-bygmo-pepabo.png",
      "sourceUrl": "https://claude.ai/directory/91dac02b-3f5f-4afe-bfa2-29e04321138a",
      "publisherUrl": "https://muumuu-domain.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "dandb-digital-audiences",
      "name": "D&B Digital Audiences",
      "description": "Discover the Right Audiences Faster",
      "url": "https://mcp.atportal.dnb.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Dun & Bradstreet",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "dandb-digital-audiences.png",
      "sourceUrl": "https://claude.ai/directory/f755792f-9dfd-451f-b5cd-09762c9b783e",
      "publisherUrl": "https://www.dnb.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "wisdomai",
      "name": "WisdomAI",
      "description": "Trustworthy answers from your governed enterprise data",
      "url": "https://mcp.wisdom.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "WisdomAI",
      "tags": ["data-analytics", "productivity"],
      "priority": "P2",
      "logo": "wisdomai.png",
      "sourceUrl": "https://claude.ai/directory/e17dcc6c-22e7-4321-af6f-876135866c93",
      "publisherUrl": "https://www.wisdom.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "steadybit",
      "name": "Steadybit",
      "description": "Find reliability risks in your systems: design, run, and analyze chaos experiments.",
      "url": "https://platform.steadybit.com/mcp/demo",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Steadybit",
      "tags": ["developer-tools"],
      "priority": "P2",
      "logo": "steadybit.svg",
      "sourceUrl": "https://claude.ai/directory/9bc77b8c-6d80-496a-a64f-716626251ce2",
      "publisherUrl": "https://steadybit.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "aditus-evo",
      "name": "ADITUS Evo",
      "description": "ADITUS Evo translates the complexity of modern events into clear insights and makes data-driven decisions easier than ever.",
      "url": "https://mcp.aditus.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "ADITUS GmbH",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "aditus-evo.png",
      "sourceUrl": "https://claude.ai/directory/9450bc97-b8e5-4ebf-95be-b4b868d88f29",
      "publisherUrl": "https://www.aditus.com/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "mary",
      "name": "Mary",
      "description": "Organise, extract, draft, and verify the facts of your matter",
      "url": "https://mcp.us.marytechnology.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mary",
      "tags": ["legal", "productivity"],
      "priority": "P2",
      "logo": "mary.png",
      "sourceUrl": "https://claude.ai/directory/3b2493bf-a122-4fe0-93c8-86be8739dea8",
      "publisherUrl": "https://marytechnology.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "pushwoosh-manymoney",
      "name": "Pushwoosh ManyMoney",
      "description": "Drive your Pushwoosh project in natural language — build segments, presets, and customer journeys, diagnose delivery, and analyze campaign performance, right from your AI client.",
      "url": "https://manymoney.pushwoosh.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pushwoosh",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "pushwoosh-manymoney.svg",
      "sourceUrl": "https://claude.ai/directory/b969c85d-c577-4d3b-b85d-678a787fa86f",
      "publisherUrl": "https://www.pushwoosh.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "maia",
      "name": "MAIA",
      "description": "The geospatial research engine: get answers from the physical world, built as map and table datasets.",
      "url": "https://api.maia-analytics.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "MAIA Analytics",
      "tags": ["data-analytics"],
      "priority": "P2",
      "logo": "maia.png",
      "sourceUrl": "https://claude.ai/directory/91a07e99-0c2b-43f4-a79f-425e148a90a1",
      "publisherUrl": "https://www.maia-analytics.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "agri-mcp-tcit-cl",
      "name": "agri-mcp.tcit.cl",
      "description": "Manage farm operations in AGRI: labor tasks, harvest, irrigation, inventory, purchasing and cost reports.",
      "url": "https://agri-mcp.tcit.cl/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "AGRI SpA",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "agri-mcp-tcit-cl.png",
      "sourceUrl": "https://claude.ai/directory/cac92b99-3982-404c-befe-f94e056e119a",
      "publisherUrl": "https://www.agri.so/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "notra",
      "name": "Notra",
      "description": "Track AI search visibility",
      "url": "https://mcp.usenotra.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Notra, Inc.",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "notra.png",
      "sourceUrl": "https://claude.ai/directory/4ac9c738-d169-4d77-abe9-5fb6cfefcab1",
      "publisherUrl": "https://www.usenotra.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "merchkit",
      "name": "Merchkit",
      "description": "AI-Native Product Catalog (PIM / PXM / Product Feed / Agentic Commerce Optimization)",
      "url": "https://www.merchkit.com/api/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Merchkit",
      "tags": ["commerce-shopping", "data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "merchkit.png",
      "sourceUrl": "https://claude.ai/directory/18589e69-0de8-4b1c-86e2-873d38920815",
      "publisherUrl": "https://merchkit.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "vylo",
      "name": "Vylo",
      "description": "Your meeting memory",
      "url": "https://mcp.vylo.one/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "WheelsEye Technology India Private Limited",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "vylo.png",
      "sourceUrl": "https://claude.ai/directory/97a9b697-9fe4-4796-9f9a-a4aac23ce162",
      "publisherUrl": "https://vylo.one/"
    },
    {
      "category": "Legal",
      "subcategory": "Legal",
      "id": "linksquares",
      "name": "LinkSquares",
      "description": "Automate legal intake and contract intelligence — create agreements, manage legal requests, and search your contract data directly from Claude.",
      "url": "https://ai-chat-service.linksquares.com/v1/mcp/external",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LinkSquares, Inc.",
      "tags": ["legal"],
      "priority": "P2",
      "logo": "linksquares.png",
      "sourceUrl": "https://claude.ai/directory/2f3d24ba-924c-41b3-8485-6b3e39cab8b0",
      "publisherUrl": "https://linksquares.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "growsurf",
      "name": "GrowSurf",
      "description": "Build and manage GrowSurf referral and affiliate programs with Claude.",
      "url": "https://mcp.growsurf.com/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "GrowSurf",
      "tags": ["sales-and-marketing"],
      "priority": "P2",
      "logo": "growsurf.png",
      "sourceUrl": "https://claude.ai/directory/c2dd8dfc-7583-42dc-a7cb-5c09b8b30cdd",
      "publisherUrl": "https://growsurf.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Commerce & operations",
      "id": "adspirer-search-ads",
      "name": "Adspirer Search Ads",
      "description": "PPC and paid search agent for Google Ads and Microsoft Advertising (Bing Ads) — does competitor ads research, plans, launches, and autonomously runs your search advertising campaigns.",
      "url": "https://mcp.adspirer.com/search-ads",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adspirer",
      "tags": ["commerce-shopping", "data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "adspirer-search-ads.png",
      "sourceUrl": "https://claude.ai/directory/4538ebb9-328c-4b1e-b6b9-470086110e04",
      "publisherUrl": "https://www.adspirer.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "promptless",
      "name": "Promptless",
      "description": "Search, read, and edit your documentation",
      "url": "https://api.gopromptless.ai/mcp/with-direct-edits",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Promptless",
      "tags": ["developer-tools", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "promptless.png",
      "sourceUrl": "https://claude.ai/directory/edb58d4d-3a6e-4950-a748-02d45a9e863c",
      "publisherUrl": "https://promptless.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "community-funding-nz",
      "name": "Community Funding NZ",
      "description": "Search 380+ New Zealand community grant funders, with deadlines, priorities and application questions, so your AI can find funders and draft applications.",
      "url": "https://funding.alltoohuman.nz/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "All Too Human",
      "tags": ["data-analytics", "nonprofit", "other", "productivity"],
      "priority": "P2",
      "logo": "community-funding-nz.png",
      "sourceUrl": "https://claude.ai/directory/ad769618-224f-44d1-ad5f-bb66078683b0",
      "publisherUrl": "https://www.alltoohuman.nz/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "mantic",
      "name": "Mantic",
      "description": "Explore judgemental forecasts",
      "url": "https://api.mantic.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Mantic Technologies Ltd",
      "tags": ["productivity"],
      "priority": "P2",
      "logo": "mantic.png",
      "sourceUrl": "https://claude.ai/directory/ccc1bcfc-193c-44b7-b443-9511aac18403",
      "publisherUrl": "https://www.mantic.com/"
    },
    {
      "category": "Product",
      "subcategory": "Productivity",
      "id": "trustfull",
      "name": "Trustfull",
      "description": "Bring Trustfull fraud intelligence and risk assessments into Claude.",
      "url": "https://mcp.trustfull.com/connector",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Trustfull",
      "tags": ["other"],
      "priority": "P2",
      "logo": "trustfull.png",
      "sourceUrl": "https://claude.ai/directory/09eda2e9-fc25-496e-ab57-e9f35d0c92ca",
      "publisherUrl": "https://www.trustfull.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales & marketing data",
      "id": "adspirer-social-ads",
      "name": "Adspirer Social Ads",
      "description": "Paid social agent for Meta Ads (Facebook & Instagram) and TikTok Ads — researches competitor ads, plans, launches (paused) and autonomously runs your social advertising campaigns.",
      "url": "https://mcp.adspirer.com/social-ads",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Adspirer",
      "tags": ["data-analytics", "productivity", "sales-and-marketing"],
      "priority": "P2",
      "logo": "adspirer-social-ads.png",
      "sourceUrl": "https://claude.ai/directory/100b4dba-8d88-4bac-89b3-ba80262f51c0",
      "publisherUrl": "https://www.adspirer.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "meridian-connector-for-xero",
      "name": "Meridian Connector for Xero",
      "description": "Make changes to Xero from within Claude",
      "url": "https://xero-connector.meridian.pilot.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Pilot.com, Inc.",
      "tags": ["data-analytics", "financial-services", "productivity"],
      "priority": "P2",
      "logo": "meridian-connector-for-xero.png",
      "sourceUrl": "https://claude.ai/directory/a1f53698-70c1-4bb3-af51-8593eee64276",
      "publisherUrl": "https://meridian.pilot.com/"
    },
    {
      "category": "Research",
      "subcategory": "Life sciences & health",
      "id": "tomorrow-io",
      "name": "Tomorrow.io",
      "description": "Interactive weather, air quality, pollen, and wildfire-risk widgets powered by Tomorrow.io — live forecasts and conditions for any location, right inside Claude",
      "url": "https://api.tomorrow.io/v4/weather-intelligence/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "Tomorrow.io",
      "tags": ["health-life-sciences", "other", "travel"],
      "priority": "P2",
      "logo": "tomorrow-io.png",
      "sourceUrl": "https://claude.ai/directory/032fc35c-fdc2-42e0-a5c0-372d52ccb605",
      "publisherUrl": "https://www.tomorrow.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "modjo",
      "name": "Modjo",
      "description": "Search recorded sales calls, transcripts and deal insights.",
      "url": "https://api.mcp.modjo.ai/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Modjo",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "modjo.png",
      "sourceUrl": "https://help.modjo.ai/articles/15459539",
      "publisherUrl": "https://www.modjo.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "perplexity",
      "name": "Perplexity",
      "description": "Search the web and get cited answers from Perplexity.",
      "url": "https://api.perplexity.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Perplexity",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "perplexity.png",
      "sourceUrl": "https://docs.perplexity.ai/guides/mcp-server",
      "publisherUrl": "https://www.perplexity.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Knowledge & files",
      "id": "slite",
      "name": "Slite",
      "description": "Search and edit your team's Slite docs.",
      "url": "https://api.slite.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Slite",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "slite.png",
      "sourceUrl": "https://slite.com/help/lmeen-YwXupV23",
      "publisherUrl": "https://slite.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "typeform",
      "name": "Typeform",
      "description": "Create forms and read responses from Typeform.",
      "url": "https://api.typeform.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Typeform",
      "tags": ["sales-and-marketing", "productivity"],
      "priority": "P1",
      "logo": "typeform.png",
      "sourceUrl": "https://www.typeform.com/developers/mcp/",
      "publisherUrl": "https://www.typeform.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "val-town",
      "name": "Val Town",
      "description": "Write, run and deploy vals on Val Town.",
      "url": "https://api.val.town/v3/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Val Town",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "val-town.png",
      "sourceUrl": "https://docs.val.town/guides/prompting/mcp",
      "publisherUrl": "https://www.val.town/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "wistia",
      "name": "Wistia",
      "description": "Manage videos, captions and viewing stats in Wistia.",
      "url": "https://api.wistia.com/mcp/api",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Wistia",
      "tags": ["creative", "sales-and-marketing"],
      "priority": "P1",
      "logo": "wistia.png",
      "sourceUrl": "https://docs.wistia.com/docs/mcp-server-guide",
      "publisherUrl": "https://wistia.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "hex",
      "name": "Hex",
      "description": "Query data and work with projects in Hex.",
      "url": "https://app.hex.tech/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hex",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "hex.png",
      "sourceUrl": "https://learn.hex.tech/docs/api-integrations/mcp-server",
      "publisherUrl": "https://hex.tech/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales engagement",
      "id": "lemlist",
      "name": "lemlist",
      "description": "Manage outreach campaigns, leads and replies in lemlist.",
      "url": "https://app.lemlist.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "lemlist",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "lemlist.png",
      "sourceUrl": "https://help.lemlist.com/en/articles/13728466-set-up-the-lemlist-mcp-server-in-your-llm-client-oauth-or-api-key",
      "publisherUrl": "https://www.lemlist.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "swarmia",
      "name": "Swarmia",
      "description": "Engineering metrics, investment balance and team insights from Swarmia.",
      "url": "https://app.swarmia.com/api/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Swarmia",
      "tags": ["developer-tools", "data-analytics"],
      "priority": "P1",
      "logo": "swarmia.png",
      "sourceUrl": "https://help.swarmia.com/settings/integrations/mcp-server",
      "publisherUrl": "https://www.swarmia.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "airbyte",
      "name": "Airbyte",
      "description": "Manage data pipelines and connections in Airbyte Cloud.",
      "url": "https://mcp.airbyte.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Airbyte",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P1",
      "logo": "airbyte.png",
      "sourceUrl": "https://docs.airbyte.com/platform/airbyte-mcp/install",
      "publisherUrl": "https://airbyte.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "apify",
      "name": "Apify",
      "description": "Run Apify actors to scrape websites and collect data.",
      "url": "https://mcp.apify.com",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Apify",
      "tags": ["data-analytics", "developer-tools"],
      "priority": "P1",
      "logo": "apify.png",
      "sourceUrl": "https://docs.apify.com/platform/integrations/mcp",
      "publisherUrl": "https://apify.com/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "basecamp",
      "name": "Basecamp",
      "description": "Work with Basecamp projects, to-dos, messages and schedules.",
      "url": "https://mcp.basecamp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Basecamp",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "basecamp.png",
      "sourceUrl": "https://basecamp.com/mcp",
      "publisherUrl": "https://basecamp.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "customer-io",
      "name": "Customer.io",
      "description": "Manage people, segments, campaigns and messages in Customer.io.",
      "url": "https://mcp.customer.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Customer.io",
      "tags": ["sales-and-marketing", "communication"],
      "priority": "P1",
      "logo": "customer-io.png",
      "sourceUrl": "https://docs.customer.io/ai/mcp/",
      "publisherUrl": "https://customer.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "fullenrich",
      "name": "FullEnrich",
      "description": "Find verified emails and phone numbers for contacts.",
      "url": "https://mcp.fullenrich.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "FullEnrich",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "fullenrich.png",
      "sourceUrl": "https://help.fullenrich.com/en/articles/14190120-mcp-server",
      "publisherUrl": "https://fullenrich.com/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "gleap",
      "name": "Gleap",
      "description": "Read bug reports, feedback and support tickets in Gleap.",
      "url": "https://mcp.gleap.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gleap",
      "tags": ["productivity", "developer-tools"],
      "priority": "P1",
      "logo": "gleap.png",
      "sourceUrl": "https://docs.gleap.ai/documentation/surveys/mcp",
      "publisherUrl": "https://www.gleap.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "gong",
      "name": "Gong",
      "description": "Search calls, deals and customer conversations recorded in Gong.",
      "url": "https://mcp.gong.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gong",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "gong.png",
      "sourceUrl": "https://help.gong.io/docs/enable-supported-ai-tools-for-gong",
      "publisherUrl": "https://www.gong.io/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "gorgias",
      "name": "Gorgias",
      "description": "Read and answer customer support tickets in Gorgias.",
      "url": "https://mcp.gorgias.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Gorgias",
      "tags": ["commerce-shopping", "communication"],
      "priority": "P1",
      "logo": "gorgias.png",
      "sourceUrl": "https://docs.gorgias.com/en-US/connect-your-ai-assistant-to-gorgias-6310546",
      "publisherUrl": "https://www.gorgias.com/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "help-scout",
      "name": "Help Scout",
      "description": "Search Help Scout conversations and pull support reports.",
      "url": "https://mcp.helpscout.net/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Help Scout",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "help-scout.png",
      "sourceUrl": "https://docs.helpscout.com/article/1779-connect-your-ai-agent-with-help-scout-to-search-conversations-and-pull-reports",
      "publisherUrl": "https://www.helpscout.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "heygen",
      "name": "HeyGen",
      "description": "Create AI avatar videos with HeyGen.",
      "url": "https://mcp.heygen.com/mcp/v1/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "HeyGen",
      "tags": ["creative"],
      "priority": "P1",
      "logo": "heygen.png",
      "sourceUrl": "https://docs.heygen.com/docs/heygen-remote-mcp-server",
      "publisherUrl": "https://www.heygen.com/"
    },
    {
      "category": "Sales",
      "subcategory": "Prospecting & enrichment",
      "id": "hunter",
      "name": "Hunter",
      "description": "Find and verify professional email addresses.",
      "url": "https://mcp.hunter.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Hunter",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "hunter.png",
      "sourceUrl": "https://hunter.io/api-documentation#mcp",
      "publisherUrl": "https://hunter.io/"
    },
    {
      "category": "Sales",
      "subcategory": "Sales engagement",
      "id": "instantly",
      "name": "Instantly",
      "description": "Manage cold email campaigns, leads and replies in Instantly.",
      "url": "https://mcp.instantly.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Instantly",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "instantly.png",
      "sourceUrl": "https://help.instantly.ai/en/articles/12980002-instantly-mcp-model-context-protocol",
      "publisherUrl": "https://instantly.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "launchdarkly",
      "name": "LaunchDarkly",
      "description": "Create, update and inspect feature flags in LaunchDarkly.",
      "url": "https://mcp.launchdarkly.com/mcp/launchdarkly",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "LaunchDarkly",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "launchdarkly.png",
      "sourceUrl": "https://launchdarkly.com/docs/home/getting-started/mcp-hosted",
      "publisherUrl": "https://launchdarkly.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "lokalise",
      "name": "Lokalise",
      "description": "Manage translation projects, keys and tasks in Lokalise.",
      "url": "https://mcp.lokalise.com/mcp/project-management",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Lokalise",
      "tags": ["developer-tools", "productivity"],
      "priority": "P1",
      "logo": "lokalise.png",
      "sourceUrl": "https://docs.lokalise.com/en/articles/13547066-setting-up-and-using-the-lokalise-mcp-server",
      "publisherUrl": "https://lokalise.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Lifecycle & campaigns",
      "id": "luma",
      "name": "Luma",
      "description": "See your Luma events, guests and registrations.",
      "url": "https://mcp.luma.com",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Luma",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "luma.png",
      "sourceUrl": "https://help.luma.com/p/mcp",
      "publisherUrl": "https://lu.ma/"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "missive",
      "name": "Missive",
      "description": "Read and work with shared inbox conversations in Missive.",
      "url": "https://mcp.missiveapp.com",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Missive",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "missive.png",
      "sourceUrl": "https://missiveapp.com/docs/ai/mcp/server",
      "publisherUrl": "https://missiveapp.com/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "paddle",
      "name": "Paddle",
      "description": "Look up customers, subscriptions, transactions and revenue in Paddle.",
      "url": "https://mcp.paddle.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Paddle",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "paddle.png",
      "sourceUrl": "https://developer.paddle.com/changelog/2026/remote-paddle-mcp-server",
      "publisherUrl": "https://www.paddle.com/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "plain",
      "name": "Plain",
      "description": "Read and act on customer support threads in Plain.",
      "url": "https://mcp.plain.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Plain",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "plain.png",
      "sourceUrl": "https://www.plain.com/docs/agents/mcp-server",
      "publisherUrl": "https://www.plain.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "prisma",
      "name": "Prisma",
      "description": "Manage Prisma Postgres databases and run queries.",
      "url": "https://mcp.prisma.io/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Prisma",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "prisma.png",
      "sourceUrl": "https://www.prisma.io/docs/postgres/integrations/mcp-server",
      "publisherUrl": "https://www.prisma.io/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "productboard",
      "name": "Productboard",
      "description": "Search feature ideas, customer feedback and roadmaps in Productboard.",
      "url": "https://mcp.productboard.com",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Productboard",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "productboard.png",
      "sourceUrl": "https://productboard.com/integrations/mcp-server",
      "publisherUrl": "https://www.productboard.com/"
    },
    {
      "category": "Product",
      "subcategory": "Data & research",
      "id": "tableau",
      "name": "Tableau",
      "description": "Query Tableau Cloud data sources, views and dashboards.",
      "url": "https://mcp.tableau.com",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Tableau",
      "tags": ["data-analytics"],
      "priority": "P1",
      "logo": "tableau.png",
      "sourceUrl": "https://github.com/tableau/tableau-mcp",
      "publisherUrl": "https://www.tableau.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "turso",
      "name": "Turso",
      "description": "Manage Turso databases and run SQL.",
      "url": "https://mcp.turso.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Turso",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "turso.png",
      "sourceUrl": "https://docs.turso.tech/",
      "publisherUrl": "https://turso.tech/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "spendesk",
      "name": "Spendesk",
      "description": "Ask about company spend, cards and expenses in Spendesk.",
      "url": "https://public-api.spendesk.com/v1/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Spendesk",
      "tags": ["financial-services"],
      "priority": "P1",
      "logo": "spendesk.png",
      "sourceUrl": "https://helpcenter.spendesk.com/en/articles/15052814-ask-your-spendesk-data-with-ai-mcp-getting-started-guide",
      "publisherUrl": "https://www.spendesk.com/"
    },
    {
      "category": "Sales",
      "subcategory": "CRM",
      "id": "highlevel",
      "name": "HighLevel",
      "description": "Work with contacts, opportunities and conversations in HighLevel.",
      "url": "https://services.leadconnectorhq.com/mcp/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "HighLevel",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "highlevel.png",
      "sourceUrl": "https://marketplace.gohighlevel.com/docs/other/mcp",
      "publisherUrl": "https://www.gohighlevel.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social advertising",
      "id": "meta-ads",
      "name": "Meta Ads",
      "description": "Review and manage Facebook and Instagram ad campaigns, audiences and results.",
      "url": "https://mcp.facebook.com/ads",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Meta Ads",
      "tags": ["sales-and-marketing"],
      "priority": "P1",
      "logo": "meta-ads.png",
      "sourceUrl": "https://developers.facebook.com/documentation/ads-commerce/ads-ai-connectors/ads-mcp-server/ads-mcp-server-overview",
      "publisherUrl": "https://www.facebook.com/business/ads"
    },
    {
      "category": "Sales",
      "subcategory": "Communication & scheduling",
      "id": "whatsapp-business",
      "name": "WhatsApp Business",
      "description": "Manage WhatsApp Business message templates, phone numbers and messaging.",
      "url": "https://mcp.facebook.com/whatsapp_business_tools",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "WhatsApp Business",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "whatsapp-business.png",
      "sourceUrl": "https://developers.facebook.com/documentation/mcp/whatsapp-business-tools-mcp",
      "publisherUrl": "https://business.whatsapp.com/"
    },
    {
      "category": "Product",
      "subcategory": "Collaboration & meetings",
      "id": "roam",
      "name": "Roam",
      "description": "Read and send messages, meetings and transcripts in your Roam virtual office.",
      "url": "https://api.ro.am/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Roam",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "roam.png",
      "sourceUrl": "https://developer.ro.am/docs/integrations/mcp",
      "publisherUrl": "https://ro.am/"
    },
    {
      "category": "Product",
      "subcategory": "Project management",
      "id": "timely",
      "name": "Timely",
      "description": "Log and review time, projects and hours in Timely.",
      "url": "https://api.timelyapp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Timely",
      "tags": ["productivity"],
      "priority": "P1",
      "logo": "timely.png",
      "sourceUrl": "https://api.timelyapp.com/.well-known/oauth-protected-resource",
      "publisherUrl": "https://timelyapp.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "xata",
      "name": "Xata",
      "description": "Manage Xata Postgres databases and branches.",
      "url": "https://api.xata.tech/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Xata",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "xata.png",
      "sourceUrl": "https://registry.modelcontextprotocol.io/v0/servers?search=xata",
      "publisherUrl": "https://xata.io/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "baremetrics",
      "name": "Baremetrics",
      "description": "Subscription revenue, MRR, churn and customer metrics from Baremetrics.",
      "url": "https://app.baremetrics.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Baremetrics",
      "tags": ["financial-services", "data-analytics"],
      "priority": "P1",
      "logo": "baremetrics.png",
      "sourceUrl": "https://help.baremetrics.com/en/articles/15427470-connecting-baremetrics-to-ai-tools-via-mcp-claude-cursor-codex",
      "publisherUrl": "https://baremetrics.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "higgsfield",
      "name": "Higgsfield",
      "description": "Generate AI images and videos with Higgsfield.",
      "url": "https://mcp.higgsfield.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Higgsfield",
      "tags": ["creative"],
      "priority": "P1",
      "logo": "higgsfield.png",
      "sourceUrl": "https://higgsfield.ai/creator-hub/help-center/mcp-cli/what-is-higgsfield-mcp",
      "publisherUrl": "https://higgsfield.ai/"
    },
    {
      "category": "Finance",
      "subcategory": "Finance & accounting",
      "id": "polar",
      "name": "Polar",
      "description": "Look up products, customers, orders and subscriptions in Polar.",
      "url": "https://mcp.polar.sh/mcp/polar-mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Polar",
      "tags": ["financial-services", "developer-tools"],
      "priority": "P1",
      "logo": "polar.png",
      "sourceUrl": "https://polar.sh/docs/integrate/mcp",
      "publisherUrl": "https://polar.sh/"
    },
    {
      "category": "Marketing",
      "subcategory": "Social listening & intelligence",
      "id": "xpoz",
      "name": "Xpoz",
      "description": "Search posts, profiles and conversations across social media.",
      "url": "https://mcp.xpoz.ai/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Xpoz",
      "tags": ["sales-and-marketing", "data-analytics"],
      "priority": "P1",
      "logo": "xpoz.png",
      "sourceUrl": "https://docs.xpoz.ai/mcp/installation",
      "publisherUrl": "https://www.xpoz.ai/"
    },
    {
      "category": "Product",
      "subcategory": "Customer feedback & support",
      "id": "kustomer",
      "name": "Kustomer",
      "description": "Read and work with customer conversations in Kustomer.",
      "url": "https://server.mcp.kustomerapp.com/mcp",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Kustomer",
      "tags": ["communication"],
      "priority": "P1",
      "logo": "kustomer.png",
      "sourceUrl": "https://help.kustomer.com/en_us/kustomer-mcp-server-HJsPzR56ee.md",
      "publisherUrl": "https://www.kustomer.com/"
    },
    {
      "category": "Marketing",
      "subcategory": "Content & creative",
      "id": "alai",
      "name": "Alai",
      "description": "Create presentations and slides with Alai.",
      "url": "https://slides-api.getalai.com/mcp/",
      "auth": "oauth",
      "oneClick": true,
      "publisher": "Alai",
      "tags": ["creative", "productivity"],
      "priority": "P1",
      "logo": "alai.png",
      "sourceUrl": "https://docs.getalai.com/api/mcp.md",
      "publisherUrl": "https://getalai.com/"
    },
    {
      "category": "Product",
      "subcategory": "Developer tools",
      "id": "deepwiki",
      "name": "DeepWiki",
      "description": "Ask questions about public GitHub repositories and read their generated docs.",
      "url": "https://mcp.deepwiki.com/mcp",
      "auth": "none",
      "oneClick": true,
      "publisher": "DeepWiki",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "deepwiki.svg",
      "sourceUrl": "https://docs.devin.ai/work-with-devin/deepwiki-mcp",
      "publisherUrl": "https://deepwiki.com/"
    },
    {
      "category": "Product",
      "subcategory": "Infrastructure & observability",
      "id": "aws-knowledge",
      "name": "AWS Knowledge",
      "description": "Search AWS documentation, guidance and regional availability.",
      "url": "https://knowledge-mcp.global.api.aws",
      "auth": "none",
      "oneClick": true,
      "publisher": "AWS Knowledge",
      "tags": ["developer-tools"],
      "priority": "P1",
      "logo": "aws-knowledge.png",
      "sourceUrl": "https://awslabs.github.io/mcp/servers/aws-knowledge-mcp-server",
      "publisherUrl": "https://aws.amazon.com/"
    }
  ]
}
